import React from 'react';
import PropTypes from 'prop-types';

var Icon90daysM = function Icon90daysM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M7.5 0a1 1 0 011 1v1h7V1a1 1 0 011-1h3a1 1 0 011 1v1H23a1 1 0 011 1v20a1 1 0 01-1 1H1a1 1 0 01-1-1V3a1 1 0 011-1h2.5V1a1 1 0 011-1h3zM22 9H2v13h20V9zM8.332 11c1.736 0 3.122 1.246 3.29 3.192.224 2.828-.266 6.412-3.71 6.3-1.092-.042-2.156-.378-2.828-1.778l1.834-.784c.252.532.644.728 1.064.728 1.344 0 1.722-1.414 1.68-2.646-.112.322-.476 1.036-1.848 1.036-1.302 0-2.814-.98-2.814-3.094C5 12.19 6.33 11 8.332 11zm7.372 0c2.674 0 3.402 2.114 3.402 4.76 0 2.618-.728 4.732-3.402 4.732-2.674 0-3.43-2.114-3.43-4.732 0-2.646.756-4.76 3.43-4.76zm0 1.904c-1.12 0-1.47 1.302-1.47 2.856 0 1.54.35 2.828 1.47 2.828 1.106 0 1.442-1.288 1.442-2.828 0-1.554-.336-2.856-1.442-2.856zm-7.47-.042c-.658 0-1.204.546-1.204 1.204 0 .658.546 1.204 1.204 1.204.658 0 1.204-.546 1.204-1.204 0-.658-.546-1.204-1.204-1.204zM3.5 4H2v3h20V4h-1.5v1a1 1 0 01-1 1h-3a1 1 0 01-1-1V4h-7v1a1 1 0 01-1 1h-3a1 1 0 01-1-1V4zm3-2h-1v2h1V2zm12 0h-1v2h1V2z",
    className: "primary"
  }));
};

Icon90daysM.displayName = 'Icon90daysM';
Icon90daysM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
Icon90daysM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconAddL = function IconAddL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M25 13v10h10v2H25v10h-2V25H13v-2h10V13h2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 47C11.297 47 1 36.703 1 24S11.297 1 24 1s23 10.297 23 23-10.297 23-23 23zm0-2c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z",
    className: "secondary"
  })));
};

IconAddL.displayName = 'IconAddL';
IconAddL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconAddL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconAddM = function IconAddM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M13 4v7h7v2h-7v7h-2v-7H4v-2h7V4h2z",
    className: "primary"
  }));
};

IconAddM.displayName = 'IconAddM';
IconAddM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconAddM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconAddNodeL = function IconAddNodeL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M47 17h-2v-2H3v14h21v2H1V13h46v4z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M13 21v2H7v-2zM23 21v2h-6v-2zM37 20c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 2a8 8 0 100 16 8 8 0 000-16zm1 4v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2z",
    className: "primary"
  })));
};

IconAddNodeL.displayName = 'IconAddNodeL';
IconAddNodeL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconAddNodeL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconAddS = function IconAddS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M13 7H9V3c0-.6-.4-1-1-1s-1 .4-1 1v4H3c-.6 0-1 .4-1 1s.4 1 1 1h4v4c0 .6.4 1 1 1s1-.4 1-1V9h4c.6 0 1-.4 1-1s-.4-1-1-1z",
    className: "primary"
  }));
};

IconAddS.displayName = 'IconAddS';
IconAddS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconAddS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconAlertM = function IconAlertM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12 .853L23.656 23H.344L12 .853zm0 4.294L3.656 21h16.688L12 5.147zM12 17a1 1 0 110 2 1 1 0 010-2zm1-7v6h-2v-6h2z",
    className: "primary"
  }));
};

IconAlertM.displayName = 'IconAlertM';
IconAlertM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconAlertM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconAlertS = function IconAlertS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M7 0l2 .04L16 13v3H0v-3L7 0zm2 12H7v2h2v-2zm0-8H7v6h2V4z",
    className: "primary"
  }));
};

IconAlertS.displayName = 'IconAlertS';
IconAlertS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconAlertS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconAlertXL = function IconAlertXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M5.674 57h52.652L32 8.11 5.674 57zm-2.554.526l28-52a1 1 0 011.76 0l28 52A1 1 0 0160 59H4a1 1 0 01-.88-1.474z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32 46a2 2 0 110 4 2 2 0 010-4zm1-20v15h-2V26h2z",
    className: "primary"
  })));
};

IconAlertXL.displayName = 'IconAlertXL';
IconAlertXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconAlertXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconArrowBackM = function IconArrowBackM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M10.512 4.077l1.317 1.505L5.637 11H21v2H6.027l5.802 5.077-1.317 1.505-8-7a1 1 0 010-1.505l8-7z",
    className: "primary"
  }));
};

IconArrowBackM.displayName = 'IconArrowBackM';
IconArrowBackM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconArrowBackM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconArrowBackS = function IconArrowBackS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M6.7 1.3l1.4 1.4L3.8 7H16v2H3.8l4.3 4.3-1.4 1.4L0 8z",
    className: "primary"
  }));
};

IconArrowBackS.displayName = 'IconArrowBackS';
IconArrowBackS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconArrowBackS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconArrowDownS = function IconArrowDownS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M14.7 9.3l-1.4-1.4L9 12.2V0H7v12.2L2.7 7.9 1.3 9.3 8 16z",
    className: "primary"
  }));
};

IconArrowDownS.displayName = 'IconArrowDownS';
IconArrowDownS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconArrowDownS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconArrowForwardM = function IconArrowForwardM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M13.488 4.077l8 7a1 1 0 010 1.505l-8 7-1.317-1.505L17.972 13H3v-2h15.362l-6.191-5.418 1.317-1.505z",
    className: "primary"
  }));
};

IconArrowForwardM.displayName = 'IconArrowForwardM';
IconArrowForwardM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconArrowForwardM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconArrowForwardS = function IconArrowForwardS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M9.3 1.3L7.9 2.7 12.2 7H0v2h12.2l-4.3 4.3 1.4 1.4L16 8z",
    className: "primary"
  }));
};

IconArrowForwardS.displayName = 'IconArrowForwardS';
IconArrowForwardS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconArrowForwardS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconArrowUpS = function IconArrowUpS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M14.7 6.7l-1.4 1.4L9 3.8V16H7V3.8L2.7 8.1 1.3 6.7 8 0z",
    className: "primary"
  }));
};

IconArrowUpS.displayName = 'IconArrowUpS';
IconArrowUpS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconArrowUpS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconBackupL = function IconBackupL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 1c10.351 0 18.773 2.761 18.995 6.834L43 8v32c0 4.15-8.55 7-19 7S5 44.15 5 40V8c0-4.164 8.51-7 19-7zm0 14c-7.439 0-13.88-1.426-17-3.74V40c0 2.45 7.65 5 17 5s17-2.55 17-5V11.26C37.883 13.573 31.44 15 24 15zm0-12C14.609 3 7 5.536 7 8s7.609 5 17 5 17-2.536 17-5-7.609-5-17-5z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M41 24h2c0 4.15-8.55 7-19 7S5 28.15 5 24h2c0 2.45 7.65 5 17 5s17-2.55 17-5z",
    className: "primary"
  })));
};

IconBackupL.displayName = 'IconBackupL';
IconBackupL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconBackupL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconBoxL = function IconBoxL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M7.473 19.106l12 6a1 1 0 01.552.894v10a1 1 0 01-1.447.894l-12-6A1 1 0 016.025 30V20a1 1 0 011.448-.894zm.552 2.512v7.764l10 5v-7.764l-10-5zM14.83 4.286l22.202 10.556-.859 1.807L13.971 6.093l.859-1.807z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M25.41 20.077a1 1 0 01.615.923v26a1 1 0 01-1.384.923l-24-10A1 1 0 01.025 37V11a1 1 0 011.385-.923l24 10zm-1.385 1.59l-22-9.167v23.833l22 9.167V21.667z",
    className: "secondary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M26.025 45.447l20-9.09V12.552l-20 9.09v23.804zM24.612 20.09l22-10a1 1 0 011.413.91v26a1 1 0 01-.586.91l-22 10a1 1 0 01-1.414-.91V21a1 1 0 01.587-.91z",
    className: "secondary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24.025 2.09l-22.6 9.827-.798-1.834 23-10a1 1 0 01.797 0l23 10-.797 1.834L24.025 2.09z",
    className: "secondary"
  })));
};

IconBoxL.displayName = 'IconBoxL';
IconBoxL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconBoxL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconCalendarL = function IconCalendarL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M9 4v2H2v8h44V6h-7V4h8a1 1 0 011 1v42a1 1 0 01-1 1H1a1 1 0 01-1-1V5a1 1 0 011-1h8zm37 12H2v30h44V16zM28.318 26.769l1.364 1.462-7.5 7a1 1 0 01-1.39-.024l-2.5-2.5 1.415-1.414 1.817 1.817 6.794-6.341zM33 4v2H15V4h18z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M24 18.5c6.903 0 12.5 5.596 12.5 12.5S30.903 43.5 24 43.5c-6.905 0-12.5-5.595-12.5-12.5S17.095 18.5 24 18.5zm0 2c-5.8 0-10.5 4.7-10.5 10.5S18.2 41.5 24 41.5c5.798 0 10.5-4.701 10.5-10.5S29.798 20.5 24 20.5zM15 0a1 1 0 011 1v8a1 1 0 01-1 1H9a1 1 0 01-1-1V1a1 1 0 011-1h6zm24 0a1 1 0 011 1v8a1 1 0 01-1 1h-6a1 1 0 01-1-1V1a1 1 0 011-1h6zM14 2h-4v6h4V2zm24 0h-4v6h4V2z",
    className: "primary"
  })));
};

IconCalendarL.displayName = 'IconCalendarL';
IconCalendarL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCalendarL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconCalendarM = function IconCalendarM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M7 1v1h4V1h2v1h4V1h2v1h4a1 1 0 011 1v20a1 1 0 01-1 1H1a1 1 0 01-1-1V3a1 1 0 011-1h4V1h2zm15 9H2v12h20V10zM7 17a1 1 0 011 1v1a1 1 0 01-.883.993L7 20H5a1 1 0 01-1-1v-1a1 1 0 011-1h2zm6 0a1 1 0 011 1v1a1 1 0 01-.883.993L13 20h-2a1 1 0 01-1-1v-1a1 1 0 011-1h2zm-7 1l-.5.5.5.5.5-.5L6 18zm6 0l-.5.5.5.5.5-.5-.5-.5zm-5-6a1 1 0 011 1v1a1 1 0 01-.883.993L7 15H5a1 1 0 01-1-1v-1a1 1 0 011-1h2zm6 0a1 1 0 011 1v1a1 1 0 01-.883.993L13 15h-2a1 1 0 01-1-1v-1a1 1 0 011-1h2zm6 0a1 1 0 011 1v1a1 1 0 01-.883.993L19 15h-2a1 1 0 01-1-1v-1a1 1 0 011-1h2zM6 13l-.5.5.5.5.5-.5L6 13zm6 0l-.5.5.5.5.5-.5-.5-.5zm6 0l-.5.5.5.5.5-.5-.5-.5zM5 4H2v4h20V4h-3v1h-2V4h-4v1h-2V4H7v1H5V4z",
    className: "primary"
  }));
};

IconCalendarM.displayName = 'IconCalendarM';
IconCalendarM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCalendarM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconCalendarXL = function IconCalendarXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M15 7v2H3v12h58V9H49V7h14v56H1V7h14zm46 16H3v38h58V23zM45 7v2H19V7h26z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M21 1v14h-8V1h8zm30 0v14h-8V1h8zM19 3h-4v10h4V3zm30 0h-4v10h4V3z",
    className: "primary"
  })));
};

IconCalendarXL.displayName = 'IconCalendarXL';
IconCalendarXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCalendarXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconCallM = function IconCallM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M6.466 1.066L2.437 2.132A1.919 1.919 0 001 4.045a20.415 20.415 0 005.774 13.163 20.414 20.414 0 0013.157 5.79 1.92 1.92 0 001.94-1.436l1.065-4.03a1.917 1.917 0 00-1.096-2.252l-5.13-2.2-.155-.058a1.917 1.917 0 00-1.949.453l-1.573 1.552-.233-.155c-.72-.5-1.4-1.057-2.03-1.667l-.35-.375a16.55 16.55 0 01-1.292-1.633l-.156-.232 1.55-1.572a1.918 1.918 0 00.397-2.1l-2.2-5.13a1.918 1.918 0 00-2.253-1.097zm.443 1.951l2.15 5.011-2.617 2.656.402.665a18.607 18.607 0 002.51 3.27 18.421 18.421 0 003.297 2.537l.665.402 2.653-2.619 5.015 2.151-1.032 3.906.068.005a18.388 18.388 0 01-11.831-5.207l-.296-.31A18.389 18.389 0 013.027 4.39l-.023-.341 3.905-1.033z",
    className: "primary"
  }));
};

IconCallM.displayName = 'IconCallM';
IconCallM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCallM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconCallS = function IconCallS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M15.086 10.4l-3.137-1.392a1.542 1.542 0 00-1.824.442l-.947 1.185a12.427 12.427 0 01-3.813-3.812l1.184-.946a1.541 1.541 0 00.444-1.826L5.6.914A1.539 1.539 0 003.807.049L1.155.738a1.545 1.545 0 00-1.14 1.706 15.976 15.976 0 0013.542 13.541 1.544 1.544 0 001.705-1.139l.688-2.653a1.533 1.533 0 00-.864-1.793z",
    className: "primary"
  }));
};

IconCallS.displayName = 'IconCallS';
IconCallS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCallS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconCancelL = function IconCancelL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32 14.586L33.414 16l-8 8 8 8L32 33.414l-8-8-8 8L14.586 32l8-8-8-8L16 14.586l8 8 8-8z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 47C11.297 47 1 36.703 1 24S11.297 1 24 1s23 10.297 23 23-10.297 23-23 23zm0-2c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z",
    className: "secondary"
  })));
};

IconCancelL.displayName = 'IconCancelL';
IconCancelL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCancelL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconCephL = function IconCephL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M24.085 11.27c.646 0 1.294.045 1.924.136 1.864.265 3.691.93 5.286 1.925a13.804 13.804 0 013.916 3.687 13.769 13.769 0 012.226 5.08 13.82 13.82 0 01-.076 5.989 13.684 13.684 0 01-2.34 4.998c-.297.397-.627.76-.977 1.143l-.353.39-.005.004c-.02.019-.04.037-.056.06-1.233 1.476-1.833 2.955-1.833 4.521 0 2.399 1.332 4.6 3.43 5.727a22.885 22.885 0 01-5.15 2.084c-.267-.168-1.177-.845-2.064-2.074a9.39 9.39 0 01-1.8-5.732c.033-1.57.348-3.099.937-4.542a12.908 12.908 0 012.496-3.897l.006-.008.237-.274c.403-.468.82-.952 1.153-1.518.41-.695.71-1.427.887-2.175a8.183 8.183 0 00.045-3.544 8.108 8.108 0 00-1.315-2.998 8.174 8.174 0 00-2.318-2.183 8.072 8.072 0 00-4.26-1.217h-.164a8.043 8.043 0 00-4.259 1.217 8.173 8.173 0 00-2.318 2.183 8.142 8.142 0 00-1.315 2.998 8.163 8.163 0 00.046 3.544c.177.748.475 1.48.885 2.175.334.566.751 1.05 1.155 1.518.08.09.157.182.237.274l.005.008a12.877 12.877 0 012.496 3.897c.59 1.443.905 2.972.937 4.542a9.392 9.392 0 01-1.799 5.732c-.889 1.23-1.798 1.906-2.065 2.074a22.86 22.86 0 01-5.148-2.083 6.518 6.518 0 003.428-5.728c0-1.587-.617-3.11-1.834-4.523l-.026-.03-.034-.033c-.12-.133-.237-.263-.354-.39-.35-.383-.68-.745-.976-1.142a13.686 13.686 0 01-2.34-4.998 13.776 13.776 0 01-.075-5.988 13.731 13.731 0 012.226-5.081 13.8 13.8 0 013.915-3.687 13.72 13.72 0 015.286-1.925c.63-.091 1.277-.135 1.923-.135h.172zM24.077 2a22.849 22.849 0 0116.209 6.714 22.865 22.865 0 014.912 7.284A22.793 22.793 0 0147 24.922a22.803 22.803 0 01-2.316 10.049c-1.38 2.827-3.616 5.645-6.15 7.754-1.635-.87-2.57-1.851-2.777-2.916-.199-1.032.261-2.179 1.408-3.508a17.31 17.31 0 004.252-11.38c0-9.56-7.778-17.34-17.34-17.34l-.06.001H24h-.078c-9.562 0-17.34 7.78-17.34 17.34 0 4.192 1.51 8.233 4.253 11.38 1.156 1.338 1.605 2.439 1.413 3.46-.2 1.065-1.136 2.06-2.786 2.962-2.53-2.11-4.768-4.927-6.148-7.753A22.87 22.87 0 011 24.92 22.847 22.847 0 017.714 8.714a22.83 22.83 0 017.285-4.911A22.782 22.782 0 0123.922 2h.155zm-.078 18.614a4.53 4.53 0 014.524 4.526A4.53 4.53 0 0124 29.666a4.531 4.531 0 01-4.526-4.526A4.531 4.531 0 0124 20.614z",
    className: "primary"
  }));
};

IconCephL.displayName = 'IconCephL';
IconCephL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCephL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconCephM = function IconCephM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12.087 4.849a7.097 7.097 0 013.73 1.066 7.142 7.142 0 012.026 1.907 7.124 7.124 0 011.152 2.629 7.15 7.15 0 01-.04 3.098 7.08 7.08 0 01-1.21 2.586 7.792 7.792 0 01-.506.591l-.182.202c-.003.001-.004.003-.006.005-.007.007-.018.016-.026.028-.638.764-.949 1.53-.949 2.34 0 1.24.69 2.38 1.775 2.963a11.84 11.84 0 01-2.665 1.077c-.137-.086-.608-.437-1.067-1.072a4.858 4.858 0 01-.931-2.966c.016-.812.18-1.603.485-2.35a6.678 6.678 0 011.29-2.016l.004-.005.122-.141c.21-.242.425-.493.597-.785.213-.36.367-.739.459-1.126.141-.597.15-1.232.023-1.833a4.195 4.195 0 00-1.88-2.681 4.177 4.177 0 00-2.203-.63H12a4.162 4.162 0 00-2.204.63c-.466.29-.882.681-1.2 1.13a4.213 4.213 0 00-.68 1.55 4.224 4.224 0 00.024 1.834c.092.387.246.766.458 1.126.173.292.389.543.598.785.04.047.08.094.122.141l.003.005a6.662 6.662 0 011.291 2.016c.305.747.469 1.538.485 2.35a4.86 4.86 0 01-.93 2.966c-.46.635-.931.986-1.069 1.072a11.626 11.626 0 01-2.663-1.077A3.372 3.372 0 008.008 19.3c0-.82-.32-1.609-.949-2.34l-.014-.015-.017-.017a22.604 22.604 0 00-.183-.202c-.18-.198-.352-.386-.505-.591a7.08 7.08 0 01-1.21-2.586 7.127 7.127 0 01-.04-3.098 7.104 7.104 0 011.152-2.629 7.14 7.14 0 012.026-1.907 7.099 7.099 0 012.735-.997c.326-.047.66-.07.995-.07h.089zM12.082.052a11.822 11.822 0 018.386 3.473 11.83 11.83 0 013.474 8.386 11.798 11.798 0 01-1.198 5.2c-.714 1.462-1.87 2.92-3.181 4.012-.847-.45-1.33-.958-1.437-1.51-.104-.533.135-1.127.728-1.814a8.956 8.956 0 002.2-5.888c0-4.946-4.025-8.971-8.972-8.971h-.08c-4.947 0-8.971 4.025-8.971 8.971 0 2.17.781 4.26 2.2 5.888.598.693.83 1.262.731 1.79-.103.551-.587 1.066-1.441 1.533-1.31-1.091-2.467-2.55-3.181-4.011a11.833 11.833 0 01-1.197-5.2 11.82 11.82 0 013.474-8.386A11.811 11.811 0 0112.001.053h.08zm-.04 9.63c1.29 0 2.34 1.05 2.34 2.342a2.344 2.344 0 01-2.34 2.342 2.344 2.344 0 01-2.341-2.342 2.344 2.344 0 012.341-2.342z",
    className: "primary"
  }));
};

IconCephM.displayName = 'IconCephM';
IconCephM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCephM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconCephXL = function IconCephXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M46.242 44.514c-1.37 1.534-2.659 3.092-3.192 5.106-.941 3.56.537 7.365 3.659 9.475l.679.463a30.263 30.263 0 01-6.648 2.641c-.167.045-.427-.034-.57-.146-2.79-2.201-4.52-5.025-4.887-8.519-.552-5.248 1.325-9.705 4.92-13.542 1.634-1.745 2.802-3.718 3.1-6.11.591-4.744-1.146-8.518-5.25-11.039-6.654-4.087-15.71-.642-17.345 7.303-.77 3.735.35 7.021 2.996 9.807 2.262 2.38 3.886 5.097 4.625 8.287 1.143 4.936.12 9.293-3.54 12.99-.818.827-1.59 1.173-2.757.657-1.78-.786-3.618-1.445-5.566-2.21.685-.525 1.208-.87 1.665-1.285 3.909-3.541 4.112-8.905.418-12.901-1.891-2.047-3.505-4.23-4.486-6.836-4.047-10.752 2.813-22.534 14.324-24.586 10.24-1.825 19.81 4.184 22.15 14.085 1.445 6.112-.062 11.622-4.295 16.36M31.974 1c-1.813.183-3.638.29-5.437.564-5.171.786-9.879 2.737-13.974 5.903C3.687 14.33-.538 23.312.055 34.403c.195 3.652 1.116 7.134 2.626 10.47 1.961 4.329 4.879 7.966 8.471 11.11.26.226.527.52.908.212.899-.724 1.88-1.377 2.655-2.213.944-1.017 1.042-2.316.464-3.544a11.372 11.372 0 00-1.608-2.482C8.132 41.56 6.23 34.297 8.364 26.25 11.738 13.53 24.898 5.995 38.072 9.243c11.652 2.874 19.421 13.754 18.19 25.35-.433 4.075-1.799 7.795-4.178 11.154-.747 1.054-1.677 1.987-2.383 3.063-.52.791-.985 1.691-1.17 2.602-.375 1.824.779 3.01 2.14 4.023 1.5 1.116 1.52 1.13 2.868-.131 8.503-7.967 12-17.652 9.836-28.99C60.544 11.475 47.095.975 31.974 1m.064 25.274c3.374.038 6.038 2.802 6.054 6.164.016 3.25-2.907 6.1-6.436 5.986-3.261-.104-5.975-2.833-5.939-6.12.038-3.41 2.826-6.07 6.321-6.03",
    className: "primary"
  }));
};

IconCephXL.displayName = 'IconCephXL';
IconCephXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCephXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconChatM = function IconChatM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    stroke: primary || '#28A730',
    strokeWidth: "2",
    d: "M23 6v13h-4v4l-6-4h-1"
  }), React.createElement("path", {
    stroke: primary || '#28A730',
    strokeWidth: "2",
    d: "M19 2H1v13h4v5l7-5h7z"
  })));
};

IconChatM.displayName = 'IconChatM';
IconChatM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconChatM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconChatS = function IconChatS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M14.853 6.861C15.571 7.603 16 8.513 16 9.5c0 .925-.373 1.785-1.012 2.5H15v4l-3.693-2.11c-.421.07-.858.11-1.307.11-1.444 0-2.769-.383-3.805-1.021.103.003.202.021.305.021 4.16 0 7.624-2.652 8.353-6.139zM6.5 0C10.09 0 13 2.462 13 5.5S10.09 11 6.5 11a7.454 7.454 0 01-2.801-.542L1 12V8.422C.37 7.574 0 6.575 0 5.5 0 2.462 2.91 0 6.5 0z",
    className: "primary"
  }));
};

IconChatS.displayName = 'IconChatS';
IconChatS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconChatS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconChatXL = function IconChatXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M38.35 24l-9.725 7.78A1 1 0 0127 31V3a1 1 0 011-1h34a1 1 0 011 1v20a1 1 0 01-1 1H38.35zM61 4H29v24.92l8.375-6.7A1 1 0 0138 22h23V4z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M50 48c4.198 0 7.724 1.058 10.542 2.725A5 5 0 0163 55.035V61a1 1 0 01-1 1H38a1 1 0 01-1-1v-5.987c0-1.765.922-3.392 2.435-4.297C42.223 49.052 45.748 48 50 48zm0 2c-3.875 0-7.05.948-9.54 2.433a2.996 2.996 0 00-1.46 2.58V60h22v-4.965a3 3 0 00-1.476-2.588C57 50.954 53.822 50 50 50zm0-20a7 7 0 110 14 7 7 0 010-14zm0 2a5 5 0 100 10 5 5 0 000-10z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M14 48c4.198 0 7.724 1.058 10.542 2.725A5 5 0 0127 55.035V61a1 1 0 01-1 1H2a1 1 0 01-1-1v-5.987c0-1.765.922-3.392 2.435-4.297C6.223 49.052 9.748 48 14 48zm0 2c-3.875 0-7.05.948-9.54 2.433A2.996 2.996 0 003 55.013V60h22v-4.965a3 3 0 00-1.476-2.588C21 50.954 17.822 50 14 50zm0-20a7 7 0 110 14 7 7 0 010-14zm0 2a5 5 0 100 10 5 5 0 000-10z",
    className: "primary"
  })));
};

IconChatXL.displayName = 'IconChatXL';
IconChatXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconChatXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconChevronDownS = function IconChevronDownS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12.91 5L8 9.793 3.09 5 2 6.141 8 12l6-5.859z",
    className: "primary"
  }));
};

IconChevronDownS.displayName = 'IconChevronDownS';
IconChevronDownS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconChevronDownS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconChevronLeftL = function IconChevronLeftL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M34.707 43.293l-1.414 1.414-20-20a1 1 0 010-1.414l20-20 1.414 1.414L15.414 24l19.293 19.293z",
    className: "primary"
  }));
};

IconChevronLeftL.displayName = 'IconChevronLeftL';
IconChevronLeftL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconChevronLeftL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconChevronLeftS = function IconChevronLeftS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M10.48 13.775l1.2-1.05L6.64 8l5.04-4.725-1.2-1.05L4.32 8z",
    className: "primary"
  }));
};

IconChevronLeftS.displayName = 'IconChevronLeftS';
IconChevronLeftS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconChevronLeftS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconChevronRightS = function IconChevronRightS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M5.52 13.775l-1.2-1.05L9.36 8 4.32 3.275l1.2-1.05L11.68 8z",
    className: "primary"
  }));
};

IconChevronRightS.displayName = 'IconChevronRightS';
IconChevronRightS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconChevronRightS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconChevronUpS = function IconChevronUpS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12.725 11.2L8 6.475 3.275 11.2l-1.05-1.125L8 4.3l5.775 5.775z",
    className: "primary"
  }));
};

IconChevronUpS.displayName = 'IconChevronUpS';
IconChevronUpS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconChevronUpS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconCloseM = function IconCloseM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M17.716 5L19 6.284 13.284 12 19 17.716 17.716 19 12 13.284 6.284 19 5 17.716 10.715 12 5 6.284 6.284 5 12 10.715 17.716 5z",
    className: "primary"
  }));
};

IconCloseM.displayName = 'IconCloseM';
IconCloseM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCloseM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconCloseS = function IconCloseS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12.786 3.214a.69.69 0 00-1 0L8 7 4.214 3.214a.69.69 0 00-1 0 .69.69 0 000 1L7 8l-3.786 3.786a.69.69 0 000 1 .648.648 0 00.5.214.648.648 0 00.5-.214L8 9l3.786 3.786a.772.772 0 00.5.214.772.772 0 00.5-.214.69.69 0 000-1L9 8l3.786-3.786a.69.69 0 000-1z",
    className: "primary"
  }));
};

IconCloseS.displayName = 'IconCloseS';
IconCloseS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCloseS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconCloseupM = function IconCloseupM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M7 15h10l-5-6z",
    className: "primary"
  }));
};

IconCloseupM.displayName = 'IconCloseupM';
IconCloseupM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCloseupM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconCloseupS = function IconCloseupS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M4 11l4-5 4 5z",
    className: "primary"
  }));
};

IconCloseupS.displayName = 'IconCloseupS';
IconCloseupS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCloseupS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconCoffinXL = function IconCoffinXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M45.133 61l5.844-40.908L45.279 3H18.721l-5.698 17.092L18.867 61h26.266zM46 63H18a1 1 0 01-.99-.859l-6-42a1 1 0 01.041-.457l6-18A1 1 0 0118 1h28a1 1 0 01.949.684l6 18a1 1 0 01.04.457l-6 42A1 1 0 0146 63z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M31 21v1l1-1h-1zm0 0v-5c0-1.333 2-1.333 2 0v6a1 1 0 01-1 1h-6c-1.333 0-1.333-2 0-2h5zm0 0v1l1-1h-1zm2 2v-1l-1 1h1zm0 0v11c0 1.333-2 1.333-2 0V22a1 1 0 011-1h6c1.333 0 1.333 2 0 2h-5zm0 0v-1l-1 1h1z",
    className: "primary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M31 21h2v2h-2z",
    className: "primary"
  })));
};

IconCoffinXL.displayName = 'IconCoffinXL';
IconCoffinXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCoffinXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconCoinL = function IconCoinL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M45.004 23.489C45.004 11.622 35.384 2 23.514 2 11.65 2 2.027 11.623 2.027 23.489c0 11.868 9.622 21.489 21.489 21.489 11.87 0 21.489-9.62 21.489-21.49zm2 0c0 12.974-10.515 23.489-23.49 23.489-12.97 0-23.488-10.516-23.488-23.49C.026 10.519 10.545 0 23.515 0c12.973 0 23.489 10.517 23.489 23.489z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M24.489 10.2v2.144a6.113 6.113 0 015.137 6.034h-2a4.113 4.113 0 00-3.137-3.995v8.183a6.113 6.113 0 010 12.068v2.144h-2v-2.153a6.112 6.112 0 01-5.085-6.025h2a4.112 4.112 0 003.085 3.982v-8.179a6.112 6.112 0 010-12.05V10.2h2zm0 14.405v7.99a4.112 4.112 0 000-7.99zm-5.085-6.227a4.112 4.112 0 003.085 3.982v-7.964a4.114 4.114 0 00-3.085 3.982z",
    className: "primary"
  })));
};

IconCoinL.displayName = 'IconCoinL';
IconCoinL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCoinL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconCompanyM = function IconCompanyM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M24 8v16H0V11h11v11h2V8h11zM9 13H2v9h7v-9zm13-3h-7v12h7V10zm-2 8v2h-3v-2h3zM7 18v2H4v-2h3zm13-3v2h-3v-2h3zM7 15v2H4v-2h3zm13-3v2h-3v-2h3zM19 0v7h-2V2H7v8H5V0h14z",
    className: "primary"
  }));
};

IconCompanyM.displayName = 'IconCompanyM';
IconCompanyM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCompanyM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconConfirmM = function IconConfirmM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M10 14.586l-4-4L4.586 12 10 17.414 19.414 8 18 6.586z",
    className: "secondary"
  })));
};

IconConfirmM.displayName = 'IconConfirmM';
IconConfirmM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconConfirmM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconCreateS = function IconCreateS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm1 2v3h3v2H9v3H7V9H4V7h3V4h2z",
    className: "primary"
  }));
};

IconCreateS.displayName = 'IconCreateS';
IconCreateS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCreateS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconCrosshairXL = function IconCrosshairXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M32 59C17.088 59 5 46.912 5 32S17.088 5 32 5s27 12.088 27 27-12.088 27-27 27zm0-2c13.807 0 25-11.193 25-25S45.807 7 32 7 7 18.193 7 32s11.193 25 25 25z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M31 1h2v12h-2zM63 31v2H51v-2zM33 63h-2V51h2zM1 33v-2h12v2zM32 39a7 7 0 110-14 7 7 0 010 14zm0-2a5 5 0 100-10 5 5 0 000 10z",
    className: "primary"
  })));
};

IconCrosshairXL.displayName = 'IconCrosshairXL';
IconCrosshairXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCrosshairXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconCursorM = function IconCursorM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, React.createElement("path", {
    fill: "#FFF",
    d: "M6 6.398V8H4a2 2 0 00-2 2v3.895c0 1.362.464 2.684 1.315 3.748L6 21h14l1.504-12.031a4 4 0 00-3.473-4.465L9.372 3.422A3 3 0 006 6.398z"
  }), React.createElement("path", {
    d: "M6 8v4M12 10v6M16 10v6"
  })));
};

IconCursorM.displayName = 'IconCursorM';
IconCursorM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCursorM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconCustomCodeXL = function IconCustomCodeXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M62 5a1 1 0 011 1v52a1 1 0 01-1 1H2a1 1 0 01-1-1V6a1 1 0 011-1h60zM3 57h20V21H3v36zm58-36H25v36h36V21zm0-14H3v12h58V7z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M14 50v2H8v-2h6zm23 0v2h-5v-2h5zm-25-6v2H8v-2h4zm32 0v2h-8v-2h8zm-30-6v2h-4v-2h4zm40 0v2H40v-2h14zm-42-6v2H8v-2h4zm32 0v2h-8v-2h8zm-30-6v2H8v-2h6zm23 0v2h-5v-2h5zM12 12v2H8v-2h4z",
    className: "primary"
  })));
};

IconCustomCodeXL.displayName = 'IconCustomCodeXL';
IconCustomCodeXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconCustomCodeXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconDNAXL = function IconDNAXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M48 53v2H16v-2h32zm-2.2-10v2H18.2v-2h27.6zm0-24v2H18.2v-2h27.6zM48 9v2H16V9h32z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M17 1v11c0 4.158 1.591 7.64 4.724 10.933 2.352 2.47 4.736 4.241 10.276 7.872 5.54-3.631 7.924-5.401 10.276-7.872C45.409 19.639 47 16.158 47 12V1h2v11c0 4.71-1.809 8.668-5.276 12.311-2.384 2.506-4.738 4.287-9.9 7.688 5.162 3.403 7.516 5.184 9.9 7.69C47.191 43.332 49 47.29 49 52v11h-2V52c0-4.158-1.591-7.64-4.724-10.933-2.352-2.47-4.736-4.241-10.275-7.871-5.541 3.63-7.925 5.4-10.277 7.871C18.591 44.361 17 47.842 17 52v11h-2V52c0-4.71 1.809-8.668 5.276-12.311 2.384-2.506 4.738-4.287 9.9-7.688-5.162-3.403-7.516-5.184-9.9-7.69C16.809 20.668 15 16.71 15 12V1h2z",
    className: "secondary"
  })));
};

IconDNAXL.displayName = 'IconDNAXL';
IconDNAXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDNAXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconDeliveryL = function IconDeliveryL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M31 27h-2V8H3v26h4v2H1V6h30v7h11.72L47 25.838V36h-6.1v-2H45v-7.838L41.28 15H31v12zm.1 7v2H17.977v-2H31.1z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M12.5 29a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM36 30a6 6 0 110 12 6 6 0 010-12zm-23.5 1a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM36 32a4 4 0 100 8 4 4 0 000-8z",
    className: "primary"
  })));
};

IconDeliveryL.displayName = 'IconDeliveryL';
IconDeliveryL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDeliveryL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconDeliveryM = function IconDeliveryM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M9 1a1 1 0 011 1v3h8a1 1 0 01.97.757l.889 3.554 3.588 1.795A1 1 0 0124 12v6a1 1 0 01-1 1h-4a4 4 0 11-.535-2H22v-4.382l-3.447-1.724a1 1 0 01-.523-.651L17.22 7H10v11a1 1 0 01-1 1H1a1 1 0 01-1-1V2a1 1 0 011-1h8zm6 16a2 2 0 100 4 2 2 0 000-4zM8 3H2v14h6V3zm7 6v1h1v2h-2a1 1 0 01-1-1V9h2z",
    className: "primary"
  }));
};

IconDeliveryM.displayName = 'IconDeliveryM';
IconDeliveryM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDeliveryM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconDensityL = function IconDensityL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M16 32v8H8v-8h8zm12 0v8h-8v-8h8zm12 0v8h-8v-8h8zm-26 2h-4v4h4v-4zm12 0h-4v4h4v-4zm12 0h-4v4h4v-4zM16 20v8H8v-8h8zm12 0v8h-8v-8h8zm12 0v8h-8v-8h8zm-26 2h-4v4h4v-4zm12 0h-4v4h4v-4zm12 0h-4v4h4v-4zM16 8v8H8V8h8zm12 0v8h-8V8h8zm12 0v8h-8V8h8zm-26 2h-4v4h4v-4zm12 0h-4v4h4v-4zm12 0h-4v4h4v-4z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M3 3h42v42H3V3zm2 2v38h38V5H5z",
    className: "secondary"
  })));
};

IconDensityL.displayName = 'IconDensityL';
IconDensityL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDensityL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconDensityM = function IconDensityM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M1 1h22v22H1V1zm2 2v18h18V3H3z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M11 13v6H5v-6h6zm8 0v6h-6v-6h6zM9 15H7v2h2v-2zm8 0h-2v2h2v-2zM11 5v6H5V5h6zm8 0v6h-6V5h6zM9 7H7v2h2V7zm8 0h-2v2h2V7z",
    className: "primary"
  })));
};

IconDensityM.displayName = 'IconDensityM';
IconDensityM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDensityM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconDensityXL = function IconDensityXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M4 4h56v56H4V4zm2 2v52h52V6H6z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M21 43v10H11V43h10zm16 0v10H27V43h10zm16 0v10H43V43h10zm-34 2h-6v6h6v-6zm16 0h-6v6h6v-6zm16 0h-6v6h6v-6zM21 27v10H11V27h10zm16 0v10H27V27h10zm16 0v10H43V27h10zm-34 2h-6v6h6v-6zm16 0h-6v6h6v-6zm16 0h-6v6h6v-6zM21 11v10H11V11h10zm16 0v10H27V11h10zm16 0v10H43V11h10zm-34 2h-6v6h6v-6zm16 0h-6v6h6v-6zm16 0h-6v6h6v-6z",
    className: "primary"
  })));
};

IconDensityXL.displayName = 'IconDensityXL';
IconDensityXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDensityXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconDesignXL = function IconDesignXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M45.707 32.293l12 12a1 1 0 01.283.566l2 14a1 1 0 01-1.131 1.13l-14-2a1 1 0 01-.566-.282l-12-12 1.414-1.414L45 55.585l10.586-10.586-11.292-11.292 1.414-1.414zM56.293 47.12l-9.172 9.172 10.7 1.528-1.528-10.7zM15.707 2.293l16 16-1.414 1.414L22 11.414 11.414 22l8.293 8.293-1.414 1.414-16-16a1 1 0 010-1.414l12-12a1 1 0 011.414 0zM15 4.414L4.414 15 10 20.585 20.585 9.999 15 4.414z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M47.706 2.294l14 14a1 1 0 010 1.414l-43.999 44a1 1 0 01-1.414 0l-14-14a1 1 0 010-1.415l44-43.999a1 1 0 011.413 0zM47 4.415L38.415 13l5.292 5.293-1.414 1.414L37 14.414 32.415 19l3.292 3.293-1.414 1.414L31 20.414 26.415 25l5.292 5.293-1.414 1.414L25 26.414 20.415 31l3.292 3.293-1.414 1.414L19 32.414 14.415 37l5.292 5.293-1.414 1.414L13 38.414 4.414 47 17 59.586l42.585-42.585L46.999 4.415z",
    className: "primary"
  })));
};

IconDesignXL.displayName = 'IconDesignXL';
IconDesignXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDesignXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconDocumentL = function IconDocumentL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M30.414 1L43 13.586V47H5V1h25.414zM29 3H7v42h34V15H29V3zm10.586 10L31 4.415V13h8.586z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M35 35v2H13v-2h22zm0-10v2H13v-2h22zM23 15v2H13v-2h10z",
    className: "secondary"
  })));
};

IconDocumentL.displayName = 'IconDocumentL';
IconDocumentL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDocumentL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconDocumentM = function IconDocumentM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M15.414 0L22 6.586V24H2V0h13.414zM14 2H4v20h16V8h-6V2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M18 16v2H6v-2h12zm0-5v2H6v-2h12zm-6-5v2H6V6h6z",
    className: "secondary"
  })));
};

IconDocumentM.displayName = 'IconDocumentM';
IconDocumentM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDocumentM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconDocumentS = function IconDocumentS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M15 15V5l-5-5H2c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h12c.6 0 1-.4 1-1zM3 2h6v4h4v8H3V2z",
    className: "primary"
  }));
};

IconDocumentS.displayName = 'IconDocumentS';
IconDocumentS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDocumentS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconDownloadL = function IconDownloadL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 47C11.297 47 1 36.703 1 24S11.297 1 24 1s23 10.297 23 23-10.297 23-23 23zm0-2c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M34 33v2H14v-2h20zM25 9v17.585l7-7L33.414 21 24 30.414 14.586 21 16 19.586l7 6.999V9h2z",
    className: "primary"
  })));
};

IconDownloadL.displayName = 'IconDownloadL';
IconDownloadL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDownloadL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconDownloadM = function IconDownloadM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M22 21v2H2v-2h20zM13 1v13.585l4.293-4.292 1.414 1.414-6 6a1 1 0 01-1.414 0l-6-6 1.414-1.414L11 14.585V1h2z",
    className: "primary"
  }));
};

IconDownloadM.displayName = 'IconDownloadM';
IconDownloadM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDownloadM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconDropdownM = function IconDropdownM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M7 10h10l-5 6z",
    className: "primary"
  }));
};

IconDropdownM.displayName = 'IconDropdownM';
IconDropdownM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDropdownM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconDropdownS = function IconDropdownS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M4 6l4 5 4-5z",
    className: "primary"
  }));
};

IconDropdownS.displayName = 'IconDropdownS';
IconDropdownS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconDropdownS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconEcoLightbulbXL = function IconEcoLightbulbXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M55 24c0 8.512-4.675 16.184-12 20.181V52c0 6.075-4.925 11-11 11s-11-4.925-11-11v-7.818C12.564 39.58 7.759 30.22 9.282 20.347c1.555-10.072 9.921-18.065 20.073-19.199C43.12-.39 55 10.306 55 24zM29.577 3.136C20.322 4.17 12.676 11.474 11.26 20.652c-1.423 9.22 3.182 17.935 11.197 22.037a1 1 0 01.544.89V52a9 9 0 0018 0v-8.42a1 1 0 01.544-.891C48.52 39.119 53 31.962 53 24 53 11.495 42.154 1.73 29.577 3.136zM33 12v40h-2V12h2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M42 51v2H22v-2h20zM22 15c6.075 0 11 4.925 11 11v1.674A10.987 10.987 0 0142 23h2a1 1 0 011 1v4c0 6.075-4.925 11-11 11h-2a1 1 0 01-1-1v-4c0-1.04.144-2.046.414-3H30c-6.075 0-11-4.925-11-11v-4a1 1 0 011-1h2zm21 10h-1a9 9 0 00-9 9v3h1a9 9 0 009-9v-3zm-21-8h-1v3a9 9 0 009 9h1v-3a9 9 0 00-9-9z",
    className: "primary"
  })));
};

IconEcoLightbulbXL.displayName = 'IconEcoLightbulbXL';
IconEcoLightbulbXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconEcoLightbulbXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconEditL = function IconEditL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M27.293 11.707l9 9 1.414-1.414-9-9z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M14.318 45.136L0 48l2.864-14.318L36.546 0 48 11.454 14.318 45.136zm30.854-33.682l-8.626-8.626-31.84 31.84L2.55 45.45l10.782-2.156 31.84-31.84z",
    className: "primary"
  })));
};

IconEditL.displayName = 'IconEditL';
IconEditL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconEditL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconEditM = function IconEditM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M7.562 21.688L1 23l1.312-6.562L17.75 1 23 6.25 7.562 21.688zM20.257 6.25L17.75 3.743 4.1 17.393l-.627 3.135 3.134-.627L20.257 6.25z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M13.186 6.935l3.879 3.879 1.37-1.371-3.878-3.879z",
    className: "secondary"
  })));
};

IconEditM.displayName = 'IconEditM';
IconEditM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconEditM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconEditS = function IconEditS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M14.1.3c-.4-.4-1-.4-1.4 0L6 7v3h3l6.7-6.7c.4-.4.4-1 0-1.4L14.1.3z",
    className: "primary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M15 9c-.6 0-1 .4-1 1v4H2V2h4c.6 0 1-.4 1-1s-.4-1-1-1H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-5c0-.6-.4-1-1-1z",
    className: "primary"
  })));
};

IconEditS.displayName = 'IconEditS';
IconEditS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconEditS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconEditXL = function IconEditXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M35.804 15.194l12.982 12.86 1.577-1.568-12.981-12.862z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M19.09 60.182L0 64l3.818-19.09L48.728 0 64 15.272l-44.91 44.91zm42.082-44.91L48.728 2.828 5.66 45.896 2.55 61.45l15.554-3.11 43.068-43.068z",
    className: "primary"
  })));
};

IconEditXL.displayName = 'IconEditXL';
IconEditXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconEditXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconElevatorM = function IconElevatorM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M15 13l-3 4-3-4h6zm-3-6l3 4H9l3-4z",
    className: "primary"
  }));
};

IconElevatorM.displayName = 'IconElevatorM';
IconElevatorM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconElevatorM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconEmailL = function IconEmailL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M46 5a1 1 0 011 1v36a1 1 0 01-1 1H2a1 1 0 01-1-1V6a1 1 0 011-1h44zm-1 2H3v34h42V7z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M45.327 6.26a1 1 0 011.346 1.48l-22 20a1 1 0 01-1.346 0l-22-20a1 1 0 111.346-1.48L24 25.65 45.327 6.26z",
    className: "primary"
  })));
};

IconEmailL.displayName = 'IconEmailL';
IconEmailL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconEmailL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconEmoticonHappyXL = function IconEmoticonHappyXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M17 35v1c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15v-1h2v1c0 9.389-7.611 17-17 17s-17-7.611-17-17v-1h2zm3-12a5 5 0 015 5v1h-2v-1a3 3 0 00-6 0v1h-2v-1a5 5 0 015-5zm24 0a5 5 0 015 5v1h-2v-1a3 3 0 00-6 0v1h-2v-1a5 5 0 015-5z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M32 61C15.984 61 3 48.016 3 32S15.984 3 32 3s29 12.984 29 29-12.984 29-29 29zm0-2c14.912 0 27-12.088 27-27S46.912 5 32 5 5 17.088 5 32s12.088 27 27 27z",
    className: "secondary"
  })));
};

IconEmoticonHappyXL.displayName = 'IconEmoticonHappyXL';
IconEmoticonHappyXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconEmoticonHappyXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconEmploymentM = function IconEmploymentM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M3 17v5h18v-5h2v7H1v-7h2zM17 0v4h7v12h-8v2H8v-2H0V4h7V0h10zm-7 14v2h4v-2h-4zm12-8H2v8h6v-2h8v2h6V6zm-7-4H9v2h6V2z",
    className: "primary"
  }));
};

IconEmploymentM.displayName = 'IconEmploymentM';
IconEmploymentM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconEmploymentM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconEngineeringXL = function IconEngineeringXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M42.327 30.913L56.96 45.546a9.485 9.485 0 010 13.414 9.485 9.485 0 01-13.414 0L29.543 44.957l1.414-1.414L44.96 57.546a7.485 7.485 0 0010.586 0 7.485 7.485 0 000-10.586L40.913 32.327l1.414-1.414zm-.62 11.38l8 8-1.414 1.414-8-8 1.414-1.414zM12.454 4.555l8.485 8.485a1 1 0 01.293.702l.02 4.095 7.626 7.627-1.414 1.414-7.918-7.918a1 1 0 01-.293-.702l-.02-4.095-7.486-7.487-7.07 7.071 7.486 7.487 4.095.019a1 1 0 01.702.293l7.742 7.742-1.414 1.414-7.451-7.45-4.095-.02a1 1 0 01-.702-.293l-8.485-8.485a1 1 0 010-1.414l8.485-8.485a1 1 0 011.414 0z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M53 15.586l6.225-6.225a1 1 0 011.618.295A12.945 12.945 0 0162 15c0 7.18-5.82 13-13 13-.83 0-1.658-.086-2.491-.251L15.74 61.672a1 1 0 01-1.448.035l-12-12a1 1 0 01.035-1.448l33.923-30.768A12.725 12.725 0 0136 15c0-7.18 5.82-13 13-13 1.858 0 3.666.399 5.344 1.157a1 1 0 01.295 1.618L48.414 11 53 15.586zm6.542-3.713l-5.835 5.834a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l5.834-5.835A10.883 10.883 0 0049 4c-6.075 0-11 4.925-11 11 0 .86.11 1.725.325 2.606a1 1 0 01-.3.977L4.45 49.035 14.965 59.55l30.452-33.575a1 1 0 01.977-.3C47.275 25.89 48.14 26 49 26c6.075 0 11-4.925 11-11 0-1.069-.156-2.118-.458-3.127z",
    className: "secondary"
  })));
};

IconEngineeringXL.displayName = 'IconEngineeringXL';
IconEngineeringXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconEngineeringXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconExpertM = function IconExpertM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M5.5 18c1.762 0 3.229.582 4.383 1.498A2.975 2.975 0 0111 21.836V23a1 1 0 01-1 1H1a1 1 0 01-1-1v-1.164c0-.912.406-1.774 1.116-2.337C2.271 18.582 3.738 18 5.5 18zm13 0c1.762 0 3.229.582 4.383 1.498A2.975 2.975 0 0124 21.836V23a1 1 0 01-1 1h-9a1 1 0 01-1-1v-1.164c0-.912.406-1.774 1.116-2.337C15.271 18.582 16.738 18 18.5 18zm-13 2c-1.277 0-2.319.413-3.14 1.066a.976.976 0 00-.36.77V22h7v-.164a.977.977 0 00-.36-.77C7.82 20.412 6.777 20 5.5 20zm13 0c-1.277 0-2.319.413-3.14 1.066a.976.976 0 00-.36.77V22h7v-.164a.977.977 0 00-.36-.77C20.82 20.412 19.777 20 18.5 20zm-13-10a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm13 0a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm-13 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm13 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM23 0a1 1 0 011 1v6a1 1 0 01-1 1h-6.65l-4.725 3.78A1 1 0 0110 11V1a1 1 0 011-1h12zm-1 2H12v6.92l3.375-2.7A1 1 0 0116 6h6V2z",
    className: "primary"
  }));
};

IconExpertM.displayName = 'IconExpertM';
IconExpertM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconExpertM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconEyeOpenM = function IconEyeOpenM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M3.487 12.297a16.387 16.387 0 001.914 1.944C7.422 15.974 9.646 17 12 17s4.578-1.026 6.6-2.76A16.387 16.387 0 0020.754 12 16.406 16.406 0 0018.6 9.76C16.578 8.025 14.354 7 12 7S7.422 8.026 5.4 9.76A16.387 16.387 0 003.246 12c.073.092.153.191.242.297zm-2.32-.852c.145-.215.408-.572.784-1.023a18.37 18.37 0 012.148-2.181C6.453 6.224 9.104 5 12 5s5.547 1.224 7.9 3.24a18.37 18.37 0 012.15 2.182c.375.451.638.808.782 1.023a1 1 0 010 1.11c-.144.215-.407.572-.783 1.023a18.37 18.37 0 01-2.148 2.181C17.547 17.776 14.896 19 12 19s-5.547-1.224-7.9-3.24a18.37 18.37 0 01-2.15-2.182c-.375-.451-.638-.808-.782-1.023a1 1 0 010-1.11z",
    className: "primary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M12 15a5 5 0 110-10 5 5 0 010 10zm0-2a3 3 0 100-6 3 3 0 000 6z",
    className: "primary"
  })));
};

IconEyeOpenM.displayName = 'IconEyeOpenM';
IconEyeOpenM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconEyeOpenM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconFacebookM = function IconFacebookM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: "#090B0D",
    fillRule: "evenodd",
    d: "M9.032 23L9 13H5V9h4V6.5C9 2.789 11.298 1 14.61 1c1.585 0 2.948.118 3.345.17v3.88H15.66c-1.8 0-2.15.856-2.15 2.112V9h5.241l-2 4h-3.24v10H9.032z"
  }));
};

IconFacebookM.displayName = 'IconFacebookM';
IconFacebookM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconFacebookM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconFeedbackM = function IconFeedbackM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M12 1c6.617 0 12 4.401 12 10 0 2.189-.87 4.263-2.429 6.015l-.124.135.74 6.412-7.147-2.907c-.816.212-1.66.317-2.62.34L12 21C5.383 21 0 16.599 0 11S5.383 1 12 1zm0 2C6.409 3 2 6.605 2 11s4.409 8 10 8c1.1 0 1.977-.107 2.813-.358l.337-.101 4.663 1.896-.462-4.002.342-.342C21.186 14.6 22 12.836 22 11c0-4.395-4.409-8-10-8zm2 9v2H7v-2h7zm3-4v2H7V8h10z",
    className: "primary"
  })));
};

IconFeedbackM.displayName = 'IconFeedbackM';
IconFeedbackM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconFeedbackM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconFilterM = function IconFilterM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12 0c6.698 0 12 1.446 12 4 0 .477-.185.915-.53 1.313l.01.009L15 16.34V24H9v-7.66L.52 5.322l.01-.01C.184 4.916 0 4.478 0 4c0-2.554 5.302-4 12-4zm7.478 7.244C17.436 7.739 14.844 8 12 8c-2.844 0-5.437-.26-7.479-.756L11 15.66V22h2v-6.34zM12 2C6.548 2 2 3.24 2 4c0 .047.017.095.05.145l.054-.043.219.285C3.452 5.12 7.405 6 12 6s8.548-.881 9.677-1.613l.219-.285.054.043A.262.262 0 0022 4c0-.76-4.548-2-10-2z",
    className: "primary"
  }));
};

IconFilterM.displayName = 'IconFilterM';
IconFilterM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconFilterM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconFilterS = function IconFilterS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M16 3c0-2.916-7.181-3-8-3S0 .084 0 3c0 .457.191.837.492 1.166L6 10.37V15a1 1 0 001 1h2a1 1 0 001-1v-4.63l5.47-6.163C15.794 3.87 16 3.476 16 3zM8 2c3.137 0 5.155.584 5.829 1-.674.416-2.692 1-5.829 1-3.137 0-5.155-.584-5.829-1C2.845 2.584 4.863 2 8 2z",
    className: "primary"
  }));
};

IconFilterS.displayName = 'IconFilterS';
IconFilterS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconFilterS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconFlashLEDL = function IconFlashLEDL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M29 45v2H19v-2h10zM7 23v2H1v-2h6zm40 0v2h-6v-2h6zM8.444 7.03l4.242 4.242-1.414 1.414L7.03 8.444 8.444 7.03zm31.112 0l1.414 1.414-4.242 4.242-1.414-1.414 4.242-4.242zM25 1v6h-2V1h2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M19 42h10v-6.012c4.787-1.995 8-6.683 8-11.988 0-7.18-5.82-13-13-13s-13 5.82-13 13c0 5.305 3.213 9.993 8 11.988V42zm2-2v-5.405l-.666-.236A10.991 10.991 0 0113 24c0-6.075 4.925-11 11-11s11 4.925 11 11c0 4.693-2.972 8.815-7.334 10.36l-.666.235V40h-6z",
    className: "secondary"
  })));
};

IconFlashLEDL.displayName = 'IconFlashLEDL';
IconFlashLEDL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconFlashLEDL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconFlexibleL = function IconFlexibleL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M25 3v30.069A12.991 12.991 0 0136 27h9v2h-9c-5.978 0-10.843 4.77-10.996 10.712L25 40v6h-2v-6c0-6.075-4.925-11-11-11H3v-2h9c4.632 0 8.699 2.423 11.001 6.07L23 3h2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M8.293 21.293l1.414 1.414L4.414 28l5.293 5.293-1.414 1.414-6-6a1 1 0 010-1.414l6-6zm31.414 0l6 6a1 1 0 010 1.414l-6 6-1.414-1.414L43.586 28l-5.293-5.293 1.414-1.414zm-15-19l8 8-1.414 1.414L24 4.414l-7.293 7.293-1.414-1.414 8-8a1 1 0 011.414 0z",
    className: "primary"
  })));
};

IconFlexibleL.displayName = 'IconFlexibleL';
IconFlexibleL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconFlexibleL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconGalleryM = function IconGalleryM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M15.894 10.553l4 8A1 1 0 0119 20H6c-.92 0-1.352-1.137-.664-1.747l9-8a1 1 0 011.558.3zm-1.205 2.061L8.63 18h8.752l-2.693-5.386zM7 8a2 2 0 110 4 2 2 0 010-4z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M2 6v16h20V6H2zM1 4h22a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V5a1 1 0 011-1zM6 2V0h12v2z",
    className: "secondary"
  })));
};

IconGalleryM.displayName = 'IconGalleryM';
IconGalleryM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconGalleryM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconGatewayS = function IconGatewayS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M14.889 6.5v5.606L9 12.105V14h1.5v2h-5v-2H7v-1.895H.744V6.5H14.89zM16 14v2h-4v-2h4zM4 14v2H0v-2h4zm5-5.5H2.744v1.606L9 10.105V8.5zm3.889 0H11v1.605h1.889V8.5zm2-8.5v5.606H.744V0H14.89zM9 2H2.744v1.606L9 3.605V2zm3.889 0H11v1.605h1.889V2z",
    className: "primary"
  }));
};

IconGatewayS.displayName = 'IconGatewayS';
IconGatewayS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconGatewayS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconGatewayXL = function IconGatewayXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M56 27v18H33v9h3v8h-8v-8h3v-9H7V27h49zM34 56h-4v4h4v-4zm-22 1v2H3v-2h9zm36 0v2h-9v-2h9zm-24 0v2h-9v-2h9zm36 0v2h-9v-2h9zm-6-28H9v14h45V29zm2-26v18h-7v4h-2v-4H16v4h-2v-4H7V3h49zm-2 2H9v14h45V5z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M14 11h9v2h-9zM14 35h9v2h-9zM47 11h2v2h-2zM47 35h2v2h-2z",
    className: "primary"
  })));
};

IconGatewayXL.displayName = 'IconGatewayXL';
IconGatewayXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconGatewayXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconGiftXL = function IconGiftXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M55.293 25.293l1.414 1.414-36 36-1.414-1.414 36-36zm0 18l1.414 1.414-18 18-1.414-1.414 18-18zm-14-20l1.414 1.414-34 34-1.414-1.414 34-34zm-16 0l1.414 1.414-18 18-1.414-1.414 18-18zM20 15c-3.952 0-7-3.048-7-7s3.048-7 7-7c4.25 0 7.604 2.454 10.145 6.465a24.497 24.497 0 011.857 3.575 24.136 24.136 0 011.853-3.575C36.395 3.454 39.75 1 44 1c3.952 0 7 3.048 7 7s-3.048 7-7 7H20zm0-12c-2.848 0-5 2.152-5 5s2.152 5 5 5h10.623a23 23 0 00-2.168-4.465C26.245 5.046 23.45 3 20 3zm24 0c-3.45 0-6.246 2.046-8.455 5.535A23 23 0 0033.377 13H44c2.848 0 5-2.152 5-5s-2.152-5-5-5z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M62 13a1 1 0 011 1v10a1 1 0 01-1 1h-5v37a1 1 0 01-1 1H8a1 1 0 01-1-1V25H2a1 1 0 01-1-1V14a1 1 0 011-1h60zm-7 12H9v36h46V25zm6-10H3v8h58v-8z",
    className: "secondary"
  })));
};

IconGiftXL.displayName = 'IconGiftXL';
IconGiftXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconGiftXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconGlobeL = function IconGlobeL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 47C11.297 47 1 36.703 1 24S11.297 1 24 1s23 10.297 23 23-10.297 23-23 23zm0-2c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M28.824 18.78c.302.075.65.215 1.051.41a18.531 18.531 0 011.196.649 27.07 27.07 0 012.004.29c.86.165 1.537.357 2.016.61a1 1 0 01.207.146l1.3 1.186.006.002a22.116 22.116 0 011.98.892c.958.499 1.681.992 2.121 1.53.144.176.26.36.342.555.703 1.67-.929 5.26-2.6 6.095-1.273.635-2.287 1.475-2.683 2.098-.065.101-.6 1.538-.743 1.874-.577 1.346-1.215 2.226-2.187 2.607-.19.074-.494.25-.935.541-.267.177-1.31.894-1.432.976-.397.269-.734.489-1.06.688-1.584.97-2.777 1.397-3.86 1.098-2.545-.702-2.799-5.681-1.137-8.257.14-.218.184-.731.091-1.473a13.73 13.73 0 00-.177-1.035c-.02-.1-.129-.621-.156-.758a6.795 6.795 0 01-.093-.568l-.011-.111v.02c-.01.033-.068-.058-.191-.198-.179-.204-.366-.387-.84-.834l-.025-.023c-1.288-1.213-1.633-1.617-1.634-2.415 0-.735.408-1.623 1.138-2.775.167-.262.348-.533.541-.812a33.66 33.66 0 011.55-2.05 1 1 0 01.457-.313c.069-.022.188-.06.345-.108.261-.08.538-.16.819-.235.22-.059.435-.112.64-.158.856-.194 1.476-.265 1.96-.144zM11.984 5.167c.59.436 1.131 1.079 1.643 1.878a14.68 14.68 0 011.028 1.919c.229.181.497.423.768.717.422.461.749.953.937 1.486.102.29.167.602.201.93a6.563 6.563 0 01-.09 1.851 21.108 21.108 0 01.282.983c.09.343.167.677.229.997.217 1.134.237 1.954-.114 2.568-.324.568-.912.984-1.708 1.353a9.911 9.911 0 01-1.139.44 5.44 5.44 0 01-.787.883 4.72 4.72 0 01-2.443 1.199c-.9.094-1.479.653-1.479 1.629 0 .31.091.741.266 1.252.126.368.29.764.483 1.175a17.54 17.54 0 00.654 1.255l.078.041c.258.14.518.29.763.45.305.195.569.39.786.587.27.246.469.494.586.788.118.294.203.667.272 1.122a14.475 14.475 0 01.117 1.044c.134.258.295.604.456 1.013.271.693.464 1.382.54 2.05.1.87-.003 1.661-.377 2.334-.25.448-.676.75-1.264 1.026-.231.109-.458.199-.659.27l-1.754 2.63-1.664-1.109 1.947-2.92a1 1 0 01.555-.406 5.25 5.25 0 00.724-.275c.23-.108.382-.215.367-.188.144-.26.194-.644.138-1.135-.054-.473-.202-1.003-.415-1.546-.17-.435-.34-.78-.446-.965a1 1 0 01-.128-.435 12.536 12.536 0 00-.114-1.089 3.676 3.676 0 00-.151-.679c.017.043-.01.01-.076-.05a4.13 4.13 0 00-.523-.386 9.738 9.738 0 00-.912-.518 1 1 0 01-.413-.375 19.518 19.518 0 01-.897-1.684 13.694 13.694 0 01-.565-1.378c-.24-.701-.374-1.333-.374-1.899 0-2.066 1.408-3.424 3.205-3.61.517-.089.973-.334 1.37-.697a3.08 3.08 0 00.608-.73 1 1 0 01.624-.492 7.958 7.958 0 001.2-.438c.447-.206.75-.42.813-.53.024-.04.011-.542-.115-1.199-.052-.273-.12-.565-.199-.868a18.744 18.744 0 00-.327-1.108 1 1 0 01-.024-.56c.012-.05.035-.16.058-.314.061-.393.083-.796.047-1.152a2.06 2.06 0 00-.098-.469c-.086-.244-.27-.521-.526-.8a4.433 4.433 0 00-.676-.607 1 1 0 01-.355-.443 12.719 12.719 0 00-.976-1.86c-.39-.612-.786-1.082-1.145-1.348l1.188-1.608zm15.322 15.707c-.18.041-.37.088-.568.14a21.495 21.495 0 00-.776.224 33.92 33.92 0 00-1.267 1.692c-.178.256-.343.504-.493.74-.507.8-.807 1.443-.827 1.68.007-.066.055.013.17.148.176.206.384.412.834.836l.025.023c1.288 1.213 1.601 1.57 1.655 2.321.006.081.029.223.072.44.024.123.131.638.154.747.092.456.156.822.2 1.185.147 1.17.07 2.084-.395 2.804-.482.748-.77 2.089-.708 3.322.058 1.13.388 1.838.697 1.923.36.1 1.159-.187 2.283-.876.297-.181.61-.386.985-.639.107-.072 1.164-.799 1.45-.988.552-.364.952-.595 1.308-.734.32-.125.697-.647 1.077-1.533.062-.144.697-1.85.894-2.16.61-.957 1.901-2.027 3.477-2.814.315-.157.847-.856 1.231-1.701.377-.83.516-1.599.42-1.828a.429.429 0 00-.047-.065c-.222-.27-.762-.64-1.496-1.021a18.209 18.209 0 00-1.787-.805l-.123-.047c.053.107.066.133-.257-.33l-.106.117-1.33-1.214c-.281-.123-.76-.253-1.36-.367a21.638 21.638 0 00-1.403-.216 20.407 20.407 0 00-.635-.07 1 1 0 01-.436-.145l-.266-.159a16.566 16.566 0 00-.956-.515 4.001 4.001 0 00-.662-.269c-.068-.017-.494.032-1.034.154zM21.292 1.762l1.904.612a4.55 4.55 0 01-.239.568c-.041.086-.232.474-.282.579-.072.15-.132.28-.183.4-.152.352-.215.603-.235.615.016-.033.265.14.614.304a8.667 8.667 0 001.03.403 1 1 0 01.67 1.203 3.937 3.937 0 00-.059.302 4.207 4.207 0 00-.057.943c.023.333.098.533.17.59.073.059.205.083.459.05a4.57 4.57 0 00.611-.136c.61-.165.493-.134.67-.169.351-.069.643-.078.952.026.892.298 1.025 1.006 1.108 2.836.024.523.028 1.07.02 1.586l.035.033c.252.242.532.484.827.708.653.493 1.282.82 1.806.91l.057.009c.192.027.506-.05.901-.248.411-.206.87-.52 1.347-.912a14.056 14.056 0 001.364-1.288 1 1 0 01.521-.307l.3-.071a46.578 46.578 0 003.25-.92c.826-.27 1.532-.542 2.077-.803l.864 1.804c-.633.303-1.414.603-2.315.9a48.568 48.568 0 01-3.43.969 16.552 16.552 0 01-1.361 1.261c-.584.48-1.16.874-1.722 1.156-.725.362-1.414.532-2.074.44l-.117-.019c-.898-.154-1.79-.617-2.675-1.287-.62-.47-1.108-.937-1.404-1.264a1 1 0 01-.258-.705l.005-.222c.01-.528.008-1.104-.016-1.64-.015-.344-.04-.645-.071-.89l-.136.037a6.282 6.282 0 01-.88.19c-.743.096-1.403-.023-1.964-.472-.593-.473-.859-1.177-.917-2.014a5.698 5.698 0 01.022-.977 9.68 9.68 0 01-.462-.202c-.86-.405-1.42-.808-1.647-1.434-.223-.615-.083-1.237.283-2.086.063-.148.133-.3.217-.474.055-.116.245-.503.281-.579.031-.064.057-.12.078-.167l.048-.112a.67.67 0 00.013-.036z",
    className: "primary"
  })));
};

IconGlobeL.displayName = 'IconGlobeL';
IconGlobeL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconGlobeL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconGridM = function IconGridM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M14 1h9v9h-9V1zm2 2v5h5V3h-5zM1 14h9v9H1v-9zm2 2v5h5v-5H3z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M23 14v9h-9v-9h9zm-2 2h-5v5h5v-5zM10 1v9H1V1h9zM8 3H3v5h5V3z",
    className: "secondary"
  })));
};

IconGridM.displayName = 'IconGridM';
IconGridM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconGridM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconGridS = function IconGridS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M4 12v4H0v-4h4zm6 0v4H6v-4h4zm6 0v4h-4v-4h4zM4 6v4H0V6h4zm6 0v4H6V6h4zm6 0v4h-4V6h4zM4 0v4H0V0h4zm6 0v4H6V0h4zm6 0v4h-4V0h4z",
    className: "primary"
  }));
};

IconGridS.displayName = 'IconGridS';
IconGridS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconGridS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconHDDL = function IconHDDL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M36 19c0-6.626-5.373-12-12-12s-12 5.374-12 12c0 6.628 5.372 12 12 12s12-5.372 12-12zm2 0c0 7.732-6.268 14-14 14s-14-6.268-14-14c0-7.731 6.268-14 14-14s14 6.269 14 14zM35.5 40a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0035.5 40",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M37.765 1C40.65 1 43 3.378 43 6.286v36.428C43 45.622 40.65 48 37.765 48h-27.53C7.351 48 5 45.621 5 42.714V6.286C5 3.379 7.35 1 10.235 1h27.53zm0 2h-27.53C8.461 3 7 4.478 7 6.286v36.428C7 44.522 8.46 46 10.235 46h27.53C39.54 46 41 44.523 41 42.714V6.286C41 4.477 39.54 3 37.765 3zM17.63 24.744l1.414 1.414-6.512 6.511 11.928 6.194a1 1 0 01.539.887V42a1 1 0 01-1 1H11a1 1 0 01-1-1v-9c0-.174.043-.333.117-.472l-.136-.135 7.65-7.65zM12 34.646V41h11v-.642l-11-5.712zM24 17a2 2 0 11-.001 4.001A2 2 0 0124 17z",
    className: "secondary"
  })));
};

IconHDDL.displayName = 'IconHDDL';
IconHDDL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconHDDL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconHamburgerM = function IconHamburgerM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: "#090B0D",
    fillRule: "evenodd",
    d: "M23 17v2H1v-2h22zm0-7v2H1v-2h22zm0-7v2H1V3h22z"
  }));
};

IconHamburgerM.displayName = 'IconHamburgerM';
IconHamburgerM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconHamburgerM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconHarddriveM = function IconHarddriveM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M18.584 0c1.582 0 2.878 1.277 2.878 2.85v18.3c0 1.573-1.296 2.85-2.878 2.85H5.878C4.296 24 3 22.723 3 21.15V2.85C3 1.276 4.296 0 5.878 0h12.706zm0 1.846H5.878c-.568 0-1.032.457-1.032 1.003v18.302c0 .546.464 1.003 1.032 1.003h12.706c.569 0 1.031-.456 1.031-1.003V2.849c0-.547-.462-1.003-1.031-1.003zm-6.353.923a6.462 6.462 0 11-2.694 12.337L8.27 16.372l4.373 2.187c.312.156.51.476.51.826v.923c0 .51-.413.923-.923.923H6.692a.923.923 0 01-.923-.923v-3.693c0-.337.175-.616.425-.776l1.762-1.762A6.462 6.462 0 0112.23 2.769zm5.538 16.616a.923.923 0 110 1.846.923.923 0 010-1.846zm-6.461 0v.57l.235.118.117-.118-.352-.57zm-3.693-1.276v1.276h2.552l-2.552-1.276zm4.616-13.494a4.616 4.616 0 100 9.232 4.616 4.616 0 000-9.232zm0 2.77a1.846 1.846 0 110 3.693 1.846 1.846 0 010-3.693z",
    className: "primary"
  }));
};

IconHarddriveM.displayName = 'IconHarddriveM';
IconHarddriveM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconHarddriveM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconHarddriveXL = function IconHarddriveXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M49.682 26.364c0-9.564-7.754-17.319-17.318-17.319-9.564 0-17.319 7.755-17.319 17.319 0 9.565 7.754 17.318 17.319 17.318s17.318-7.753 17.318-17.318zm2 0c0 10.67-8.649 19.318-19.318 19.318-10.67 0-19.319-8.649-19.319-19.318 0-10.668 8.65-19.319 19.319-19.319 10.668 0 19.318 8.65 19.318 19.319zM47.455 50.727a2 2 0 000 4 2 2 0 000-4",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M50.682 1.41c3.654 0 6.636 2.982 6.636 6.635v47.91c0 3.653-2.982 6.636-6.636 6.636H14.045c-3.652 0-6.636-2.984-6.636-6.636V8.045c0-3.652 2.984-6.636 6.636-6.636h36.637zm0 2H14.045c-2.547 0-4.636 2.088-4.636 4.635v47.91c0 2.547 2.089 4.636 4.636 4.636h36.637a4.651 4.651 0 004.636-4.636V8.045a4.651 4.651 0 00-4.636-4.636zM23.202 34.11l1.414 1.414-8.883 8.882 15.669 7.835a1 1 0 01.553.894v2.819a1 1 0 01-1 1h-16.91a1 1 0 01-1-1V44.682c0-.274.107-.513.274-.688l.02-.02 9.863-9.863zM15.045 46.3v8.655h14.91v-1.2L15.045 46.3zm17.319-22.345a2.41 2.41 0 11-.001 4.819 2.41 2.41 0 010-4.82zm0 2a.41.41 0 100 .819.41.41 0 000-.82z",
    className: "secondary"
  })));
};

IconHarddriveXL.displayName = 'IconHarddriveXL';
IconHarddriveXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconHarddriveXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconHeartbeatXL = function IconHeartbeatXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M22.894 31.447A1 1 0 0122 32H5.5v-2h15.882l3.724-7.447a1 1 0 011.742-.083l9.055 14.488 3.203-6.405A1 1 0 0140 30h18.5v2H40.618l-3.724 7.447a1 1 0 01-1.742.083l-9.055-14.488-3.203 6.405z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M45.6 2C55.251 2 63 9.847 63 19.6c0 4.116-1.727 8.84-4.91 14.075-2.608 4.291-6.133 8.825-10.349 13.484-3.303 3.65-6.84 7.168-10.376 10.428a158.894 158.894 0 01-3.42 3.066 105.977 105.977 0 01-1.306 1.116 1 1 0 01-1.278 0 105.977 105.977 0 01-1.306-1.117 158.894 158.894 0 01-3.42-3.065c-3.537-3.26-7.073-6.778-10.376-10.428-4.216-4.659-7.741-9.193-10.35-13.484C2.727 28.44 1 23.715 1 19.6 1 9.847 8.749 2 18.4 2 23.826 2 28.785 4.494 32 8.667 35.215 4.494 40.174 2 45.6 2zM32.633 59.143c1.018-.885 2.154-1.9 3.377-3.027 3.495-3.22 6.99-6.698 10.249-10.3 4.137-4.571 7.588-9.01 10.123-13.18C59.39 27.686 61 23.284 61 19.6 61 10.946 54.141 4 45.6 4c-5.24 0-9.976 2.623-12.76 6.942a1 1 0 01-1.68 0C28.375 6.623 23.64 4 18.4 4 9.859 4 3 10.946 3 19.6c0 3.684 1.61 8.086 4.618 13.036 2.535 4.17 5.986 8.609 10.123 13.18 3.26 3.602 6.754 7.08 10.25 10.3A156.903 156.903 0 0032 59.69c.194-.166.405-.348.633-.546z",
    className: "secondary"
  })));
};

IconHeartbeatXL.displayName = 'IconHeartbeatXL';
IconHeartbeatXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconHeartbeatXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconHeirarchyXL = function IconHeirarchyXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M3 47v12h12V47H3zm14-2v16H1V45h16zM26 47v12h12V47H26zm14-2v16H24V45h16zM49 47v12h12V47H49zm14-2v16H47V45h16z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M31 23h2v18h-2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M10 33v8H8V31h48v10h-2v-8z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32 19a8 8 0 110-16 8 8 0 010 16zm0-2a6 6 0 100-12 6 6 0 000 12z",
    className: "primary"
  })));
};

IconHeirarchyXL.displayName = 'IconHeirarchyXL';
IconHeirarchyXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconHeirarchyXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconHelpM = function IconHelpM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 15a1 1 0 110 2 1 1 0 010-2zm4.12-10.32c1.1 1.78.518 3.861-1.246 5.458l-.548.475c-1.002.882-1.296 1.313-1.324 1.805L13 14.5v1h-2v-1c0-1.342.622-2.222 2.395-3.724 1.225-1.039 1.57-2.163 1.024-3.045-.491-.795-2.309-.995-3.964-.34l-.198.084-.914.404-.809-1.83.915-.404c2.51-1.109 5.522-.826 6.672 1.034z",
    className: "primary"
  }));
};

IconHelpM.displayName = 'IconHelpM';
IconHelpM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconHelpM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconHierarchyL = function IconHierarchyL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M29 35a1 1 0 011 1v10a1 1 0 01-1 1H19a1 1 0 01-1-1V36a1 1 0 011-1h10zm17 0a1 1 0 011 1v10a1 1 0 01-1 1H36a1 1 0 01-1-1V36a1 1 0 011-1h10zm-34 0a1 1 0 011 1v10a1 1 0 01-1 1H2a1 1 0 01-1-1V36a1 1 0 011-1h10zm16 2h-8v8h8v-8zm17 0h-8v8h8v-8zm-34 0H3v8h8v-8zM24 1a6 6 0 110 12 6 6 0 010-12zm0 2a4 4 0 100 8 4 4 0 000-8z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M25 18v5h16a1 1 0 011 1v6h-2v-5H25v5h-2v-5H8v5H6v-6a1 1 0 011-1h16v-5h2z",
    className: "secondary"
  })));
};

IconHierarchyL.displayName = 'IconHierarchyL';
IconHierarchyL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconHierarchyL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconHomeM = function IconHomeM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M4.633 11.292v10h4v-6h6v6h4v-10h2v12h-18v-12h2zm8 6h-2v4h2v-4zM11.633 0l11.633 9.518L22 11.066 11.633 2.584 1.266 11.066 0 9.518 11.633 0z",
    className: "primary"
  }));
};

IconHomeM.displayName = 'IconHomeM';
IconHomeM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconHomeM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconHourglassS = function IconHourglassS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M15 2c.6 0 1-.4 1-1s-.4-1-1-1H1C.4 0 0 .4 0 1s.4 1 1 1h1c.1 2.4.8 4.5 2 6-1.2 1.4-2 3.6-2 6H1c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1h-1c-.1-2.5-.8-4.6-2-6 1.3-1.5 2-3.6 2-6h1zM9.9 7.3l-.9.8 1 .7c1.2.9 2 2.9 2.1 5.2H4c.1-2.3.9-4.3 2.1-5.2l1-.7-1-.8C4.8 6.1 4.1 4.2 4 2h8c-.1 2.2-.8 4.1-2.1 5.3z",
    className: "primary"
  }));
};

IconHourglassS.displayName = 'IconHourglassS';
IconHourglassS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconHourglassS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconImageL = function IconImageL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M32.971 18.557l13.736 13.736-1.414 1.414-12.264-12.264L22.27 33.098l2.399 2.159-1.338 1.486-9.325-8.392-11.33 10.386-1.352-1.474 12.67-11.614 6.79 6.11L32.97 18.557zM18 11a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M1 5h46v38H1V5zm2 2v34h42V7H3z",
    className: "primary"
  })));
};

IconImageL.displayName = 'IconImageL';
IconImageL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconImageL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconImageM = function IconImageM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M15.894 8.553l4 8A1 1 0 0119 18H6c-.92 0-1.352-1.137-.664-1.747l9-8a1 1 0 011.558.3zm-1.205 2.061L8.63 16h8.752l-2.693-5.386zM7 6a2 2 0 110 4 2 2 0 010-4z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M2 4v16h20V4H2zM1 2h22a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V3a1 1 0 011-1z",
    className: "secondary"
  })));
};

IconImageM.displayName = 'IconImageM';
IconImageM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconImageM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconInfoM = function IconInfoM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 8a1 1 0 011 1v5h1v2h-4v-2h1v-4h-1v-2h2zm0-4a1 1 0 110 2 1 1 0 010-2z",
    className: "primary"
  }));
};

IconInfoM.displayName = 'IconInfoM';
IconInfoM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconInfoM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconInfoS = function IconInfoS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
    className: "primary"
  }));
};

IconInfoS.displayName = 'IconInfoS';
IconInfoS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconInfoS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconInteroperabilityL = function IconInteroperabilityL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M39.707 20.293l8 8a1 1 0 010 1.414l-8 8-1.414-1.414L44.585 30H19v-2h25.585l-6.292-6.293 1.414-1.414z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M8.293 10.293l1.414 1.414L3.414 18H29v2H3.414l6.293 6.293-1.414 1.414-8-8a1 1 0 010-1.414l8-8z",
    className: "secondary"
  })));
};

IconInteroperabilityL.displayName = 'IconInteroperabilityL';
IconInteroperabilityL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconInteroperabilityL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconKnowledgeM = function IconKnowledgeM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12 6a7 7 0 017 7 6.993 6.993 0 01-3.932 6.286l-.068.031V24H9v-4.682l-.068-.032a6.994 6.994 0 01-3.927-6.015L5 13a7 7 0 017-7zm0 2a4.996 4.996 0 00-1.666 9.708l.666.236V22h2v-4.056l.666-.236A4.996 4.996 0 0012 8zm-8 4v2H0v-2h4zm20 0v2h-4v-2h4zM4.222 3.808L7.05 6.636 5.636 8.05 2.808 5.222l1.414-1.414zm15.556 0l1.414 1.414-2.828 2.828-1.414-1.414 2.828-2.828zM13 1v4h-2V1h2z",
    className: "primary"
  }));
};

IconKnowledgeM.displayName = 'IconKnowledgeM';
IconKnowledgeM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconKnowledgeM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconLaunchM = function IconLaunchM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M10 1v2H3v18h18v-7h2v9H1V1h9zm13 0v10h-2V4.414l-9.293 9.293-1.414-1.414L19.584 3H13V1h10z",
    className: "primary"
  }));
};

IconLaunchM.displayName = 'IconLaunchM';
IconLaunchM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLaunchM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconLaunchS = function IconLaunchS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M8 0v2H2v12h12V8h2v7a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h7zm8 0v6l-2.293-2.293-5 5-1.414-1.414 5-5L10 0h6z",
    className: "primary"
  }));
};

IconLaunchS.displayName = 'IconLaunchS';
IconLaunchS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLaunchS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconLetterboxXL = function IconLetterboxXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M54.905 13.476c5.022 0 9.095 4.073 9.095 9.096V46.83a1.01 1.01 0 01-1.01 1.01H37.051V63h-2.02l-.001-15.161H1.011A1.01 1.01 0 010 46.83V22.572c0-5.023 4.073-9.096 9.095-9.096h45.81zm0 2.021H14.81a9.08 9.08 0 013.38 7.075l-.001 23.246h43.79V22.572a7.075 7.075 0 00-7.074-7.075zm-45.81 0a7.075 7.075 0 00-7.074 7.075v23.246h14.147V22.572a7.075 7.075 0 00-7.073-7.075z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M11.79 40.428v2.021H6.4v-2.021h5.39zM10.778 1.01c0-.558.452-1.011 1.01-1.011h8.085c.558 0 1.01.453 1.01 1.01v5.391a1.01 1.01 0 01-1.01 1.01H12.8v7.076h-2.021V1.01zm8.084 1.01H12.8v3.37h6.063V2.02z",
    className: "primary"
  })));
};

IconLetterboxXL.displayName = 'IconLetterboxXL';
IconLetterboxXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLetterboxXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconLightBulbXL = function IconLightBulbXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M8 31v2H2v-2h6zm54 0v2h-6v-2h6zM11.494 10.08l4.242 4.242-1.414 1.414-4.242-4.242 1.414-1.414zm41.012 0l1.414 1.414-4.242 4.242-1.414-1.414 4.242-4.242zM33 2v6h-2V2h2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M39 61v2H25v-2h14zm-7-47c9.941 0 18 8.059 18 18 0 6.911-3.938 13.1-10 16.112V56a1 1 0 01-1 1H25a1 1 0 01-1-1v-7.888C17.938 45.1 14 38.912 14 32c0-9.941 8.059-18 18-18zm0 2c-8.837 0-16 7.163-16 16 0 6.339 3.728 11.993 9.413 14.57a1 1 0 01.587.91V55h12v-7.52a1 1 0 01.587-.91C44.272 43.992 48 38.338 48 32c0-8.837-7.163-16-16-16z",
    className: "secondary"
  })));
};

IconLightBulbXL.displayName = 'IconLightBulbXL';
IconLightBulbXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLightBulbXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconLinkM = function IconLinkM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M14.242 9.758a6.01 6.01 0 00-1.659-1.169A1.99 1.99 0 0012 10c0 .213.04.415.102.608.259.161.505.343.726.564A3.977 3.977 0 0114 14a3.978 3.978 0 01-1.171 2.829l-3 2.999c-1.512 1.512-4.146 1.512-5.657 0A3.973 3.973 0 013 17c0-1.068.416-2.072 1.171-2.828l2.104-2.104A8.05 8.05 0 016 10c0-.162.013-.323.023-.483-.089.079-.18.156-.266.241l-3 3A5.959 5.959 0 001 17c0 1.603.624 3.109 1.757 4.242A5.96 5.96 0 007 23a5.96 5.96 0 004.243-1.758l3-2.999A5.967 5.967 0 0016 14a5.96 5.96 0 00-1.758-4.242z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M21.243 2.758A5.96 5.96 0 0017 1a5.96 5.96 0 00-4.243 1.758l-3 2.999A5.967 5.967 0 008 10c0 1.603.624 3.109 1.757 4.242a6.01 6.01 0 001.659 1.169c.376-.377.584-.879.584-1.411 0-.218-.041-.425-.106-.622a3.7 3.7 0 01-.721-.55A3.974 3.974 0 0110 10c0-1.068.416-2.073 1.171-2.829l3-2.999A3.975 3.975 0 0117 3c1.068 0 2.073.416 2.829 1.172A3.976 3.976 0 0121 7a3.976 3.976 0 01-1.171 2.828l-2.107 2.107C17.9 12.601 18 13.292 18 14c0 .162-.012.322-.021.482.089-.079.18-.155.265-.24l3-3A5.962 5.962 0 0023 7a5.959 5.959 0 00-1.757-4.242z",
    className: "secondary"
  })));
};

IconLinkM.displayName = 'IconLinkM';
IconLinkM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLinkM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconLinkXL = function IconLinkXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M37.366 26.839c6.053 6.053 6.053 15.867 0 21.92l-9.9 9.9c-6.053 6.053-15.867 6.053-21.92 0-6.053-6.053-6.053-15.868 0-21.92l9.9-9.9a15.445 15.445 0 015.419-3.52 17.117 17.117 0 00-.27 2.29l.01-.005a13.477 13.477 0 00-3.745 2.649l-9.9 9.9c-5.272 5.272-5.272 13.82 0 19.091 5.272 5.273 13.82 5.273 19.092 0l9.9-9.9c5.272-5.271 5.272-13.819 0-19.091a13.465 13.465 0 00-10.21-3.938c.112-.675.29-1.35.544-2.015a15.45 15.45 0 0111.08 4.539z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M26.54 37.36c-6.053-6.053-6.053-15.868 0-21.92l9.9-9.9c6.052-6.053 15.867-6.053 21.92 0 6.053 6.053 6.053 15.867 0 21.92l-9.9 9.9a15.445 15.445 0 01-5.42 3.52c.142-.759.232-1.524.27-2.29l-.01.004a13.477 13.477 0 003.746-2.649l9.9-9.9c5.272-5.271 5.272-13.819 0-19.09-5.273-5.273-13.82-5.273-19.092 0l-9.9 9.899c-5.272 5.272-5.272 13.82 0 19.091a13.465 13.465 0 0010.21 3.938c-.112.675-.29 1.35-.545 2.015a15.45 15.45 0 01-11.08-4.538z",
    className: "secondary"
  })));
};

IconLinkXL.displayName = 'IconLinkXL';
IconLinkXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLinkXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconLinkedinM = function IconLinkedinM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: "#090B0D",
    fillRule: "evenodd",
    d: "M15.527 13.5a2 2 0 00-2 2v7h-5s.06-12 0-13h5v1.485s1.548-1.443 3.94-1.443c2.96 0 5.06 2.143 5.06 6.304V22.5h-5v-7a2 2 0 00-2-2zm-11.51-6h-.029C2.478 7.5 1.5 6.318 1.5 5.019c0-1.329 1.007-2.412 2.547-2.412 1.541 0 2.488 1.118 2.518 2.447 0 1.3-.977 2.446-2.548 2.446zm2.51 15h-5v-13h5v13z"
  }));
};

IconLinkedinM.displayName = 'IconLinkedinM';
IconLinkedinM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLinkedinM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconListM = function IconListM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M6 17a1 1 0 011 1v4a1 1 0 01-1 1H2a1 1 0 01-1-1v-4a1 1 0 011-1h4zm-1 2H3v2h2v-2zM6 9a1 1 0 011 1v4a1 1 0 01-1 1H2a1 1 0 01-1-1v-4a1 1 0 011-1h4zm-1 2H3v2h2v-2zM6 1a1 1 0 011 1v4a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h4zM5 3H3v2h2V3z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M22 19v2H10v-2h12zm0-8v2H10v-2h12zm0-8v2H10V3h12z",
    className: "secondary"
  })));
};

IconListM.displayName = 'IconListM';
IconListM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconListM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconLoadingM = function IconLoadingM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      tertiary = theme.tertiary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: tertiary || '#E5F8E6',
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    className: "tertiary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M12 2V0c6.627 0 12 5.373 12 12h-2c0-5.523-4.477-10-10-10z",
    className: "primary"
  })));
};

IconLoadingM.displayName = 'IconLoadingM';
IconLoadingM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLoadingM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconLockL = function IconLockL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24.003 1c6.066.018 10.98 4.93 10.997 11v4.999L41 17v30H7V17l6-.001v-5.002c.017-5.97 4.776-10.823 10.715-10.992zM39 19l-4-.001V19h-2v-.001H15V19h-2v-.001L9 19v26h30V19zM24.003 3c-4.966.014-8.989 4.037-9.003 9v4.999h18v-4.996c-.014-4.878-3.894-8.845-8.732-8.998z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M24 25a5 5 0 011.001 9.9L25 39h-2v-4.1a5.002 5.002 0 011-9.9zm0 2a3 3 0 100 6 3 3 0 000-6z",
    className: "primary"
  })));
};

IconLockL.displayName = 'IconLockL';
IconLockL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLockL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconLockM = function IconLockM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12.11 0c3.286.034 5.923 2.724 5.89 6v2h2a1 1 0 011 1v14a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1h2V5.89A5.95 5.95 0 0111.778.002L12 0zM19 10H5v12h14V10zm-7 2a3 3 0 011 5.829V20h-2v-2.17A3.001 3.001 0 0112 12zm0 2a1 1 0 100 2 1 1 0 000-2zm.1-12h-.11A3.949 3.949 0 008 5.9V8h8V5.99a3.95 3.95 0 00-3.698-3.983L12.1 2z",
    className: "primary"
  }));
};

IconLockM.displayName = 'IconLockM';
IconLockM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLockM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconLockS = function IconLockS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M8 0C5.8 0 4 1.8 4 4v1H2c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1h-2V4c0-2.2-1.8-4-4-4zm1 11.7V13H7v-1.3c-.6-.3-1-1-1-1.7 0-1.1.9-2 2-2s2 .9 2 2c0 .7-.4 1.4-1 1.7zM10 5H6V4c0-1.1.9-2 2-2s2 .9 2 2v1z",
    className: "primary"
  }));
};

IconLockS.displayName = 'IconLockS';
IconLockS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLockS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconLockXL = function IconLockXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32 35a7 7 0 011.001 13.929L33 55h-2v-6.07A7.002 7.002 0 0132 35zm0 2a5 5 0 100 10 5 5 0 000-10zm0-36c7.18 0 13 5.82 13 13v13h-2V14c0-6.075-4.925-11-11-11S21 7.925 21 14v13h-2V14c0-7.18 5.82-13 13-13z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M57 63H7V27h50v36zm-2-2V29H9v32h46z",
    className: "secondary"
  })));
};

IconLockXL.displayName = 'IconLockXL';
IconLockXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLockXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconLogoutM = function IconLogoutM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M16 6.586L21.414 12 16 17.414 14.586 16l2.999-3H8v-2h9.585l-3-3L16 6.586z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M17 22H5V2h12v3h2V0H3v24h16v-5h-2z",
    className: "secondary"
  })));
};

IconLogoutM.displayName = 'IconLogoutM';
IconLogoutM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLogoutM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconLogoutS = function IconLogoutS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M11 0v2H2v12h9v2H1a1 1 0 01-1-1V1a1 1 0 011-1h10zm-1 3.586L14.414 8 10 12.414 8.586 11l2-2H4V7h6.586l-2-2L10 3.586z",
    className: "primary"
  }));
};

IconLogoutS.displayName = 'IconLogoutS';
IconLogoutS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconLogoutS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconMagicXL = function IconMagicXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M60.707 37.707c-1.53 1.53-1.53 5.056 0 6.586.943.943-.471 2.357-1.414 1.414-1.53-1.53-5.056-1.53-6.586 0-.943.943-2.357-.471-1.414-1.414 1.53-1.53 1.53-5.056 0-6.586-.943-.943.471-2.357 1.414-1.414 1.53 1.53 5.056 1.53 6.586 0 .943-.943 2.357.471 1.414 1.414zm-2.955 1.54a8.076 8.076 0 01-3.504 0 8.076 8.076 0 010 3.505 8.076 8.076 0 013.504 0 8.076 8.076 0 010-3.504zM31.707 24.294l9 9-1.414 1.414-9-9 1.414-1.414zm31-20.586c-2.49 2.49-2.49 8.096 0 10.586.943.943-.471 2.357-1.414 1.414-2.49-2.49-8.096-2.49-10.586 0-.943.943-2.357-.471-1.414-1.414 2.49-2.49 2.49-8.096 0-10.586-.943-.943.471-2.357 1.414-1.414 2.49 2.49 8.096 2.49 10.586 0 .943-.943 2.357.471 1.414 1.414zm-34 2c-1.53 1.53-1.53 5.056 0 6.586.943.943-.471 2.357-1.414 1.414-1.53-1.53-5.056-1.53-6.586 0-.943.943-2.357-.471-1.414-1.414 1.53-1.53 1.53-5.056 0-6.586-.943-.943.471-2.357 1.414-1.414 1.53 1.53 5.056 1.53 6.586 0 .943-.943 2.357.471 1.414 1.414zm30.628-.042c-2.115.66-4.555.66-6.67 0 .66 2.115.66 4.555 0 6.67 2.115-.66 4.555-.66 6.67 0a11.489 11.489 0 010-6.67zM25.752 7.248a8.076 8.076 0 01-3.504 0 8.076 8.076 0 010 3.504 8.076 8.076 0 013.504 0 8.076 8.076 0 010-3.504z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M4.414 53L12 60.586 45.585 27l-7.586-7.586L4.414 53zm-2.122-.707l35-35a1 1 0 011.414 0l9 9a1 1 0 010 1.415l-35 34.999a1 1 0 01-1.414 0l-9-9a1 1 0 010-1.414z",
    className: "secondary"
  })));
};

IconMagicXL.displayName = 'IconMagicXL';
IconMagicXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMagicXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconMailM = function IconMailM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M23 2a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V3a1 1 0 011-1h22zm-1 3.259l-9.327 8.48a1 1 0 01-1.346 0L2 5.26V20h20V5.259zM20.413 4H3.586L12 11.649 20.413 4z",
    className: "primary"
  }));
};

IconMailM.displayName = 'IconMailM';
IconMailM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMailM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconMailS = function IconMailS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M16 5.7V14c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V5.7l7.5 4.2c.28.14.72.14 1 0L16 5.7zM15 1c.6 0 1 .4 1 1v1.5L8 7.9 0 3.4V2c0-.6.4-1 1-1z",
    className: "primary"
  }));
};

IconMailS.displayName = 'IconMailS';
IconMailS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMailS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconMainboardS = function IconMainboardS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M16 0v16H0V0h16zM7 2H2v12h5V2zm7 0H9v12h5V2zm-8 8.5v2H3v-2h3zm7 0v2h-3v-2h3zM4.5 7a1 1 0 110 2 1 1 0 010-2zm7 0a1 1 0 110 2 1 1 0 010-2zM13 3.5v2h-3v-2h3zm-7 0v2H3v-2h3z",
    className: "primary"
  }));
};

IconMainboardS.displayName = 'IconMainboardS';
IconMainboardS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMainboardS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconMathL = function IconMathL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M15 7v6h6v2h-6v6h-2v-6H7v-2h6V7h2zM19 27.586L20.414 29l-5 5 5 5L19 40.414l-5-5-5 5L7.586 39l5-5-5-5L9 27.586l5 5 5-5zM41 13H27v2h14zM41 37v2H27v-2h14zm0-8v2H27v-2h14z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M1 1h46v46H1V1zm2 2v42h42V3H3z",
    className: "secondary"
  })));
};

IconMathL.displayName = 'IconMathL';
IconMathL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMathL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconMathM = function IconMathM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M6 1v4h4v2H6v4H4V7H0V5h4V1h2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M8 15.586L9.414 17l-3 3 3 3L8 24.414l-3-3-3 3L.586 23l3-3-3-3L2 15.586l3 3 3-3zM24 5H14v2h10z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M23 17v2h-8v-2h8zm0 4v2h-8v-2h8z",
    className: "secondary"
  })));
};

IconMathM.displayName = 'IconMathM';
IconMathM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMathM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconMathXL = function IconMathXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M61 61H3V3h58v58zM31 33H5v26h26V33zm28 0H33v26h26V33zM31 5H5v26h26V5zm28 0H33v26h26V5z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M22.5 40.086l1.414 1.414-4.5 4.5 4.5 4.5-1.414 1.414-4.5-4.5-4.5 4.5-1.414-1.414 4.5-4.5-4.5-4.5 1.414-1.414 4.5 4.5 4.5-4.5zM53 49v2H39v-2h14zm0-8v2H39v-2h14zM19 11v6h6v2h-6v6h-2v-6h-6v-2h6v-6h2zm34 6v2H39v-2h14z",
    className: "primary"
  })));
};

IconMathXL.displayName = 'IconMathXL';
IconMathXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMathXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconMoneyL = function IconMoneyL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32 34a1 1 0 010 2h-5a1 1 0 010-2h5zm9 0a1 1 0 010 2h-1a1 1 0 010-2h1zm-28.875-4a1 1 0 01-1-1c0-1.762-1.413-3.2-3.125-3.2a1 1 0 01-1-1v-5.6a1 1 0 011-1c1.712 0 3.125-1.438 3.125-3.2a1 1 0 011-1h13.75a1 1 0 011 1c0 1.762 1.413 3.2 3.125 3.2a1 1 0 011 1v2.82a1 1 0 01-1 1h-4.976c-.649-.007-.852.138-.952.442-.055.165-.07.333-.07.628L24 25H45a1 1 0 010 2H24.001v2H45a1 1 0 010 2H23a1 1 0 01-1-1h-9.875zm12.846-14H13.029c-.398 2.057-2 3.69-4.029 4.1v3.8c2.029.41 3.631 2.043 4.03 4.1h8.972L22 26.02V26l.001-.026V24.09c0-.495.032-.832.171-1.255.374-1.133 1.356-1.83 2.861-1.815H29v-.92c-2.029-.41-3.631-2.043-4.03-4.1z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M34 10a1 1 0 011 1v10h8a3 3 0 013 3v14a3 3 0 01-3 3H25a3 3 0 01-3-3v-4H4a1 1 0 01-1-1V11a1 1 0 011-1h30zm9 13H25a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V24a1 1 0 00-1-1zM33 12H5v20h16.97v-7.94c0-1.782 1.066-3.06 3.023-3.06H33v-9zm-14.5 6a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    className: "secondary"
  })));
};

IconMoneyL.displayName = 'IconMoneyL';
IconMoneyL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMoneyL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconMoneyXL = function IconMoneyXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M37 52v2H25v-2h12zm18 0v2h-5v-2h5zm8-8v2H17v-2h46zM47 2v28h-2V4H3v30h16.023v2H63v2H17v-2H1V2h46zM24 14a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M35 8v1c0 2.748 2.252 5 5 5h1v10h-1c-2.406 0-4.431 1.726-4.899 4H59c2.252 0 4 1.748 4 4v26c0 2.252-1.748 4-4 4H21c-2.252 0-4-1.748-4-4V32c0-.735.186-1.416.515-2H13v-1c0-2.748-2.252-5-5-5H7V14h1c2.748 0 5-2.252 5-5V8h22zm24 22H21c-1.148 0-2 .852-2 2v26c0 1.148.852 2 2 2h38c1.148 0 2-.852 2-2V32c0-1.148-.852-2-2-2zm-20-7.928v-6.144A7.03 7.03 0 0133.072 10H14.928A7.03 7.03 0 019 15.928v6.144A7.03 7.03 0 0114.928 28h18.144A7.03 7.03 0 0139 22.072z",
    className: "primary"
  })));
};

IconMoneyXL.displayName = 'IconMoneyXL';
IconMoneyXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMoneyXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconMoneybagL = function IconMoneybagL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M34 1a1 1 0 01.949 1.316l-3.874 11.621 10.156 21.668C43.718 40.909 39.847 47 33.988 47H14.012c-5.859 0-9.73-6.09-7.243-11.395l10.156-21.668-3.874-11.62A1 1 0 0114 1h20zm-4.636 14h-10.73L8.58 36.453C6.714 40.433 9.62 45 14.012 45h19.976c4.394 0 7.298-4.568 5.433-8.547L29.364 15zm3.249-12H15.387l3.334 10H23v-3h2v3h4.279l3.334-10z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M25 19l.001 2.1A5.002 5.002 0 0129 26h-2a3 3 0 00-3-3c-1.634 0-3 1.38-3 3 0 1.43.732 2.016 3.371 3.072C27.732 30.416 29 31.43 29 34c0 2.477-1.7 4.455-4 4.904V41h-2v-2.1a5.002 5.002 0 01-4-4.9h2a3 3 0 003 3c1.692 0 3-1.287 3-3 0-1.43-.732-2.016-3.371-3.072C20.268 29.584 19 28.57 19 26c0-2.381 1.73-4.425 4-4.897V19h2z",
    className: "primary"
  })));
};

IconMoneybagL.displayName = 'IconMoneybagL';
IconMoneybagL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMoneybagL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconMoneybagXL = function IconMoneybagXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M47.44 1l-6.322 16.973 12.786 29.674C57.033 54.91 51.71 63 43.802 63H20.211c-7.91 0-13.235-8.1-10.1-15.36l12.811-29.666L16.557 1H47.44zm-8.057 18H24.657L11.948 48.433c-2.532 5.862 1.678 12.393 8.009 12.564l.254.003h23.591c6.47 0 10.825-6.62 8.266-12.561L39.383 19zm-.037-2L44.56 3H19.443l5.25 14H31v-7h2v7h6.346z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M33 26v4c3.352 0 6 2.648 6 6h-2c0-2.248-1.752-4-4-4l.002 8.223c1.831.477 2.72.801 3.661 1.403 1.52.97 2.337 2.4 2.337 4.374 0 3.352-2.648 6-6 6v4h-2v-4c-3.352 0-6-2.648-6-6h2c0 2.248 1.752 4 4 4l-.001-8.223c-1.832-.477-2.72-.801-3.662-1.403C25.817 39.404 25 37.974 25 36c0-3.352 2.648-6 6-6v-4h2zm.002 16.3L33 50c2.248 0 4-1.752 4-4 0-2.018-.92-2.828-3.998-3.7zM31 32c-2.248 0-4 1.752-4 4 0 2.018.92 2.828 4 3.7z",
    className: "primary"
  })));
};

IconMoneybagXL.displayName = 'IconMoneybagXL';
IconMoneybagXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMoneybagXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconMoonM = function IconMoonM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M10.01 1.956l-.674 1.795C9.106 4.363 9 5.111 9 6c0 4.948 4.052 9 9 9 .89 0 1.637-.107 2.249-.336l1.795-.673-.475 1.857C20.345 20.632 16.014 24 11 24 4.948 24 0 19.052 0 13 0 7.986 3.368 3.655 8.152 2.431l1.857-.475zM7.046 4.95l-.13.062C3.96 6.479 2 9.538 2 13c0 4.948 4.052 9 9 9 3.462 0 6.52-1.96 7.989-4.918l.061-.13-.33.027c-.116.007-.235.012-.355.016L18 17C11.948 17 7 12.052 7 6c0-.247.007-.487.021-.72l.026-.331zM22 6v2h2v2h-2v2h-2v-2h-2V8h2V6h2zm-6-6v2h2v2h-2v2h-2V4h-2V2h2V0h2z",
    className: "primary"
  }));
};

IconMoonM.displayName = 'IconMoonM';
IconMoonM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMoonM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconMoonS = function IconMoonS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M5.2 2C3.8 7.3 8.7 12.2 14 10.8c-.9 3-3.6 5.2-6.9 5.2C3.2 16 0 12.8 0 8.9 0 5.6 2.2 2.8 5.2 2zM15 6a1 1 0 110 2 1 1 0 010-2zm-5-1a1 1 0 110 2 1 1 0 010-2zm0-5a1 1 0 110 2 1 1 0 010-2z",
    className: "primary"
  }));
};

IconMoonS.displayName = 'IconMoonS';
IconMoonS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconMoonS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconNFSL = function IconNFSL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M20.414 6H37v4h-2V8H19.586l-3-3H10v19.838L14.28 12h29.107l-6.666 20H8V3h9.414l3 3zM10.387 30H35.28l5.334-16H15.72l-5.334 16z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M25 32v7h2v6h-6v-6h2v-7h2zm-14 9v2H5v-2h6zm8 0v2h-6v-2h6zm16 0v2h-6v-2h6zm8 0v2h-6v-2h6zm-18 0h-2v2h2v-2z",
    className: "primary"
  })));
};

IconNFSL.displayName = 'IconNFSL';
IconNFSL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconNFSL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconNICXL = function IconNICXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M37.623.823a1 1 0 011.212.116L62.68 23.144a1 1 0 01-.162 1.587l-13.244 8.037c-.476.29-.925.562-1.347.817l-8.174 4.961 2.716 2.752a1 1 0 01-.2 1.56l-7.63 4.55 3.195 3.117a6 6 0 011.803 4.01l.007.285v9.172h-2V54.82a4 4 0 00-1.207-2.863L2.07 18.427v11.706h-2V18.428a2 2 0 013.397-1.432L6.7 20.151zm.41 2.102L8.174 21.588l24.984 24.375 6.992-4.168-2.708-2.745a1 1 0 01.193-1.557L60.35 23.707 38.033 2.925z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M7.546 28.166c.672 0 1.317.266 1.794.74l7.147 7.09A5.117 5.117 0 0118 39.63v1.998a2.546 2.546 0 01-4.34 1.808l-7.147-7.092A5.117 5.117 0 015 32.711v-1.998a2.546 2.546 0 012.546-2.547zm0 2a.546.546 0 00-.546.547v1.998c0 .83.332 1.627.922 2.212l7.147 7.092a.546.546 0 00.931-.388v-1.998c0-.831-.332-1.627-.922-2.213l-7.147-7.091a.546.546 0 00-.385-.159zm43.146-11.011a1 1 0 011.251.147l2.82 2.892a1 1 0 01-.194 1.55L35.3 35.564a1 1 0 01-1.198-.116l-2.777-2.544a1 1 0 01.141-1.582zm.385 2.123L33.639 32.313l1.257 1.151 17.56-10.77-1.379-1.416zm-7.385-8.123a1 1 0 011.251.147l2.82 2.892a1 1 0 01-.194 1.55L28.3 29.564a1 1 0 01-1.198-.116l-2.777-2.544a1 1 0 01.141-1.582zm.385 2.123L26.639 26.313l1.257 1.151 17.56-10.77-1.379-1.416zm-6.385-8.123a1 1 0 011.251.147l2.82 2.892a1 1 0 01-.194 1.55L22.3 23.564a1 1 0 01-1.198-.116l-2.777-2.544a1 1 0 01.141-1.582zm.385 2.123L20.639 20.313l1.257 1.151 17.56-10.77-1.379-1.416zM33 54c.552 0 1 .36 1 .804v6.392c0 .444-.448.804-1 .804s-1-.36-1-.804v-6.392c0-.444.448-.804 1-.804zm-4-4c.552 0 1 .36 1 .804v6.392c0 .444-.448.804-1 .804s-1-.36-1-.804v-6.392c0-.444.448-.804 1-.804zm-4-4c.552 0 1 .36 1 .804v6.392c0 .444-.448.804-1 .804s-1-.36-1-.804v-6.392c0-.444.448-.804 1-.804zm-4-4.5c.552 0 1 .36 1 .804v6.392c0 .444-.448.804-1 .804s-1-.36-1-.804v-6.392c0-.444.448-.804 1-.804z",
    className: "primary"
  })));
};

IconNICXL.displayName = 'IconNICXL';
IconNICXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconNICXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconNetworkL = function IconNetworkL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 1c12.703 0 23 10.297 23 23S36.703 47 24 47 1 36.703 1 24 11.297 1 24 1zm17.236 35H6.764c3.795 5.44 10.1 9 17.236 9 7.136 0 13.44-3.56 17.236-9zm3.74-11H3.024a20.882 20.882 0 002.507 9h36.94a20.882 20.882 0 002.507-9zm-2.505-11H5.529a20.882 20.882 0 00-2.506 9h41.954a20.882 20.882 0 00-2.506-9zM24 3c-7.137 0-13.442 3.56-17.236 9h34.472C37.442 6.56 31.136 3 24 3z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M24 1c6.816 0 12 10.368 12 23s-5.184 23-12 23-12-10.368-12-23S17.184 1 24 1zM14 24c0 10.933 4.096 19.815 9 20.89V3.11c-4.904 1.075-9 9.957-9 20.89zM25 3.11v41.78c4.905-1.077 9-9.957 9-20.89S29.905 4.187 25 3.11z",
    className: "primary"
  })));
};

IconNetworkL.displayName = 'IconNetworkL';
IconNetworkL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconNetworkL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconNetworkM = function IconNetworkM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M19.207 6.793l5 5a1 1 0 010 1.414l-5 5-1.414-1.414 4.293-4.293-4.293-4.293 1.414-1.414zm-14.414 0l1.414 1.414L1.914 12.5l4.293 4.293-1.414 1.414-5-5a1 1 0 010-1.414l5-5zM12 10.5a2 2 0 110 4 2 2 0 010-4zm5 0a2 2 0 110 4 2 2 0 010-4zm-10 0a2 2 0 110 4 2 2 0 010-4z",
    className: "primary"
  }));
};

IconNetworkM.displayName = 'IconNetworkM';
IconNetworkM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconNetworkM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconNetworkSettingsL = function IconNetworkSettingsL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M40 20v12H25v6h2v6h-6v-6h2v-6H8V20h32zM25 40h-2v2h2v-2zm13-18H10v8h28v-8zm2-18v12h-4v3h-2v-3H14v3h-2v-3H8V4h32zm-2 2H10v8h28V6z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M11 40v2H5v-2h6zm8 0v2h-6v-2h6zm16 0v2h-6v-2h6zm8 0v2h-6v-2h6zM20 25v2h-7v-2h7zm15 0v2h-2v-2h2zM20 9v2h-7V9h7zm15 0v2h-2V9h2z",
    className: "primary"
  })));
};

IconNetworkSettingsL.displayName = 'IconNetworkSettingsL';
IconNetworkSettingsL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconNetworkSettingsL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconNewsM = function IconNewsM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M24 0v21.003A3.007 3.007 0 0121 24H3.997v.003l-1-.003a3.007 3.007 0 01-2.991-2.824L0 21v-9h3v2H1.999L2 20.997c.002.514.388.937.886.996L3 22c.552-.003.998-.45 1-1V0h20zm-2 2H6v19.003c0 .295-.044.58-.124.85L5.827 22h15.17c.514-.002.937-.388.996-.884L22 21V2zm-2 15v2H8v-2h12zm0-4v2H8v-2h12zm0-8v6H8V5h12zm-2 2h-8v2h8V7z",
    className: "primary"
  }));
};

IconNewsM.displayName = 'IconNewsM';
IconNewsM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconNewsM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconNodeL = function IconNodeL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M30.25 28.836l9.914 9.914-1.414 1.414-9.914-9.914 1.414-1.414zM43.5 28v10h-2V28h2zM25 31v7h-2v-7h2zM6.5 10v10h-2V10h2zm3-1.914L19.414 18 18 19.414 8.086 9.5 9.5 8.086zM25 10v7h-2v-7h2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M24 37a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm18.5 0a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM24 39a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm18.5 0a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM24 15a9 9 0 110 18 9 9 0 010-18zm0 2a7 7 0 100 14 7 7 0 000-14zm18.5 1.5a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm-37 0a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm37 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm-37 0a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM5.5 0a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM24 0a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM5.5 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM24 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7z",
    className: "primary"
  })));
};

IconNodeL.displayName = 'IconNodeL';
IconNodeL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconNodeL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconNodeM = function IconNodeM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M22 13v6h-2v-.336l-1.375 1.375-5.164-5.164 1.414-1.414L20 18.586V13h2zm-9 3v4h-2v-4h2zM5.25 3.836L10.414 9 9 10.414l-5-5V11H2V5h2v.085l1.25-1.25zM13 5v4h-2V5h2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M21 18a3 3 0 110 6 3 3 0 010-6zm-9 0a3 3 0 110 6 3 3 0 010-6zm9 2a1 1 0 100 2 1 1 0 000-2zm-9 0a1 1 0 100 2 1 1 0 000-2zm0-13a5 5 0 110 10 5 5 0 010-10zM3 9a3 3 0 110 6 3 3 0 010-6zm18 0a3 3 0 110 6 3 3 0 010-6zm-9 0a3 3 0 100 6 3 3 0 000-6zm-9 2a1 1 0 100 2 1 1 0 000-2zm18 0a1 1 0 100 2 1 1 0 000-2zM3 0a3 3 0 110 6 3 3 0 010-6zm9 0a3 3 0 110 6 3 3 0 010-6zM3 2a1 1 0 100 2 1 1 0 000-2zm9 0a1 1 0 100 2 1 1 0 000-2z",
    className: "primary"
  })));
};

IconNodeM.displayName = 'IconNodeM';
IconNodeM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconNodeM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconNodeS = function IconNodeS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M15.5 8v6h-1.712l-.6.602-3.54-3.54 1.415-1.414 2.437 2.438V8h2zM9 10v4H7v-4h2zM2.875 1.46L6.415 5 5 6.414l-2.5-2.5V8h-2V2h1.835l.54-.54zM9 2v4H7V2h2z",
    className: "primary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M8 13a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm6.5 0l.144.007A1.5 1.5 0 1114.5 13zM8 4.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zM14.5 7a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-13-.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm6.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM1.5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM8 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    className: "primary"
  })));
};

IconNodeS.displayName = 'IconNodeS';
IconNodeS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconNodeS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconNodeXL = function IconNodeXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M39.607 38.191L52.914 51.5 51.5 52.914 38.245 39.66c.504-.44.96-.932 1.362-1.468zm-6.606 3.757L33 50h-2v-8.052a9.61 9.61 0 002 0zM57.5 39v11h-2V39h2zm-45-27.914l13.809 13.807a9.556 9.556 0 00-1.468 1.362L11.086 12.5l1.414-1.414zM8.5 14v12h-2V14h2zM33 14v9.052a9.61 9.61 0 00-2 0V14h2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32 49a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm24.5 0a7.5 7.5 0 110 15 7.5 7.5 0 010-15zM32 51a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm24.5 0a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM32 21c6.351 0 11.5 5.149 11.5 11.5S38.351 44 32 44s-11.5-5.149-11.5-11.5S25.649 21 32 21zm0 2a9.5 9.5 0 100 19 9.5 9.5 0 000-19zm24.5 2a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm-49 0a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm49 2a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm-49 0a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0-27a7.5 7.5 0 110 15 7.5 7.5 0 010-15zM32 0a7.5 7.5 0 110 15 7.5 7.5 0 010-15zM7.5 2a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM32 2a5.5 5.5 0 100 11 5.5 5.5 0 000-11z",
    className: "primary"
  })));
};

IconNodeXL.displayName = 'IconNodeXL';
IconNodeXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconNodeXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconNotificationS = function IconNotificationS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M10 14c0 1.1-.9 2-2 2s-2-.9-2-2zM8 0c2.8 0 5 2.2 5 5v3c0 1.3.8 2.3 1.5 3h.5c.6 0 1 .4 1 1s-.4 1-1 1H1c-.6 0-1-.4-1-1s.4-1 1-1h.5C2.2 10.3 3 9.3 3 8V5c0-2.8 2.2-5 5-5z",
    className: "primary"
  }));
};

IconNotificationS.displayName = 'IconNotificationS';
IconNotificationS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconNotificationS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconOptionsM = function IconOptionsM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M16 16a1 1 0 011-1h6a1 1 0 011 1v4a1 1 0 01-1 1h-2v2h-2v-2h-2a1 1 0 01-1-1v-4zm2 1v2h4v-2h-4zm1-16h2v11h-2V1zM8 6a1 1 0 011-1h6a1 1 0 011 1v4a1 1 0 01-1 1h-2v12h-2V11H9a1 1 0 01-1-1V6zm2 1v2h4V7h-4zm1-6h2v2h-2V1zM0 16a1 1 0 011-1h6a1 1 0 011 1v4a1 1 0 01-1 1H5v2H3v-2H1a1 1 0 01-1-1v-4zm2 1v2h4v-2H2zM3 1h2v11H3V1z",
    className: "primary"
  }));
};

IconOptionsM.displayName = 'IconOptionsM';
IconOptionsM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconOptionsM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconOrgChartM = function IconOrgChartM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: "#090B0D",
    fillRule: "evenodd",
    d: "M15 18v6H9v-6h6zm9 0v6h-6v-6h6zM6 18v6H0v-6h6zm7 2h-2v2h2v-2zm9 0h-2v2h2v-2zM4 20H2v2h2v-2zm9-12v3h9v5h-2v-3h-7v3h-2v-3H4v3H2v-5h9V8h2zm2-8v6H9V0h6zm-2 2h-2v2h2V2z"
  }));
};

IconOrgChartM.displayName = 'IconOrgChartM';
IconOrgChartM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconOrgChartM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconPasswordM = function IconPasswordM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M24 0v5.414L20.414 9H18v2.414l-2.33 2.33c.218.73.33 1.487.33 2.256a8 8 0 11-8-8c.485 0 .968.047 1.448.138L17.586 0H24zm-2 2h-3.586l-8.347 8.347-.554-.146A5.949 5.949 0 008 10a6 6 0 106 6c0-.74-.14-1.468-.409-2.164l-.234-.607L16 10.586V7h3.586L22 4.586V2zM8 13a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z",
    className: "primary"
  }));
};

IconPasswordM.displayName = 'IconPasswordM';
IconPasswordM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPasswordM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconPauseL = function IconPauseL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 47C11.297 47 1 36.703 1 24S11.297 1 24 1s23 10.297 23 23-10.297 23-23 23zm0-2c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M18 15h2v18h-2zM28 15h2v18h-2z",
    className: "primary"
  })));
};

IconPauseL.displayName = 'IconPauseL';
IconPauseL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPauseL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconPayGoXL = function IconPayGoXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M63 56c0 4.055-5.891 7-13 7s-13-2.945-13-7V40c0-4.054 5.891-7 13-7 6.992 0 12.807 2.85 12.995 6.802L63 40v16zm-13-1c-4.597 0-8.685-1.232-11-3.199V56c0 2.573 4.854 5 11 5s11-2.427 11-5l.001-4.2C58.686 53.768 54.598 55 50 55zm0-8c-4.597 0-8.685-1.232-11-3.199V48c0 2.573 4.854 5 11 5s11-2.427 11-5l.001-4.2C58.687 45.768 54.598 47 50 47zm0-12c-6.146 0-11 2.427-11 5s4.854 5 11 5 11-2.427 11-5-4.854-5-11-5z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M28 1c14.911 0 27 12.089 27 27h-2C53 14.193 41.807 3 28 3S3 14.193 3 28s11.193 25 25 25c1.3 0 2.585-.099 3.848-.294l.306 1.976A27.142 27.142 0 0128 55C13.089 55 1 42.911 1 28S13.089 1 28 1zm1 13v14a1 1 0 01-1 1H13v-2h14V14h2z",
    className: "secondary"
  })));
};

IconPayGoXL.displayName = 'IconPayGoXL';
IconPayGoXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPayGoXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconPaymentL = function IconPaymentL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M21 31v2H9v-2h12zm18 0v2h-5v-2h5zm8-8v2H1v-2h46zm0-8v2H1v-2h46z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M43 39c1.148 0 2-.852 2-2V11c0-1.148-.852-2-2-2H5c-1.148 0-2 .852-2 2v26c0 1.148.852 2 2 2h38zm0 2H5c-2.252 0-4-1.748-4-4V11c0-2.252 1.748-4 4-4h38c2.252 0 4 1.748 4 4v26c0 2.252-1.748 4-4 4z",
    className: "secondary"
  })));
};

IconPaymentL.displayName = 'IconPaymentL';
IconPaymentL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPaymentL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconPaymentM = function IconPaymentM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M21.913 3C23.639 3 25 4.491 25 6.286v11.428C25 19.51 23.639 21 21.913 21H2.087C.361 21-1 19.509-1 17.714V6.286C-1 4.49.361 3 2.087 3h19.826zM23 10H1v7.714C1 18.443 1.509 19 2.087 19h19.826c.578 0 1.087-.557 1.087-1.286V10zM7 15v2H3v-2h4zm14-3v2h-4v-2h4zm-10 0v2H3v-2h8zm10.913-7H2.087C1.509 5 1 5.557 1 6.286V8h22V6.286C23 5.557 22.491 5 21.913 5z",
    className: "primary"
  }));
};

IconPaymentM.displayName = 'IconPaymentM';
IconPaymentM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPaymentM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconPeopleM = function IconPeopleM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M17 0a3 3 0 013 3v18a3 3 0 01-3 3H0V0zm0 2H2v20h15a1 1 0 001-1V3a1 1 0 00-1-1zm-7 4a3 3 0 013 3v1c0 .603-.178 1.164-.483 1.634l1.283.966a3 3 0 011.193 2.199L15 15v2H5v-2a3 3 0 011.042-2.273l.156-.126 1.285-.967A2.986 2.986 0 017 10V9a3 3 0 013-3zm.847 6.879a3 3 0 01-1.694 0L7.4 14.2a1 1 0 00-.393.683L7 15h6a1 1 0 00-.312-.725l-.09-.076zM10 8a1 1 0 00-1 1v1a1 1 0 002 0V9a1 1 0 00-1-1zm13-4v6h-2V4h2z",
    className: "primary"
  }));
};

IconPeopleM.displayName = 'IconPeopleM';
IconPeopleM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPeopleM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconPerformanceL = function IconPerformanceL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 0c13.256 0 24 10.744 24 24S37.256 48 24 48 0 37.256 0 24 10.744 0 24 0zm0 2C11.848 2 2 11.848 2 24s9.848 22 22 22 22-9.848 22-22S36.152 2 24 2zm12.726 9.274a1 1 0 010 1.414l-9.28 9.281A4.001 4.001 0 1120 24a4.001 4.001 0 016.032-3.446l9.28-9.28a1 1 0 011.415 0zM24 22a2.001 2.001 0 000 4 2.001 2.001 0 000-4z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M33 32a1 1 0 011 1v6a1 1 0 01-1 1H15a1 1 0 01-1-1v-6a1 1 0 011-1h18zm-1 2H16v4h16v-4zm6.24-5.184l3.694 1.532a1 1 0 11-.766 1.847l-3.694-1.532a1 1 0 11.766-1.847zm-27.175.541a1 1 0 01-.541 1.307l-3.696 1.53a1 1 0 01-.765-1.848l3.696-1.53a1 1 0 011.306.541zm-2.178-5.986a1 1 0 010 2h-4a1 1 0 010-2h4zM39 23l3.998.002a1 1 0 01-.002 2L39 25a1 1 0 01.002-2zm3.476-6.652a1 1 0 01-.542 1.306l-3.696 1.53a1 1 0 01-.765-1.848l3.696-1.53a1 1 0 011.307.542zM6.83 15.805l3.694 1.532a1 1 0 01-.766 1.847l-3.694-1.532a1 1 0 01.766-1.847zm4.444-5.947l2.826 2.828a1 1 0 01-1.415 1.413l-2.826-2.828a1 1 0 111.415-1.413zm20.38-4.335a1 1 0 01.541 1.307l-1.532 3.694a1 1 0 01-1.847-.766l1.532-3.694a1 1 0 011.306-.54zm-14 .54l1.53 3.696a1 1 0 01-1.848.765l-1.53-3.696a1 1 0 011.848-.765zm6.233-1.692a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1z",
    className: "primary"
  })));
};

IconPerformanceL.displayName = 'IconPerformanceL';
IconPerformanceL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPerformanceL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconPerformanceM = function IconPerformanceM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM7 5.586l3.706 3.707a3 3 0 11-1.414 1.414L5.587 7 7 5.586zM12 11a.996.996 0 00-.622.217l-.161.161A1 1 0 1012 11z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M20 11v2h-3v-2h3zM7 11v2H4v-2h3zm9.95-5.364l1.414 1.414-2.121 2.121-1.414-1.414 2.121-2.121zM13 4v3h-2V4h2z",
    className: "secondary"
  })));
};

IconPerformanceM.displayName = 'IconPerformanceM';
IconPerformanceM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPerformanceM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconPerformanceXL = function IconPerformanceXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M32 2c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30C15.431 62 2 48.569 2 32 2 15.431 15.431 2 32 2zm0 2C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28S47.464 4 32 4zM16 14.586l13.173 13.173-1.414 1.414L14.586 16 16 14.586z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32 25a7 7 0 110 14 7 7 0 010-14zm0 2a5 5 0 100 10 5 5 0 000-10zm24 4v2h-7v-2h7zm-41 0v2H8v-2h7zm33.263-16.677l1.414 1.414-4.949 4.95-1.414-1.415 4.949-4.95zM33 8v7h-2V8h2z",
    className: "primary"
  })));
};

IconPerformanceXL.displayName = 'IconPerformanceXL';
IconPerformanceXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPerformanceXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconPhoneL = function IconPhoneL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    fillRule: "evenodd",
    d: "M34.293 28.293a1 1 0 011.414 0l10 10a1 1 0 010 1.414l-6 6A1 1 0 0139 46C18.566 46 2 29.434 2 9a1 1 0 01.293-.707l6-6a1 1 0 011.414 0l10 10a1 1 0 010 1.414L14.414 19 29 33.586l5.293-5.293zm-4.586 7.414a1 1 0 01-1.414 0l-16-16a1 1 0 010-1.414L17.586 13 9 4.414 4.002 9.412c.22 19.003 15.583 34.367 34.586 34.586L43.586 39 35 30.414l-5.293 5.293z",
    className: "secondary"
  }));
};

IconPhoneL.displayName = 'IconPhoneL';
IconPhoneL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPhoneL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconPlaneL = function IconPlaneL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M31.47 29.015L20.55 47.31h-6.797l5.46-18.294H9.562L6.286 33.59H.69l2.532-9.28L.69 15.03h5.595l3.276 4.574h9.65L13.753 1.31h6.798l10.92 18.294h11.291c2.538 0 4.548 2.126 4.548 4.706 0 2.581-2.01 4.706-4.548 4.706h-11.29zM16.437 45.31h2.978l10.92-18.294h12.426c1.403 0 2.548-1.2 2.548-2.706s-1.145-2.706-2.548-2.706H30.335L19.415 3.31h-2.978l5.46 18.294H8.534L5.258 17.03H3.31l1.987 7.28-1.987 7.279h1.95l3.275-4.574h13.363l-5.46 18.294z",
    className: "primary"
  }));
};

IconPlaneL.displayName = 'IconPlaneL';
IconPlaneL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPlaneL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconPlaneM = function IconPlaneM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M16.4 15.289h4.306c1.8 0 3.213-1.494 3.213-3.289 0-1.795-1.412-3.289-3.213-3.289h-4.307L11.2 0H5.962l2.6 8.711H6.134l-1.56-2.177H0L1.492 12 0 17.466h4.574l1.56-2.177h2.428L5.962 24h5.237l5.2-8.711zM8.645 22l2.6-8.711h-6.14l-1.56 2.177H2.62L3.565 12l-.946-3.466h.928l1.56 2.177h6.139L8.646 2h1.418l5.2 8.711h5.442c.668 0 1.213.572 1.213 1.289s-.545 1.289-1.213 1.289h-5.442L10.064 22H8.646z",
    className: "primary"
  }));
};

IconPlaneM.displayName = 'IconPlaneM';
IconPlaneM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPlaneM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconPlaneS = function IconPlaneS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M4.483 16L6.82 9.03H2.236L.834 10.774H0L.85 8 0 5.227h.834l1.402 1.742H6.82L4.483 0h1.275l4.674 6.97h4.477C15.51 6.97 16 7.425 16 8c0 .574-.49 1.03-1.09 1.03h-4.478L5.758 16H4.483z",
    className: "primary"
  }));
};

IconPlaneS.displayName = 'IconPlaneS';
IconPlaneS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPlaneS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconPlaneXL = function IconPlaneXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M41.723 37.89h15.93c3.055 0 5.5-2.574 5.5-5.736s-2.445-5.737-5.5-5.737h-15.93l-15-25.263h-7.91l7.5 25.263H11.67l-4.5-6.316H.846l3.272 12.053L.846 44.206H7.17l4.5-6.315h14.645l-7.5 25.263h7.909l15-25.263zm-20.23 23.264l7.5-25.263H10.639l-4.5 6.315H3.461L6.19 32.154 3.461 22.1h2.677l4.5 6.316h18.356l-7.5-25.263h4.09l15 25.263h17.07c1.926 0 3.5 1.657 3.5 3.737s-1.574 3.737-3.5 3.737h-17.07l-15 25.263h-4.09z",
    className: "primary"
  }));
};

IconPlaneXL.displayName = 'IconPlaneXL';
IconPlaneXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPlaneXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconPlayL = function IconPlayL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 47C11.297 47 1 36.703 1 24S11.297 1 24 1s23 10.297 23 23-10.297 23-23 23zm0-2c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M20 30.21L30.092 24 20 17.79v12.42zm-2-16L33.908 24 18 33.79V14.21z",
    className: "primary"
  })));
};

IconPlayL.displayName = 'IconPlayL';
IconPlayL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPlayL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconPlayS = function IconPlayS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M15 0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-4.4 8.8l-4 3c-.6.5-1.6 0-1.6-.8V5a1 1 0 011.6-.8l4 3c.5.4.5 1.2 0 1.6z",
    className: "primary"
  }));
};

IconPlayS.displayName = 'IconPlayS';
IconPlayS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPlayS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconPlayXL = function IconPlayXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M32 63C14.88 63 1 49.12 1 32 1 14.88 14.88 1 32 1c17.12 0 31 13.88 31 31 0 17.12-13.88 31-31 31zm0-2c16.016 0 29-12.984 29-29S48.016 3 32 3 3 15.984 3 32s12.984 29 29 29z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M24 44.178L43.137 32 24 19.822v24.356zM22 46V18a1 1 0 011.537-.844l22 14a1 1 0 010 1.688l-22 14A1 1 0 0122 46z",
    className: "primary"
  })));
};

IconPlayXL.displayName = 'IconPlayXL';
IconPlayXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPlayXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconPowerL = function IconPowerL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M33.496 9.564l-.864-.504 1.008-1.728.864.504C40.974 11.611 45 18.426 45 26c0 11.552-9.448 21-21 21S3 37.552 3 26c0-7.612 4.063-14.518 10.507-18.17l.87-.493.986 1.74-.87.493C8.673 12.868 5 19.112 5 26c0 10.448 8.552 19 19 19s19-8.552 19-19c0-6.854-3.64-13.016-9.504-16.436z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M23 1h2v16h-2z",
    className: "primary"
  })));
};

IconPowerL.displayName = 'IconPowerL';
IconPowerL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPowerL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconPowerS = function IconPowerS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12.666 3.283a7 7 0 11-9.333 0l1.334 1.49a5 5 0 106.666 0l1.333-1.49zM9 .5v7H7v-7h2z",
    className: "primary"
  }));
};

IconPowerS.displayName = 'IconPowerS';
IconPowerS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPowerS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconPrinterM = function IconPrinterM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M19 19v4a1 1 0 01-1 1H6a1 1 0 01-1-1v-4H1a1 1 0 01-1-1v-7c0-3.011 2.136-5.454 5-5.92V1a1 1 0 011-1h12a1 1 0 011 1v4.08c2.864.467 5 2.91 5 5.92v7a1 1 0 01-1 1h-4zm-2-4H7v7h10v-7zm1-6v2h-3V9h3zm-1-7H7v3h10V2zm2 15h3v-6c0-2.248-1.752-4-4-4H6c-2.248 0-4 1.752-4 4v6h3v-3a1 1 0 011-1h12a1 1 0 011 1v3z",
    className: "primary"
  }));
};

IconPrinterM.displayName = 'IconPrinterM';
IconPrinterM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPrinterM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconPrinterXL = function IconPrinterXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M46 2a3 3 0 013 3v11c7.18 0 13 5.82 13 13v17a3 3 0 01-3 3H47.968v.003H16.034L16.032 49H5a3 3 0 01-3-3V29c0-7.18 5.82-13 13-13h1V5a3 3 0 013-3h27zm3 16H16v-.001L15 18C8.925 18 4 22.925 4 29v17a1 1 0 001 1h11.033l-.001 2h31.936v-2H59a1 1 0 001-1V29c0-6.075-4.925-11-11-11zM46 4H19a1 1 0 00-1 1v11h29V5a1 1 0 00-1-1z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M46 37a3 3 0 013 3v19a3 3 0 01-3 3H19a3 3 0 01-3-3V40a3 3 0 013-3h27zm0 2H19a1 1 0 00-1 1v19a1 1 0 001 1h27a1 1 0 001-1V40a1 1 0 00-1-1zM49 29.5H39v-6h10v6zm-2-4h-6v2h6v-2z",
    className: "secondary"
  })));
};

IconPrinterXL.displayName = 'IconPrinterXL';
IconPrinterXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconPrinterXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconQuestionS = function IconQuestionS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 13c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1.5-4.6c-.5.3-.5.4-.5.6v1H7V9c0-1.3.8-1.9 1.4-2.3.5-.3.6-.4.6-.7 0-.6-.4-1-1-1-.4 0-.7.2-.9.5l-.5.9-1.7-1 .5-.9C5.9 3.6 6.9 3 8 3c1.7 0 3 1.3 3 3 0 1.4-.9 2-1.5 2.4z",
    className: "primary"
  }));
};

IconQuestionS.displayName = 'IconQuestionS';
IconQuestionS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconQuestionS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconRebootL = function IconRebootL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M6.457 3.075l1.342 9.902C11.585 7.43 17.968 4 25 4c11.552 0 21 9.448 21 21h-2c0-10.448-8.552-19-19-19-6.633 0-12.617 3.365-15.968 8.747l11.027-1.47.264 1.982-13.98 1.864-1.868-13.78 1.982-.268z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32.499 42.51l.684 1.88-.94.342a21.108 21.108 0 01-6.719 1.262l-1 .024-.048-2 1-.024a19.108 19.108 0 006.083-1.142l.94-.342zm-21.753-4.943l.7.714a19.188 19.188 0 005.122 3.732l.894.447-.893 1.79-.895-.447a21.188 21.188 0 01-5.656-4.122l-.7-.714 1.428-1.4zm31.59-4.903l1.8.872-.436.9a20.271 20.271 0 01-3.45 5.017l-.683.73-1.46-1.368.684-.73a18.271 18.271 0 003.11-4.521l.435-.9zM6 24v1c0 1.949.297 3.86.875 5.688l.3.953-1.906.603-.302-.954A20.85 20.85 0 014 25v-1h2z",
    className: "primary"
  })));
};

IconRebootL.displayName = 'IconRebootL';
IconRebootL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconRebootL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconRecurringPayL = function IconRecurringPayL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M42.802 37.779l1.95.442A10.004 10.004 0 0135 46c-2.7 0-5.182-1.08-7-2.907V46h-2v-6a1 1 0 011-1h6v2l-4.188.001A7.854 7.854 0 0035 44a8.004 8.004 0 007.802-6.221zM44 26v6a1 1 0 01-1 1h-6v-2h4.188A7.854 7.854 0 0035 28a8.004 8.004 0 00-7.802 6.221l-1.95-.442A10.004 10.004 0 0135 26c2.7 0 5.183 1.08 7.001 2.908L42 26h2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M42 1c2.752 0 5 2.248 5 5v14a1 1 0 01-1 1H3v11c0 1.648 1.352 3 3 3h12v2H6c-2.752 0-5-2.248-5-5V6c0-2.752 2.248-5 5-5h36zM18 27v2H9v-2h9zm27-16H3v8h42v-8zm-3-8H6C4.352 3 3 4.352 3 6v3h42V6c0-1.648-1.352-3-3-3z",
    className: "secondary"
  })));
};

IconRecurringPayL.displayName = 'IconRecurringPayL';
IconRecurringPayL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconRecurringPayL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconRefreshL = function IconRefreshL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M43 25h2c0 11.552-9.448 21-21 21S3 36.552 3 25 12.448 4 24 4c7.95 0 15.11 4.5 18.689 11.442l-1.778.916C37.671 10.073 31.191 6 24 6 13.552 6 5 14.552 5 25s8.552 19 19 19 19-8.552 19-19z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M42.742 3.176l1.982.266-1.866 13.882-13.882-1.866.266-1.982 11.9 1.6z",
    className: "primary"
  })));
};

IconRefreshL.displayName = 'IconRefreshL';
IconRefreshL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconRefreshL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconRepeatXL = function IconRepeatXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32 39a7 7 0 110-14 7 7 0 010 14zm0-2a5 5 0 100-10 5 5 0 000 10z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M61 32c0 16.016-12.984 29-29 29-10.295 0-19.774-5.662-24.985-14.361L5.207 60.133l-1.982-.266 2.223-16.59a1 1 0 011.124-.858l16.589 2.223-.266 1.982-14.713-1.971C12.902 53.302 22.052 59 32 59c14.912 0 27-12.088 27-27h2zM32 3c10.295 0 19.774 5.662 24.985 14.361l1.808-13.494 1.982.266-2.223 16.59a1 1 0 01-1.124.858L40.84 19.358l.266-1.982 14.713 1.971C51.098 10.698 41.948 5 32 5 17.088 5 5 17.088 5 32H3C3 15.984 15.984 3 32 3z",
    className: "secondary"
  })));
};

IconRepeatXL.displayName = 'IconRepeatXL';
IconRepeatXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconRepeatXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconResetM = function IconResetM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M3 13c0 4.963 4.037 9 9 9s9-4.037 9-9-4.037-9-9-9c-1.989 0-3.873.65-5.43 1.833l3.604 3.393-9.167.983L1.438 1l3.655 3.442A10.915 10.915 0 0112 2c6.065 0 11 4.935 11 11s-4.935 11-11 11S1 19.065 1 13h2z",
    className: "primary"
  }));
};

IconResetM.displayName = 'IconResetM';
IconResetM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconResetM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconResourcesM = function IconResourcesM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M20 0a2 2 0 011.995 1.85L22 2v6a2 2 0 012 2v12a2 2 0 01-2 2h-6a2 2 0 01-2-2v-4H2a2 2 0 01-1.995-1.85L0 16V2A2 2 0 011.85.005L2 0h18zm2 20h-6v2h6v-2zm-6-2h6v-8h-6v8zM2 14v2h12v-2H2zm0-2h12v-2a2 2 0 011.85-1.995L16 8h4V2H2v10z",
    className: "primary"
  }));
};

IconResourcesM.displayName = 'IconResourcesM';
IconResourcesM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconResourcesM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconRocketXL = function IconRocketXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M53.13 29.998a22.438 22.438 0 01-4.69 24.883 22.395 22.395 0 01-4.488 3.448 1 1 0 01-1.215-.154L33.51 48.95l1.414-1.414 8.669 8.668a20.078 20.078 0 003.43-2.736 20.439 20.439 0 004.274-22.665l1.832-.804zM33.876 10.815l-.792 1.836a20.45 20.45 0 00-22.55 4.323 20.078 20.078 0 00-2.737 3.431l8.63 8.63-1.414 1.415-9.188-9.188a1 1 0 01-.154-1.215 22.395 22.395 0 013.448-4.487 22.45 22.45 0 0124.757-4.745zm6.561-3.257l15.94 15.939-1.414 1.414-15.94-15.939 1.414-1.414z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M9 48a7 7 0 110 14H3a1 1 0 01-1-1v-6a7 7 0 017-7zm0 2a5 5 0 00-5 5v5h5a5 5 0 100-10zM60.948 2.001a1 1 0 011.05 1.056c-.887 15.638-7.256 28.243-17.305 38.072a64.494 64.494 0 01-11.949 9.212 54.143 54.143 0 01-3.95 2.158c-.42.206-.794.38-1.118.525-.198.089-.337.148-.414.18a1 1 0 01-1.085-.219L11.015 37.823a1 1 0 01-.22-1.08c.03-.077.089-.216.176-.414.142-.324.314-.698.517-1.118a53.7 53.7 0 012.13-3.948 63.864 63.864 0 019.123-11.945C32.556 9.205 45.2 2.823 60.948 2.001zm-1.02 2.066C45.24 5.1 33.423 11.184 24.176 20.711a61.879 61.879 0 00-8.837 11.57 51.71 51.71 0 00-2.05 3.8 35.04 35.04 0 00-.379.81l14.197 14.196c.243-.112.512-.24.807-.384a52.152 52.152 0 003.803-2.078A62.508 62.508 0 0043.294 39.7c9.47-9.261 15.542-21.044 16.634-35.632zm-19.07 19.074a6.36 6.36 0 11-8.995 8.996 6.36 6.36 0 018.995-8.996zm-7.581 1.414a4.36 4.36 0 106.167 6.168 4.36 4.36 0 00-6.167-6.168z",
    className: "primary"
  })));
};

IconRocketXL.displayName = 'IconRocketXL';
IconRocketXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconRocketXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconS3L = function IconS3L(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M27.204 7l-7.059 2.355v8.067l-5.039 1.675-6.047-2.015L2 19.437v9.512l.692.234 5.359 1.782v8.066l.688.231 6.367 2.125 7.055-2.356v-8.066l6.05-2.016v-8.062l5.039-1.68 6.051 2.019 7.055-2.355V9.355L39.301 7 33.25 9.019 27.204 7zm0 2.129l4.371 1.457-4.371 1.457-4.372-1.457 4.372-1.457zm12.097 0l4.371 1.457-4.371 1.457-4.371-1.457 4.371-1.457zm-17.14 3.363l4.035 1.336v4.93l-4.035-1.336v-4.93zm10.082 0v4.93l-4.032 1.336v-4.93l4.032-1.336zm2.015 0l4.035 1.336v4.93l-4.035-1.336v-4.93zm10.082 0v4.93l-4.031 1.336v-4.93l4.031-1.336zM9.059 19.207l4.371 1.457-4.371 1.457-4.371-1.457 4.371-1.457zm12.094 0l4.371 1.457-4.371 1.457-4.371-1.457 4.371-1.457zM4.016 22.57l4.035 1.34v4.93L4.016 27.5v-4.93zm10.082 0v4.93l-4.031 1.34v-4.93l4.031-1.34zm2.016 0l4.031 1.34v4.93l-4.031-1.34v-4.93zm10.082 0v4.93l-4.035 1.34v-4.93l4.035-1.34zm-11.09 6.719l4.371 1.457-4.371 1.457-4.371-1.457 4.371-1.457zm-5.039 3.363l4.031 1.34v4.93l-4.031-1.34v-4.93zm10.078 0v4.93l-4.031 1.34v-4.93l4.031-1.34z",
    className: "primary"
  }));
};

IconS3L.displayName = 'IconS3L';
IconS3L.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconS3L.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconSSDL = function IconSSDL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M16 1v7h7V1h2v7h7V1h2v7h3c1.653 0 3 1.349 3 3v3h7v2h-7v7h7v2h-7v7h7v2h-7v3c0 1.653-1.346 3-3 3h-3v7h-2v-7h-7v7h-2v-7h-7v7h-2v-7h-3c-1.652 0-3-1.348-3-3v-3H1v-2h7v-7H1v-2h7v-7H1v-2h7v-3c0-1.65 1.348-3 3-3h3V1h2zm21 9H11c-.547 0-1 .453-1 1v26c0 .548.452 1 1 1h26c.549 0 1-.451 1-1V11c0-.547-.452-1-1-1z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M34 31V17c0-1.648-1.351-3-3-3H17c-1.648 0-3 1.352-3 3v14c0 1.648 1.352 3 3 3h14c1.649 0 3-1.352 3-3zm2 0c0 2.753-2.246 5-5 5H17c-2.752 0-5-2.248-5-5V17c0-2.752 2.248-5 5-5h14c2.754 0 5 2.247 5 5v14z",
    className: "primary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M19 20v-2h8v2zM19 24v-2h4v2zM25 30v-2h4v2z",
    className: "primary"
  })));
};

IconSSDL.displayName = 'IconSSDL';
IconSSDL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSSDL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconSSDM = function IconSSDM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M9 0v3h2V0h2v3h2V0h2v3h1.933A2.07 2.07 0 0121 5.067V7h3v2h-3v2h3v2h-3v2h3v2h-3v1.933A2.07 2.07 0 0118.933 21H17v3h-2v-3h-2v3h-2v-3H9v3H7v-3H5.067A2.07 2.07 0 013 18.933V17H0v-2h3v-2H0v-2h3V9H0V7h3V5.067A2.07 2.07 0 015.067 3H7V0h2zm9.933 5H5.067A.07.07 0 005 5.067v13.866a.07.07 0 00.067.067h13.866a.07.07 0 00.067-.067V5.067A.07.07 0 0018.933 5zm-4.387 2A2.458 2.458 0 0117 9.455v5.09A2.458 2.458 0 0114.546 17H9.454A2.46 2.46 0 017 14.545v-5.09A2.46 2.46 0 019.454 7h5.092zm0 2H9.454A.46.46 0 009 9.455v5.09a.46.46 0 00.454.455h5.092a.458.458 0 00.454-.455v-5.09A.458.458 0 0014.546 9z",
    className: "primary"
  }));
};

IconSSDM.displayName = 'IconSSDM';
IconSSDM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSSDM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconSaveConfigXL = function IconSaveConfigXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M52.502 21.135l10 5.8A1 1 0 0163 27.8V62a1 1 0 01-1 1H2a1 1 0 01-1-1V27.8a1 1 0 01.498-.865l10-5.8 1.004 1.73-8.496 4.927 27.167 15.485 28.778-15.51-8.453-4.902 1.004-1.73zM3 29.521V61h55.227L3 29.521zm58-.047L33.222 44.446 61 60.279V29.474zM43.795 30v2H31.487v-2h12.308zm0-10v2H31.487v-2h12.308zm0-9.667v2H31.487v-2h12.308z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M21.564 28.564a3 3 0 110 6 3 3 0 010-6zM52 1a1 1 0 011 1v31.177h-2V3H13v30.44h-2V2a1 1 0 011-1h40zM21.564 30.564a1 1 0 100 2 1 1 0 000-2zm2.81-13.233l1.487 1.338-4.616 5.128a1 1 0 01-1.459.03l-2.502-2.565 1.432-1.396 1.756 1.8 3.902-4.335zm0-10l1.487 1.338-4.616 5.128a1 1 0 01-1.459.03l-2.502-2.565 1.432-1.396 1.756 1.8 3.902-4.335z",
    className: "primary"
  })));
};

IconSaveConfigXL.displayName = 'IconSaveConfigXL';
IconSaveConfigXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSaveConfigXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconScaleUpL = function IconScaleUpL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M46 1a1 1 0 011 1v44a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h44zM3 45h14V31H3v14zM45 3H3v26h15a1 1 0 011 1v15h26V3z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M38 9a1 1 0 011 1v12h-2v-9.586L23.707 25.707l-1.414-1.414L35.583 11H26V9h12z",
    className: "primary"
  })));
};

IconScaleUpL.displayName = 'IconScaleUpL';
IconScaleUpL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconScaleUpL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconScrollM = function IconScrollM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: "#090B0D",
    fillRule: "evenodd",
    d: "M14 0a6 6 0 016 6v12a6 6 0 01-6 6h-4a6 6 0 01-6-6V6a6 6 0 016-6h4zm0 2h-4a4 4 0 00-4 4v12a4 4 0 004 4h4a4 4 0 004-4V6a4 4 0 00-4-4zm-1 3v7h-2V5h2z"
  }));
};

IconScrollM.displayName = 'IconScrollM';
IconScrollM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconScrollM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconScrubS = function IconScrubS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M15 4h-3V1c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v3H1c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zM6 2h4v2H6V2zm8 12H2V6h12v8z",
    className: "primary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M11 9H9V7H7v2H5v2h2v2h2v-2h2z",
    className: "primary"
  })));
};

IconScrubS.displayName = 'IconScrubS';
IconScrubS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconScrubS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconSearchM = function IconSearchM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M10 2a8 8 0 016.32 12.905l5.387 5.388-1.414 1.414-5.388-5.386A8 8 0 1110 2zm0 2a6 6 0 100 12 6 6 0 000-12z",
    className: "primary"
  }));
};

IconSearchM.displayName = 'IconSearchM';
IconSearchM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSearchM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconSearchS = function IconSearchS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12.7 11.3c.9-1.2 1.4-2.6 1.4-4.2 0-3.9-3.1-7.1-7-7.1S0 3.2 0 7.1c0 3.9 3.2 7.1 7.1 7.1 1.6 0 3.1-.5 4.2-1.4l3 3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-3-3.1zm-5.6.8c-2.8 0-5.1-2.2-5.1-5S4.3 2 7.1 2s5.1 2.3 5.1 5.1-2.3 5-5.1 5z",
    className: "primary"
  }));
};

IconSearchS.displayName = 'IconSearchS';
IconSearchS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSearchS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconSecureL = function IconSecureL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M25 4v19h16.807v2H25v19h-2V25H6.193v-2H23V4h2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M23.445 3.168a1 1 0 011.11 0C30.01 6.805 37.692 9 44 9a1 1 0 011 1c0 15.833-7.234 29.188-20.606 34.92a1 1 0 01-.788 0C10.234 39.187 3 25.832 3 10a1 1 0 011-1c6.308 0 13.99-2.195 19.445-5.832zM24 5.193c-5.451 3.457-12.725 5.58-18.99 5.79C5.297 25.479 11.956 37.55 24 42.909c12.044-5.358 18.703-17.43 18.99-31.926-6.265-.21-13.539-2.333-18.99-5.79z",
    className: "secondary"
  })));
};

IconSecureL.displayName = 'IconSecureL';
IconSecureL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSecureL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconSerialM = function IconSerialM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M24 12v12h-2V14h-2v5h-5v-5h-2v5h-2v-5H9v5H4v-5H2v10H0V12h24zM20 0v10h-5V0h5zM9 0v10H4V0h5zM2 0v10H0V0h2zm11 0v10h-2V0h2zm11 0v10h-2V0h2z",
    className: "primary"
  }));
};

IconSerialM.displayName = 'IconSerialM';
IconSerialM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSerialM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconSettingsAdvancedL = function IconSettingsAdvancedL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: "#090B0D",
    fillRule: "evenodd",
    d: "M17 33v14H7v-6H1v-2h6v-6h10zM9 45h6V35H9v10zm38-6v2H21v-2h26zM37 17v14H27v-6H1v-2h26v-6h10zm-2 2h-6v10h6V19zm12 4v2h-6v-2h6zM17 1v14H7V9H1V7h6V1h10zm-2 2H9v10h6V3zm32 4v2H21V7h26z"
  }));
};

IconSettingsAdvancedL.displayName = 'IconSettingsAdvancedL';
IconSettingsAdvancedL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSettingsAdvancedL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconSettingsL = function IconSettingsL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M24 31a7 7 0 110-14 7 7 0 010 14zm0-2a5 5 0 100-10 5 5 0 000 10z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M47 20.08v7.84l-6.608.551a16.864 16.864 0 01-1.643 3.955l4.287 5.065-5.545 5.545-5.065-4.287a16.88 16.88 0 01-3.955 1.643L27.921 47H20.08l-.551-6.608a16.864 16.864 0 01-3.955-1.643l-5.065 4.287-5.545-5.545 4.287-5.065a16.88 16.88 0 01-1.643-3.955L1 27.921V20.08l6.608-.551c.377-1.385.93-2.711 1.643-3.955l-4.287-5.065 5.545-5.545 5.065 4.287a16.88 16.88 0 013.955-1.643L20.079 1h7.841l.551 6.608c1.385.377 2.711.93 3.955 1.643l5.065-4.287 5.545 5.545-4.287 5.065a16.88 16.88 0 011.643 3.955l6.608.55zm-2 1.84l-6.219-.518-.161-.716a14.888 14.888 0 00-1.942-4.677l-.392-.62 4.034-4.768L37.38 7.68l-4.768 4.034-.62-.392a14.875 14.875 0 00-4.677-1.942l-.716-.161L26.08 3h-4.16l-.518 6.219-.716.161a14.888 14.888 0 00-4.677 1.942l-.62.392L10.62 7.68 7.68 10.62l4.034 4.768-.392.62a14.875 14.875 0 00-1.942 4.677l-.161.716L3 21.92v4.16l6.219.518.161.716a14.888 14.888 0 001.942 4.677l.392.62L7.68 37.38l2.941 2.941 4.768-4.034.62.392c1.44.91 3.016 1.567 4.677 1.942l.716.161L21.92 45h4.16l.518-6.219.716-.161a14.888 14.888 0 004.677-1.942l.62-.392 4.768 4.034 2.941-2.941-4.034-4.768.392-.62a14.875 14.875 0 001.942-4.677l.161-.716L45 26.08v-4.16z",
    className: "secondary"
  })));
};

IconSettingsL.displayName = 'IconSettingsL';
IconSettingsL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSettingsL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconSettingsM = function IconSettingsM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M14 0a1 1 0 011 1v2.523c.298.105.59.226.874.361l1.783-1.783a1 1 0 011.414 0L21.9 4.929a1 1 0 010 1.414l-1.783 1.783c.135.285.256.576.361.874H23a1 1 0 011 1v4a1 1 0 01-1 1h-2.523c-.105.298-.225.59-.361.874l1.783 1.783a1 1 0 010 1.414L19.071 21.9a1 1 0 01-1.414 0l-1.783-1.783a8.958 8.958 0 01-.874.361V23a1 1 0 01-1 1h-4a1 1 0 01-1-1v-2.523a8.948 8.948 0 01-.874-.361l-1.783 1.783a1 1 0 01-1.414 0L2.1 19.071a1 1 0 010-1.414l1.783-1.783A8.958 8.958 0 013.523 15H1a1 1 0 01-1-1v-4a1 1 0 011-1h2.523c.105-.298.226-.59.361-.874L2.101 6.343a1 1 0 010-1.414L4.929 2.1a1 1 0 011.414 0l1.783 1.783c.285-.135.576-.256.874-.361V1a1 1 0 011-1h4zm-1 2h-2v2.262a1 1 0 01-.75.968 6.968 6.968 0 00-1.8.745 1 1 0 01-1.215-.154L5.636 4.222 4.222 5.636l1.6 1.599a1 1 0 01.153 1.215 6.968 6.968 0 00-.745 1.8 1 1 0 01-.968.75H2v2h2.262a1 1 0 01.968.75c.164.636.415 1.24.745 1.8a1 1 0 01-.154 1.215l-1.599 1.599 1.414 1.414 1.599-1.6a1 1 0 011.216-.153c.558.33 1.162.58 1.799.745a1 1 0 01.75.968V22h2v-2.262a1 1 0 01.75-.968 6.968 6.968 0 001.8-.745 1 1 0 011.215.154l1.599 1.599 1.414-1.414-1.6-1.599a1 1 0 01-.153-1.216c.33-.558.58-1.162.745-1.799a1 1 0 01.968-.75H22v-2h-2.262a1 1 0 01-.968-.75 6.968 6.968 0 00-.745-1.8 1 1 0 01.154-1.215l1.599-1.599-1.414-1.414-1.599 1.6a1 1 0 01-1.215.153 6.968 6.968 0 00-1.8-.745 1 1 0 01-.75-.968V2zm-1 6a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z",
    className: "primary"
  }));
};

IconSettingsM.displayName = 'IconSettingsM';
IconSettingsM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSettingsM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconSettingsS = function IconSettingsS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M13.3 5.2l1.1-2.1L13 1.7l-2.1 1.1c-.3-.2-.7-.3-1.1-.4L9 0H7l-.8 2.3c-.3.1-.7.2-1 .4L3.1 1.6 1.6 3.1l1.1 2.1c-.2.3-.3.7-.4 1L0 7v2l2.3.8c.1.4.3.7.4 1.1L1.6 13 3 14.4l2.1-1.1c.3.2.7.3 1.1.4L7 16h2l.8-2.3c.4-.1.7-.3 1.1-.4l2.1 1.1 1.4-1.4-1.1-2.1c.2-.3.3-.7.4-1.1L16 9V7l-2.3-.8c-.1-.3-.2-.7-.4-1zM8 11c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z",
    className: "primary"
  }));
};

IconSettingsS.displayName = 'IconSettingsS';
IconSettingsS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSettingsS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconSettingsXL = function IconSettingsXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32 41a9 9 0 110-18 9 9 0 010 18zm0-2a7 7 0 100-14 7 7 0 000 14z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M63 38a1 1 0 01-1 1h-6.12c-1.151 0-2.177.678-2.653 1.829a2.845 2.845 0 00.608 3.108l4.328 4.328a1 1 0 010 1.414l-8.485 8.485a1 1 0 01-1.414 0l-4.328-4.328c-.811-.811-2.009-1.06-3.157-.588A2.846 2.846 0 0039 55.88V62a1 1 0 01-1 1H26a1 1 0 01-1-1v-6.12c0-1.153-.7-2.19-1.779-2.633-1.15-.472-2.347-.222-3.157.588l-4.328 4.328a1 1 0 01-1.414 0l-8.485-8.485a1 1 0 010-1.414l4.328-4.328a2.845 2.845 0 00.608-3.108C10.297 39.677 9.27 39 8.12 39H2a1 1 0 01-1-1V26a1 1 0 011-1h6.12c1.15 0 2.177-.678 2.653-1.828a2.845 2.845 0 00-.608-3.108l-4.328-4.328a1 1 0 010-1.414l8.485-8.485a1 1 0 011.414 0l4.328 4.328a2.845 2.845 0 003.108.608C24.323 10.297 25 9.27 25 8.12V2a1 1 0 011-1h12a1 1 0 011 1v6.12c0 1.153.7 2.19 1.779 2.633 1.15.472 2.347.222 3.157-.588l4.328-4.328a1 1 0 011.414 0l8.485 8.485a1 1 0 010 1.414l-4.328 4.328a2.845 2.845 0 00-.608 3.108C53.703 24.323 54.73 25 55.88 25H62a1 1 0 011 1v12zm-2-11h-5.12c-1.954 0-3.714-1.16-4.501-3.064a4.845 4.845 0 011.042-5.286l3.62-3.621-7.07-7.07-3.62 3.62c-1.377 1.377-3.43 1.804-5.332 1.024A4.849 4.849 0 0137 8.12V3H27v5.12c0 1.954-1.16 3.714-3.064 4.501a4.845 4.845 0 01-5.286-1.042l-3.621-3.62-7.07 7.07 3.62 3.62a4.845 4.845 0 011.042 5.287C11.834 25.84 10.076 27 8.12 27H3v10h5.12c1.954 0 3.714 1.16 4.501 3.064a4.845 4.845 0 01-1.042 5.286l-3.62 3.621 7.07 7.07 3.62-3.62c1.377-1.377 3.43-1.804 5.332-1.024A4.849 4.849 0 0127 55.88V61h10v-5.12a4.846 4.846 0 013.02-4.482c1.899-.78 3.952-.354 5.33 1.024l3.621 3.62 7.07-7.07-3.62-3.62a4.845 4.845 0 01-1.042-5.287C52.165 38.162 53.924 37 55.88 37H61V27z",
    className: "secondary"
  })));
};

IconSettingsXL.displayName = 'IconSettingsXL';
IconSettingsXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSettingsXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconShareAddL = function IconShareAddL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M37 24c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 2a8 8 0 100 16 8 8 0 000-16zm1 4v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M23 29v2H3.1c.463 2.282 2.48 4 4.9 4h15v2H8a7 7 0 01-7-7v-1h22zM38 4a5 5 0 015 5v11h-2V9a3 3 0 00-3-3H10a3 3 0 00-3 3v17H5V9a5 5 0 015-5h28zM24 19c2.187 0 4.028.366 5.536.992.788.326 1.444 1.22 1.88 2.265a12.94 12.94 0 00-1.763 1.016c-.252-.71-.598-1.316-.882-1.433C27.505 21.314 25.924 21 24 21s-3.504.314-4.77.839c-.379.157-.867 1.178-1.098 2.161l10.562-.001a13.078 13.078 0 00-1.94 2L16 26v-1c0-1.861 1.007-4.405 2.463-5.009C19.973 19.366 21.813 19 24 19zm0-11a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z",
    className: "secondary"
  })));
};

IconShareAddL.displayName = 'IconShareAddL';
IconShareAddL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconShareAddL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconSharePauseL = function IconSharePauseL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M37 24c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 2a8 8 0 100 16 8 8 0 000-16zm-1 4v8h-2v-8h2zm4 0v8h-2v-8h2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M23 29v2H3.1c.463 2.282 2.48 4 4.9 4h15v2H8a7 7 0 01-7-7v-1h22zM38 4a5 5 0 015 5v11h-2V9a3 3 0 00-3-3H10a3 3 0 00-3 3v17H5V9a5 5 0 015-5h28zM24 19c2.187 0 4.028.366 5.536.992.788.326 1.444 1.22 1.88 2.265a12.94 12.94 0 00-1.763 1.016c-.252-.71-.598-1.316-.882-1.433C27.505 21.314 25.924 21 24 21s-3.504.314-4.77.839c-.379.157-.867 1.178-1.098 2.161l10.562-.001a13.078 13.078 0 00-1.94 2L16 26v-1c0-1.861 1.007-4.405 2.463-5.009C19.973 19.366 21.813 19 24 19zm0-11a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z",
    className: "secondary"
  })));
};

IconSharePauseL.displayName = 'IconSharePauseL';
IconSharePauseL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSharePauseL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconShareRefreshL = function IconShareRefreshL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M44.802 35.779l1.95.442A10.004 10.004 0 0137 44c-2.7 0-5.182-1.08-7-2.907V45h-2v-8h8v2l-5.188.001A7.854 7.854 0 0037 42a8.004 8.004 0 007.802-6.221zM46 23v8h-8v-2h4.965a7.854 7.854 0 00-6.188-3 8.004 8.004 0 00-7.802 6.221l-1.95-.442A10.004 10.004 0 0136.777 24a9.84 9.84 0 017.224 3.14L44 23h2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M23 29v2H3.1c.463 2.282 2.48 4 4.9 4h15v2H8a7 7 0 01-7-7v-1h22zM38 4a5 5 0 015 5v11h-2V9a3 3 0 00-3-3H10a3 3 0 00-3 3v17H5V9a5 5 0 015-5h28zM24 19c2.187 0 4.028.366 5.536.992.788.326 1.444 1.22 1.88 2.265a12.94 12.94 0 00-1.763 1.016c-.252-.71-.598-1.316-.882-1.433C27.505 21.314 25.924 21 24 21s-3.504.314-4.77.839c-.379.157-.867 1.178-1.098 2.161l10.562-.001a13.078 13.078 0 00-1.94 2L16 26v-1c0-1.861 1.007-4.405 2.463-5.009C19.973 19.366 21.813 19 24 19zm0-11a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z",
    className: "secondary"
  })));
};

IconShareRefreshL.displayName = 'IconShareRefreshL';
IconShareRefreshL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconShareRefreshL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconShareRemoveL = function IconShareRemoveL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M22.322 31H3.1c.463 2.282 2.48 4 4.9 4h14.035c.048.682.145 1.35.287 2H8a7 7 0 01-7-7v-1h21.92a13.892 13.892 0 00-.598 2zM38 4a5 5 0 015 5v11h-2V9a3 3 0 00-3-3H10a3 3 0 00-3 3v17H5V9a5 5 0 015-5h28zM24 19c2.187 0 4.028.366 5.536.992.448.185.854.554 1.2 1.03-.635.26-1.247.562-1.831.906a.473.473 0 00-.134-.088C27.505 21.314 25.924 21 24 21s-3.504.314-4.77.839c-.379.157-.867 1.178-1.098 2.161h8.07a14.073 14.073 0 00-1.692 1.999L16 26v-1c0-1.861 1.007-4.405 2.463-5.009C19.973 19.366 21.813 19 24 19zm0-11a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M37 24c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 2a8 8 0 100 16 8 8 0 000-16zm2.121 4.464l1.415 1.415L38.414 34l2.122 2.121-1.415 1.415L37 35.414l-2.121 2.122-1.415-1.415L35.586 34l-2.122-2.121 1.415-1.415L37 32.586l2.121-2.122z",
    className: "primary"
  })));
};

IconShareRemoveL.displayName = 'IconShareRemoveL';
IconShareRemoveL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconShareRemoveL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconShareSettingsL = function IconShareSettingsL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M37 23l.001 3.062a7.96 7.96 0 013.905 1.618l2.165-2.165 1.414 1.414-2.164 2.166A7.96 7.96 0 0143.938 33H47v2l-3.062.001a7.96 7.96 0 01-1.617 3.904l2.164 2.166-1.414 1.414-2.166-2.164A7.96 7.96 0 0137 41.938L37 45h-2v-3.062a7.96 7.96 0 01-3.905-1.617l-2.166 2.164-1.414-1.414 2.165-2.165A7.96 7.96 0 0128.062 35L25 35v-2h3.062a7.96 7.96 0 011.618-3.906l-2.165-2.165 1.414-1.414 2.165 2.165A7.96 7.96 0 0135 26.062V23h2zm-1 5a6 6 0 100 12 6 6 0 000-12zm0 4a2 2 0 110 4 2 2 0 010-4z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M22.322 31H3.1c.463 2.282 2.48 4 4.9 4h14.035c.048.682.145 1.35.287 2H8a7 7 0 01-7-7v-1h21.92a13.892 13.892 0 00-.598 2zM38 4a5 5 0 015 5v11h-2V9a3 3 0 00-3-3H10a3 3 0 00-3 3v17H5V9a5 5 0 015-5h28zM24 19c2.187 0 4.028.366 5.536.992.448.185.854.554 1.2 1.03-.635.26-1.247.562-1.831.906a.473.473 0 00-.134-.088C27.505 21.314 25.924 21 24 21s-3.504.314-4.77.839c-.379.157-.867 1.178-1.098 2.161h8.07a14.073 14.073 0 00-1.692 1.999L16 26v-1c0-1.861 1.007-4.405 2.463-5.009C19.973 19.366 21.813 19 24 19zm0-11a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z",
    className: "secondary"
  })));
};

IconShareSettingsL.displayName = 'IconShareSettingsL';
IconShareSettingsL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconShareSettingsL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconSharesM = function IconSharesM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M24 19v2H0v-2h24zM22 2v15h-2V4H4v13H2V2h20zM12 6a3 3 0 013 3v1c0 .603-.178 1.164-.483 1.634l1.283.966A2.999 2.999 0 0117 15v2H7v-2c0-.945.444-1.833 1.198-2.399l1.285-.967A2.987 2.987 0 019 10V9a3 3 0 013-3zm0 7c-.294 0-.578-.042-.847-.121L9.4 14.2a.999.999 0 00-.4.8h6a1 1 0 00-.402-.801l-1.751-1.32A3.002 3.002 0 0112 13zm0-5a1 1 0 00-1 1v1a1 1 0 102 0V9a1 1 0 00-1-1z",
    className: "primary"
  }));
};

IconSharesM.displayName = 'IconSharesM';
IconSharesM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSharesM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconShieldXL = function IconShieldXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M33 1.333v28.333H58.58v2H33l.001 31h-2v-31H5.332v-2H31L31 1.333h2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M45.297 6.721c4.15 0 8.129-1.56 12.798-4.82a1 1 0 011.572.82V42.22a1 1 0 01-.035.265c-.226.82-.793 2.19-1.831 3.927-1.71 2.858-4.15 5.707-7.447 8.358-4.644 3.733-10.619 6.766-18.083 8.858a1 1 0 01-.54 0c-7.466-2.092-13.442-5.125-18.086-8.858-3.297-2.651-5.737-5.5-7.445-8.359-1.038-1.736-1.605-3.107-1.83-3.926a1 1 0 01-.036-.265V2.721a1 1 0 011.573-.82c4.657 3.258 8.64 4.82 12.79 4.82 4.988 0 9.502-2.195 12.49-6.006a1 1 0 01.787-.383h.045a1 1 0 01.787.383c2.988 3.81 7.505 6.006 12.49 6.006zm0 2c-5.192 0-9.951-2.13-13.3-5.861-3.35 3.733-8.107 5.861-13.3 5.861-4.123 0-8.037-1.362-12.363-4.126v37.479c.054.167.148.43.291.776.315.76.74 1.612 1.291 2.535 1.59 2.66 3.875 5.327 6.982 7.826 4.375 3.517 10.02 6.398 17.103 8.415 7.08-2.017 12.725-4.898 17.1-8.415 3.108-2.499 5.393-5.167 6.983-7.826.552-.923.977-1.775 1.292-2.536.143-.346.238-.608.291-.775V4.593c-4.335 2.767-8.246 4.128-12.37 4.128zm-13.3-7.371l-.023.018v.964h.045v-.964l-.022-.018z",
    className: "secondary"
  })));
};

IconShieldXL.displayName = 'IconShieldXL';
IconShieldXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconShieldXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconSoCL = function IconSoCL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M17 42v6h-2v-6h2zm8 0v6h-2v-6h2zm8 0v6h-2v-6h2zm15-11v2h-6v-2h6zM6 31v2H0v-2h6zm42-8v2h-6v-2h6zM6 23v2H0v-2h6zm42-8v2h-6v-2h6zM6 15v2H0v-2h6zM17 0v6h-2V0h2zm8 0v6h-2V0h2zm8 0v6h-2V0h2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M38 5a5 5 0 015 5v28a5 5 0 01-5 5H10a5 5 0 01-5-5V10a5 5 0 015-5h28zm0 2H10a3 3 0 00-3 3v28a3 3 0 003 3h28a3 3 0 003-3V10a3 3 0 00-3-3z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M30 25a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z",
    className: "secondary"
  })));
};

IconSoCL.displayName = 'IconSoCL';
IconSoCL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSoCL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconSoCM = function IconSoCM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M9 20v4H7v-4h2zm8 0v4h-2v-4h2zm-4 0v4h-2v-4h2zm11-5v2h-4v-2h4zM4 15v2H0v-2h4zm20-4v2h-4v-2h4zM4 11v2H0v-2h4zm20-4v2h-4V7h4zM4 7v2H0V7h4zm5-7v4H7V0h2zm8 0v4h-2V0h2zm-4 0v4h-2V0h2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M5 2h14a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3V5a3 3 0 013-3zm0 2a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V5a1 1 0 00-1-1H5z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M15 18a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2z",
    className: "secondary"
  })));
};

IconSoCM.displayName = 'IconSoCM';
IconSoCM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSoCM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconSoCS = function IconSoCS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M6 0v2h.999L7 0h2l-.001 2H10V0h2v2h.2A1.8 1.8 0 0114 3.8V4h2v2h-2v1h2v2h-2v1h2v2h-2v.2a1.8 1.8 0 01-1.8 1.8H12v2h-2v-2H8.999L9 16H7l-.001-2H6v2H4v-2h-.2A1.8 1.8 0 012 12.2V12H0v-2h2V9H0V7h2V6H0V4h2v-.2A1.8 1.8 0 013.8 2H4V0h2zm5.382 4H4.619A.619.619 0 004 4.619v6.775c0 .341.277.618.619.618h6.763a.619.619 0 00.619-.618V4.619A.619.619 0 0011.382 4zM9.5 8a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    className: "primary"
  }));
};

IconSoCS.displayName = 'IconSoCS';
IconSoCS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSoCS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconSortS = function IconSortS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M4 7l4-5 4 5zM4 9l4 5 4-5z",
    className: "primary"
  })));
};

IconSortS.displayName = 'IconSortS';
IconSortS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSortS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconSpecsL = function IconSpecsL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M11 8v2H7v35h34V10h-4V8h6v39H5V8h6zm13-7a6.002 6.002 0 015.917 5H34v8H14V6h4.083A6.002 6.002 0 0124 1zm0 2a4 4 0 00-4 4v1h-4v4h16V8h-4V7a4 4 0 00-4-4z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M14 23v-2h20v2zM14 30v-2h20v2zM14 37v-2h9v2z",
    className: "primary"
  })));
};

IconSpecsL.displayName = 'IconSpecsL';
IconSpecsL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSpecsL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconSpecsM = function IconSpecsM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M4 2v2H3v18h18V4h-1V2h2a1 1 0 011 1v20a1 1 0 01-1 1H2a1 1 0 01-1-1V3a1 1 0 011-1h2zm13 14v2H7v-2h10zm0-5v2H7v-2h10zm0-11a1 1 0 011 1v6a1 1 0 01-1 1h-3a1 1 0 01-1-1 1 1 0 10-2 0 1 1 0 01-1 1H7a1 1 0 01-1-1V1a1 1 0 011-1h10zm-1 2H8v4h1.17a3 3 0 015.66 0H16V2z",
    className: "primary"
  }));
};

IconSpecsM.displayName = 'IconSpecsM';
IconSpecsM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSpecsM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconStorageL = function IconStorageL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 37a5 5 0 100-10 5 5 0 000 10zm0-2a3 3 0 110-6 3 3 0 010 6z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M36.553 7L47 23.627v17.288H1V23.627L11.447 7h25.106zM37 25H3v11h7v2.915h35V28h-8v-3zM35.447 9H12.553L3.756 23h40.488L35.447 9z",
    className: "primary"
  })));
};

IconStorageL.displayName = 'IconStorageL';
IconStorageL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconStorageL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconStorageM = function IconStorageM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M18 3a1 1 0 01.848.47l5 8A1 1 0 0124 12v8a1 1 0 01-1 1H1a1 1 0 01-1-1v-8a1 1 0 01.152-.53l5-8A1 1 0 016 3h12zm0 10H2v4h4v2h16v-4h-4v-2zm-6 1a2 2 0 110 4 2 2 0 010-4zm5.446-9H6.554l-3.75 6h18.392l-3.75-6z",
    className: "primary"
  }));
};

IconStorageM.displayName = 'IconStorageM';
IconStorageM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconStorageM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconSubtractM = function IconSubtractM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M20 11v2H4v-2z",
    className: "primary"
  }));
};

IconSubtractM.displayName = 'IconSubtractM';
IconSubtractM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSubtractM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconSubtractS = function IconSubtractS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M2 7h12v2H2z",
    className: "primary"
  }));
};

IconSubtractS.displayName = 'IconSubtractS';
IconSubtractS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSubtractS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconSummaryM = function IconSummaryM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M17 0a1 1 0 011 1h4a1 1 0 011 1v21a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h4a1 1 0 011-1h10zm1 7a1 1 0 01-1 1h-3a1 1 0 01-1-1 1 1 0 10-2 0 1 1 0 01-1 1H7a1 1 0 01-1-1V3H3v19h18V3h-3v4zm-3.707 5.293l1.414 1.414-4 4a1 1 0 01-1.414 0l-2-2 1.414-1.414L11 15.586l3.293-3.293zM16 2H8v4h1.17a3 3 0 015.66 0H16V2z",
    className: "primary"
  }));
};

IconSummaryM.displayName = 'IconSummaryM';
IconSummaryM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSummaryM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconSunM = function IconSunM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M13 21v3h-2v-3h2zm6.1-3.314l2.114 2.114-1.414 1.414-2.114-2.114 1.414-1.414zm-14.2 0L6.314 19.1 4.2 21.214 2.786 19.8 4.9 17.686zM12 5a7 7 0 110 14 7 7 0 010-14zm0 2a5 5 0 100 10 5 5 0 000-10zm-9 4v2H0v-2h3zm21 0v2h-3v-2h3zM4.2 2.786L6.314 4.9 4.9 6.314 2.786 4.2 4.2 2.786zm15.6 0L21.214 4.2 19.1 6.314 17.686 4.9 19.8 2.786zM13 0v3h-2V0h2z",
    className: "primary"
  }));
};

IconSunM.displayName = 'IconSunM';
IconSunM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSunM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconSunS = function IconSunS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M9 14v2H7v-2h2zm3.949-2.395l1.415 1.413-1.414 1.415-1.415-1.414 1.414-1.414zm-9.968-.07l1.414 1.415-1.415 1.413-1.414-1.414 1.415-1.414zM8 4c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm8 3v2h-2V7h2zM2 7v2H0V7h2zm1.05-5.293L4.465 3.12 3.05 4.535 1.636 3.121 3.05 1.707zm9.83-.07l1.414 1.415-1.415 1.413-1.414-1.414 1.415-1.414zM9 0v2H7V0h2z",
    className: "primary"
  }));
};

IconSunS.displayName = 'IconSunS';
IconSunS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSunS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconSupportCallL = function IconSupportCallL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M45 34v6a7 7 0 01-7 7H28v-2h10a5 5 0 005-5v-6h2zM24 1c11.598 0 21 9.402 21 21v2h-2v-2c0-10.494-8.506-19-19-19S5 11.506 5 22v2H3v-2C3 10.402 12.402 1 24 1z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M14 23a1 1 0 011 1v14a1 1 0 01-1 1H8a5 5 0 01-5-5V24a1 1 0 011-1h10zm-1 2H5v9a3 3 0 003 3h5V25zM44 23a1 1 0 011 1v10a5 5 0 01-5 5h-6a1 1 0 01-1-1V24a1 1 0 011-1h10zm-1 2h-8v12h5a3 3 0 003-3v-9z",
    className: "primary"
  })));
};

IconSupportCallL.displayName = 'IconSupportCallL';
IconSupportCallL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSupportCallL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconSupportCallM = function IconSupportCallM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M23 20a4 4 0 01-4 4h-6v-2h6a2 2 0 002-2l.001-.171c-.313.11-.65.171-1.001.171h-4v-9h5a9 9 0 00-9-9 9 9 0 00-9 9h5v9H4a3 3 0 01-3-3v-6C1 4.925 5.925 0 12 0s11 4.925 11 11v9zM6 13H3v4a1 1 0 001 1h2v-5zm15 0h-3v5h2a1 1 0 001-1v-4z",
    className: "primary"
  }));
};

IconSupportCallM.displayName = 'IconSupportCallM';
IconSupportCallM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSupportCallM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconSupportL = function IconSupportL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M28.176 32.419l8.813 8.813-1.414 1.414-8.813-8.813 1.414-1.414zm-8.706-.001l1.414 1.414-8.813 8.814-1.414-1.414 8.813-8.814zm14.362-5.656l8.814 8.813-1.414 1.414-8.814-8.813 1.414-1.414zm-20.019 0l1.414 1.414-8.813 8.813L5 35.575l8.813-8.813zM6.414 10.657l8.814 8.813-1.414 1.414L5 12.071l1.414-1.414zm34.818 0l1.414 1.414-8.813 8.813-1.414-1.414 8.813-8.813zM35.575 5l1.414 1.414-8.813 8.814-1.414-1.414L35.575 5zM12.071 5l8.813 8.813-1.414 1.414-8.813-8.813L12.071 5z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M40.263 7.736c8.982 8.982 8.982 23.545 0 32.527s-23.545 8.982-32.527 0c-8.981-8.982-8.981-23.545 0-32.527 8.982-8.981 23.545-8.981 32.527 0zM9.151 9.151C.95 17.35.95 30.648 9.15 38.849c8.2 8.2 21.497 8.2 29.698 0 8.2-8.201 8.2-21.497 0-29.698C30.648.95 17.352.95 9.15 9.15zm22.627 7.07c4.296 4.296 4.296 11.261 0 15.557-4.296 4.296-11.26 4.296-15.556 0-4.296-4.296-4.296-11.26 0-15.556 4.295-4.296 11.26-4.296 15.556 0zm-14.142 1.415a9 9 0 1012.728 12.728 9 9 0 00-12.728-12.728z",
    className: "secondary"
  })));
};

IconSupportL.displayName = 'IconSupportL';
IconSupportL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSupportL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconSupportM = function IconSupportM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M13.5-.5a1 1 0 011 1v.272A11.515 11.515 0 0123.227 9.5h.273a1 1 0 011 1v3a1 1 0 01-1 1h-.274a11.513 11.513 0 01-8.726 8.727v.273a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.273A11.514 11.514 0 01.772 14.5H.5a1 1 0 01-1-1v-3a1 1 0 011-1h.272A11.515 11.515 0 019.5.771L9.5.5a1 1 0 011-1h3zM12 18c-.168 0-.335-.007-.5-.02v4.52h1v-4.52c-.164.013-.331.02-.5.02zm9.167-3.5h-3.711a6.026 6.026 0 01-2.956 2.955v3.712a9.518 9.518 0 006.667-6.666zm-14.623 0H2.831A9.519 9.519 0 009.5 21.168v-3.711A6.023 6.023 0 016.544 14.5zM12 8a4 4 0 100 8 4 4 0 000-8zm10.5 3.5h-4.52a6.081 6.081 0 010 1h4.52v-1zm-16.48 0H1.5v1h4.52a6.08 6.08 0 010-1zm-3.189-2h3.713A6.02 6.02 0 019.5 6.544V2.83a9.52 9.52 0 00-6.669 6.67zm11.67-6.668v3.712A6.023 6.023 0 0117.456 9.5h3.711a9.52 9.52 0 00-6.666-6.668zM12.5 1.5h-1v4.52a6.086 6.086 0 011 0V1.5z",
    className: "primary"
  }));
};

IconSupportM.displayName = 'IconSupportM';
IconSupportM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSupportM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconSupportXL = function IconSupportXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M58.724 35.859l1.98.282C58.889 48.843 48.842 58.89 36.14 60.705l-.283-1.98c11.822-1.69 21.178-11.045 22.867-22.866zM5.27 35.857c1.695 11.826 11.049 21.18 22.871 22.867l-.282 1.98C15.156 58.892 5.11 48.846 3.29 36.14l1.98-.284zM32 17.667c7.916 0 14.333 6.416 14.333 14.333 0 7.913-6.419 14.333-14.333 14.333-7.918 0-14.333-6.418-14.333-14.333 0-7.919 6.414-14.333 14.333-14.333zm0 2c-6.815 0-12.333 5.519-12.333 12.333 0 6.81 5.52 12.333 12.333 12.333 6.81 0 12.333-5.524 12.333-12.333 0-6.812-5.522-12.333-12.333-12.333zM36.142 3.29C48.844 5.11 58.887 15.154 60.705 27.86l-1.98.283C57.033 16.317 47.68 6.963 35.858 5.27l.284-1.98zm-8.282 0l.283 1.979C16.315 6.964 6.963 16.316 5.271 28.142l-1.98-.284C5.11 15.153 15.152 5.111 27.86 3.29z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M29 44.708v16.958h6V44.708h2v17.958a1 1 0 01-1 1h-8a1 1 0 01-1-1V44.708h2zM19.207 27v2H2.333v6H19.25v2H1.333a1 1 0 01-1-1v-8a1 1 0 011-1h17.874zm43.459 0a1 1 0 011 1v8a1 1 0 01-1 1h-18v-2h17v-6H44.708v-2h17.958zM36 .333a1 1 0 011 1v17.96h-2V2.333h-6v16.912h-2V1.333a1 1 0 011-1h8z",
    className: "primary"
  })));
};

IconSupportXL.displayName = 'IconSupportXL';
IconSupportXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSupportXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconSwissArmyKnifeXL = function IconSwissArmyKnifeXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M11 50a4 4 0 110 8 4 4 0 010-8zm42 0a4 4 0 110 8 4 4 0 010-8zm-42 2a2 2 0 100 4 2 2 0 000-4zm42 0a2 2 0 100 4 2 2 0 000-4zM19 16v12h-3c-1.648 0-3 1.352-3 3s1.352 3 3 3h3v12h-2V36h-1c-2.752 0-5-2.248-5-5s2.248-5 5-5h1v-8H3v36H1V16h18zM63 1v53h-2V3.033c-7.787.52-14 7.055-14 14.967v28h-2V18c0-9.352 7.648-17 17-17h1z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M54 45c4.952 0 9 4.048 9 9s-4.048 9-9 9H10c-4.952 0-9-4.048-9-9s4.048-9 9-9h44zm0 2H10c-3.848 0-7 3.152-7 7s3.152 7 7 7h44c3.848 0 7-3.152 7-7s-3.152-7-7-7zm-9-7v2H19v-2h26zm10-23v21h-2V17h2z",
    className: "secondary"
  })));
};

IconSwissArmyKnifeXL.displayName = 'IconSwissArmyKnifeXL';
IconSwissArmyKnifeXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSwissArmyKnifeXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconSwitchesXL = function IconSwitchesXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M26 45a1 1 0 011 1v16a1 1 0 01-1 1H16a1 1 0 01-1-1v-7H2v-2h13v-7a1 1 0 011-1h10zm-1 2h-8v14h8V47zm37 6v2H34v-2h28zM26 1a1 1 0 011 1v16a1 1 0 01-1 1H16a1 1 0 01-1-1v-7H2V9h13V2a1 1 0 011-1h10zm-1 2h-8v14h8V3zm37 6v2H34V9h28z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M48 23a1 1 0 011 1v16a1 1 0 01-1 1H38a1 1 0 01-1-1v-7H2v-2h35v-7a1 1 0 011-1h10zm-1 2h-8v14h8V25zm15 6v2h-6v-2h6z",
    className: "primary"
  })));
};

IconSwitchesXL.displayName = 'IconSwitchesXL';
IconSwitchesXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconSwitchesXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconTCOXL = function IconTCOXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M33 12v5.03c3.532.123 7.287.954 9.461 2.083l-.922 1.774c-1.884-.978-5.313-1.733-8.54-1.855v12.105l.24.076c2.948.934 4.355 1.488 5.727 2.378 1.993 1.292 3.068 3 3.068 5.274 0 4.527-2.93 7.143-7.792 7.832-.402.057-.816.1-1.242.13V52h-2v-5.123c-3.236-.06-6.88-.752-10.289-1.915l.646-1.892C24.569 44.165 28 44.816 31 44.877l-.002-12.275c-2.873-.923-4.428-1.572-5.874-2.574-2.13-1.474-3.272-3.437-3.272-6.045 0-4.325 3.45-6.574 8.805-6.923l.342-.019L31 12h2zm0 21.237v11.585c.33-.026.65-.061.962-.105 3.962-.562 6.072-2.445 6.072-5.852 0-2.674-1.723-3.906-7.034-5.628zm-2.213-14.181c-4.437.29-6.935 1.918-6.935 4.927 0 3.217 1.871 4.737 7.147 6.512V19.043l-.212.013z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M32 3c10.612 0 20.356 6.016 25.454 15.173l1.899-4.736 1.856.744-2.72 6.781a1 1 0 01-1.06.62l-7.832-1.05.266-1.982 5.955.797C51.098 10.698 41.948 5 32 5 17.088 5 5 17.088 5 32s12.088 27 27 27 27-12.088 27-27h2c0 16.016-12.984 29-29 29S3 48.016 3 32 15.984 3 32 3z",
    className: "secondary"
  })));
};

IconTCOXL.displayName = 'IconTCOXL';
IconTCOXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTCOXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconTermsL = function IconTermsL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M38 7v40H4V7h34zm-2 2H6v36h30V9zm8-8v42h-2V3H8V1h36z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M22 33v2H12v-2h10zm8-8v2H12v-2h18zm0-8v2H12v-2h18z",
    className: "primary"
  })));
};

IconTermsL.displayName = 'IconTermsL';
IconTermsL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTermsL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconTestdriveL = function IconTestdriveL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    stroke: primary || '#28A730',
    strokeWidth: "2",
    d: "M25.552 13.909a1.552 1.552 0 11-3.103.001 1.552 1.552 0 013.103-.001zM25.552 23.224a1.552 1.552 0 11-3.104 0 1.552 1.552 0 013.104 0zM25.552 32.538a1.552 1.552 0 11-3.103.002 1.552 1.552 0 013.103-.002zM25.552 41.853a1.552 1.552 0 11-3.103.002 1.552 1.552 0 013.103-.002zM36.112 9.252s.363 2.514 2.179 2.514h8.22M12.002 18.566s-.367-2.514-2.202-2.514H1.49M12.002 27.88s-.367-2.512-2.202-2.512H1.49M12.002 37.196s-.367-2.514-2.202-2.514H1.49M12.002 46.51s-.367-2.514-2.202-2.514H2.035M36.112 18.566s.363 2.515 2.179 2.515h8.22M36.112 27.88s.363 2.515 2.179 2.515h8.22M36.112 37.196s.363 2.514 2.179 2.514h8.22"
  }), React.createElement("path", {
    stroke: secondary || '#00755B',
    strokeWidth: "2",
    d: "M1.49 18.566h45.02V9.252H1.49zM1.49 9.252l9.213-7.762h26.594l9.214 7.762M1.49 18.566v9.315h45.02v-9.315"
  }), React.createElement("path", {
    stroke: secondary || '#00755B',
    strokeWidth: "2",
    d: "M1.49 27.88v9.316h45.02v-9.315M46.51 37.196v6.21c0 1.713-1.374 3.105-3.071 3.105H4.56c-1.697 0-3.071-1.392-3.071-3.105v-6.21"
  })));
};

IconTestdriveL.displayName = 'IconTestdriveL';
IconTestdriveL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTestdriveL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconTickL = function IconTickL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 47C11.297 47 1 36.703 1 24S11.297 1 24 1s23 10.297 23 23-10.297 23-23 23zm0-2c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M36 14.586L37.414 16 20 33.414 10.586 24 12 22.586l8 8z",
    className: "primary"
  })));
};

IconTickL.displayName = 'IconTickL';
IconTickL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTickL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconTickS = function IconTickS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M6.346 10.405L13.026 4l.974.934-7.167 6.872a.71.71 0 01-.974 0L2 8.106l.975-.934 3.371 3.233z",
    className: "primary"
  }));
};

IconTickS.displayName = 'IconTickS';
IconTickS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTickS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconTickSoloL = function IconTickSoloL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M19.058 33.057L8.7 22.865 7.3 24.291l11.066 10.89a1 1 0 001.411-.008L40.09 14.704l-1.42-1.408-19.611 19.761z",
    className: "primary"
  }));
};

IconTickSoloL.displayName = 'IconTickSoloL';
IconTickSoloL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTickSoloL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconTickSoloM = function IconTickSoloM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M9.6 14.986l9.693-9.693 1.414 1.414-10.4 10.4a1 1 0 01-1.414 0l-5.6-5.6 1.414-1.414L9.6 14.986z",
    className: "primary"
  }));
};

IconTickSoloM.displayName = 'IconTickSoloM';
IconTickSoloM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTickSoloM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconTickSoloXL = function IconTickSoloXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M11.701 29.882L10.3 31.307l14.796 14.56a1 1 0 001.407-.005L53.72 18.708l-1.413-1.416-26.516 26.454-14.09-13.864z",
    className: "primary"
  }));
};

IconTickSoloXL.displayName = 'IconTickSoloXL';
IconTickSoloXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTickSoloXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconTickXL = function IconTickXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M25.357 39.943l19.294-18.007 1.365 1.462-20 18.666a1 1 0 01-1.39-.024l-6.666-6.666 1.414-1.414 5.983 5.983z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M61.667 32C61.667 15.615 48.383 2.333 32 2.333 15.612 2.333 2.333 15.613 2.333 32S15.612 61.667 32 61.667c16.383 0 29.667-13.282 29.667-29.667zm2 0c0 17.49-14.18 31.667-31.667 31.667C14.507 63.667.333 49.492.333 32S14.507.333 32 .333C49.487.333 63.667 14.511 63.667 32z",
    className: "secondary"
  })));
};

IconTickXL.displayName = 'IconTickXL';
IconTickXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTickXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconTimeM = function IconTimeM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm1 3v6h6v2h-8V5h2z",
    className: "primary"
  }));
};

IconTimeM.displayName = 'IconTimeM';
IconTimeM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTimeM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconTimeS = function IconTimeS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm1 2v3h3v2H7V4h2z",
    className: "primary"
  }));
};

IconTimeS.displayName = 'IconTimeS';
IconTimeS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTimeS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconTrashM = function IconTrashM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M5 8v13h14V8h2v14a1 1 0 01-1 1H4a1 1 0 01-1-1V8h2zm8 3v6h-2v-6h2zm-4 0v6H7v-6h2zm8 0v6h-2v-6h2zM16 1a1 1 0 011 1v3h6v2H1V5h6V2a1 1 0 011-1h8zm-1 2H9v2h6V3z",
    className: "primary"
  }));
};

IconTrashM.displayName = 'IconTrashM';
IconTrashM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTrashM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconTrashS = function IconTrashS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M5 7h2v6H5zM9 7h2v6H9z",
    className: "primary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M12 1c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v2H0v2h1v10c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V5h1V3h-4V1zM6 2h4v1H6V2zm7 3v9H3V5h10z",
    className: "primary"
  })));
};

IconTrashS.displayName = 'IconTrashS';
IconTrashS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTrashS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconTrashXL = function IconTrashXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M53 18v38a4 4 0 01-4 4H15a4 4 0 01-4-4V18H9v38a6 6 0 006 6h34a6 6 0 006-6V18h-2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M31 26v24h2V26zM21 26v24h2V26zM41 26v24h2V26zM23 4h18v10h2V2H21v12h2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M61 12H3v2h58z",
    className: "primary"
  })));
};

IconTrashXL.displayName = 'IconTrashXL';
IconTrashXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTrashXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconTravelM = function IconTravelM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#090B0D",
    d: "M3.249.878A3 3 0 017.034.504l6.439 4.292 2.7-2.698a4 4 0 115.656 5.657l-2.699 2.698 4.292 6.439a3 3 0 01-.242 3.645l-.133.141-3.238 3.239-5.657-8.486-2.102 2.101-.172.138-3.131 1.981.25 3.196c.071.926-1.048 1.44-1.704.784L5.43 21.752l-1.393.882C2.25 23.706.22 21.676 1.304 19.87l.869-1.373-1.878-1.864c-.628-.629-.182-1.683.67-1.707l.114.003 3.196.249 1.981-3.13.138-.172 2.1-2.101L.01 4.117zm14.337 2.634l-9.7 9.7-4.88 7.708-.02.012 7.729-4.893 9.7-9.698a2 2 0 10-2.829-2.829zm.102 8.383l-2.094 2.094 4.526 6.788 1.513-1.513a1 1 0 00.125-1.262l-4.07-6.107zM5.924 2.168a1 1 0 00-1.262.125L3.15 3.807l6.788 4.525 2.093-2.093z"
  })));
};

IconTravelM.displayName = 'IconTravelM';
IconTravelM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTravelM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconTrialPayL = function IconTrialPayL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    fillRule: "nonzero",
    d: "M6.26 4a1 1 0 110 2H2l-.001 5H36V6h-4.26a1 1 0 010-2H37a1 1 0 011 1v21h7a3 3 0 013 3v14a3 3 0 01-3 3H27a3 3 0 01-3-3v-7.001L1 36a1 1 0 01-1-1V5a1 1 0 011-1h5.26zM45 28H27a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V29a1 1 0 00-1-1zm-9-15H1.999L2 34h22v-5c0-.516.107-1.082.417-1.624C24.91 26.515 25.795 26 27 26h9V13zM26 4a1 1 0 010 2H12a1 1 0 010-2h14z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "nonzero",
    d: "M34 39a1 1 0 010 2h-5a1 1 0 010-2h5zm9 0a1 1 0 010 2h-1a1 1 0 010-2h1zm4-5a1 1 0 010 2H25a1 1 0 010-2h22zm0-4a1 1 0 010 2H25a1 1 0 010-2h22zM12 1a1 1 0 011 1v6a1 1 0 01-1 1H7a1 1 0 01-1-1V2a1 1 0 011-1h5zm19 0a1 1 0 011 1v6a1 1 0 01-1 1h-5a1 1 0 01-1-1V2a1 1 0 011-1h5zM11 3H8v4h3V3zm19 0h-3v4h3V3z",
    className: "primary"
  })));
};

IconTrialPayL.displayName = 'IconTrialPayL';
IconTrialPayL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTrialPayL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconTrophyXL = function IconTrophyXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32.897 12.557l2.24 4.538 5.007.727a1 1 0 01.554 1.706l-3.624 3.532.856 4.988a1 1 0 01-1.451 1.054L32 26.748l-4.479 2.354a1 1 0 01-1.45-1.054l.855-4.988-3.624-3.532a1 1 0 01.554-1.706l5.008-.727 2.24-4.538a1 1 0 011.793 0zM14 7v2H5v9a7 7 0 007 7h2.115v2H12a9 9 0 01-9-9V8a1 1 0 011-1h10zm46 0a1 1 0 011 1v10a9 9 0 01-9 9h-2.115v-2H52a7 7 0 007-7V9h-9V7h10zm-28 8.26l-1.575 3.192a1 1 0 01-.753.547l-3.523.511 2.549 2.485a1 1 0 01.288.885l-.602 3.51 3.15-1.657a1 1 0 01.931 0l3.151 1.656-.602-3.509a1 1 0 01.288-.885l2.549-2.485L34.328 19a1 1 0 01-.753-.547L32 15.26z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M50 3a1 1 0 011 1v20c0 10.158-7.971 18.454-18 18.974V51h5a9 9 0 019 9 1 1 0 01-1 1H18a1 1 0 01-1-1 9 9 0 019-9h5v-8.026C20.973 42.454 13 34.158 13 24V4a1 1 0 011-1h36zM38 53H26a7.002 7.002 0 00-6.93 6h25.86A7.002 7.002 0 0038 53zM49 5H15v19c0 9.389 7.611 17 17 17s17-7.611 17-17V5z",
    className: "secondary"
  })));
};

IconTrophyXL.displayName = 'IconTrophyXL';
IconTrophyXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTrophyXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconTuneupM = function IconTuneupM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M19.294.38a1 1 0 01.313 1.627L17.314 4.3 19.4 6.386l2.293-2.293a1 1 0 011.635.336c.472 1.18.503 2.491.13 3.858-.652 2.172-2.31 3.84-4.489 4.47l3.438 3.436a4.501 4.501 0 010 6.414 4.501 4.501 0 01-6.414 0l-4.676-4.675-3.536 3.993c-1.579 1.973-4.473 2.097-6.288.282-1.706-1.706-1.584-4.559.244-6.256l6.63-5.87L6.23 7.945l-1.514.504a1 1 0 01-1.023-.242l-2.8-2.8a1 1 0 010-1.414l2.8-2.8a1 1 0 011.414 0l2.8 2.8a1 1 0 01.242 1.023L7.643 6.53l2.223 2.223.983-.87a5.126 5.126 0 01-.148-1.249C10.583 3.221 13.268.243 16.576.008c.968-.121 1.848 0 2.718.373zm-3.456 12.446l-3.193 3.606 4.762 4.76a2.501 2.501 0 003.586 0 2.501 2.501 0 000-3.585l-4.705-4.705a5.97 5.97 0 01-.45-.076zm.953-10.83l-.02.001C14.482 2.161 12.62 4.23 12.7 6.6c0 .461.071.836.228 1.229a1 1 0 01-.265 1.12L3.08 17.433c-.995.924-1.061 2.471-.173 3.36.98.98 2.486.915 3.344-.156l8.5-9.6a1 1 0 011.065-.286c.657.22 1.355.257 2.288.168 1.626-.325 2.941-1.55 3.431-3.182.076-.278.128-.55.155-.813l-1.583 1.583a1 1 0 01-1.414 0l-3.5-3.5a1 1 0 010-1.414l1.598-1.598zM4.4 3.313L3.014 4.7 4.67 6.356l1.04-.347.346-1.039L4.4 3.314z",
    className: "primary"
  }));
};

IconTuneupM.displayName = 'IconTuneupM';
IconTuneupM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTuneupM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconTwitterM = function IconTwitterM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: "#090B0D",
    fillRule: "evenodd",
    d: "M24 4.6c-.9.4-1.8.7-2.8.8 1-.6 1.8-1.6 2.2-2.7-1 .6-2 1-3.1 1.2-.9-1-2.2-1.6-3.6-1.6-2.7 0-4.9 2.2-4.9 4.9 0 .4 0 .8.1 1.1-4.2-.2-7.8-2.2-10.2-5.2-.5.8-.7 1.6-.7 2.5 0 1.7.9 3.2 2.2 4.1-.8 0-1.6-.2-2.2-.6v.1c0 2.4 1.7 4.4 3.9 4.8-.4.1-.8.2-1.3.2-.3 0-.6 0-.9-.1.6 2 2.4 3.4 4.6 3.4-1.7 1.3-3.8 2.1-6.1 2.1-.4 0-.8 0-1.2-.1 2.2 1.4 4.8 2.2 7.5 2.2 9.1 0 14-7.5 14-14v-.6c1-.7 1.8-1.6 2.5-2.5z"
  }));
};

IconTwitterM.displayName = 'IconTwitterM';
IconTwitterM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconTwitterM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconUnlockL = function IconUnlockL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M24 1c6.052 0 11 4.948 11 11h-2c0-4.948-4.052-9-9-9s-9 4.052-9 9v5h26v30H7V17h6v-5c0-6.052 4.948-11 11-11zm15 18H9v26h30V19z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M24 25a5 5 0 011.001 9.9L25 39h-2v-4.1a5.002 5.002 0 011-9.9zm0 2a3 3 0 100 6 3 3 0 000-6z",
    className: "primary"
  })));
};

IconUnlockL.displayName = 'IconUnlockL';
IconUnlockL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUnlockL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconUnlockM = function IconUnlockM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12 0a6.053 6.053 0 015.514 3.594l-1.828.812A4.053 4.053 0 0012 2C9.752 2 8 3.752 8 6v2h12a1 1 0 011 1v14a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1h2V6c0-3.352 2.648-6 6-6zm7 10H5v12h14V10zm-7 2a3 3 0 011 5.829V20h-2v-2.17A3.001 3.001 0 0112 12zm0 2a1 1 0 100 2 1 1 0 000-2z",
    className: "primary"
  }));
};

IconUnlockM.displayName = 'IconUnlockM';
IconUnlockM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUnlockM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconUnlockS = function IconUnlockS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M1 15c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1H6V4c0-1.1.9-2 2-2 .6 0 1.1.2 1.5.7l.7.7 1.5-1.3-.7-.8C10.2.5 9.1 0 8 0 5.8 0 4 1.8 4 4v1H2c-.6 0-1 .4-1 1v9zm7-7c1.1 0 2 .9 2 2 0 .7-.4 1.4-1 1.7V13H7v-1.3c-.6-.3-1-1-1-1.7 0-1.1.9-2 2-2z",
    className: "primary"
  }));
};

IconUnlockS.displayName = 'IconUnlockS';
IconUnlockS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUnlockS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconUnlockXL = function IconUnlockXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32 35a7 7 0 011.001 13.929L33 55h-2v-6.07A7.002 7.002 0 0132 35zm0 2a5 5 0 100 10 5 5 0 000-10zm0-36c7.18 0 13 5.82 13 13v1h-2v-1c0-6.075-4.925-11-11-11S21 7.925 21 14v13h-2V14c0-7.18 5.82-13 13-13z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M57 63H7V27h50v36zm-2-2V29H9v32h46z",
    className: "secondary"
  })));
};

IconUnlockXL.displayName = 'IconUnlockXL';
IconUnlockXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUnlockXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconUpdateL = function IconUpdateL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M45 24c0 11.552-9.448 21-21 21-7.995 0-15.236-4.544-18.792-11.547l1.784-.906C10.21 38.886 16.766 43 24 43c10.448 0 19-8.552 19-19h2zM24 3c7.995 0 15.236 4.544 18.792 11.547l-1.784.906C37.79 9.114 31.234 5 24 5 13.552 5 5 13.552 5 24H3C3 12.448 12.448 3 24 3z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M5.142 31.676l13.882 1.866-.266 1.982-11.9-1.6-1.6 11.9-1.982-.266 1.866-13.882zm37.6-29.5l1.982.266-1.866 13.882-13.882-1.866.266-1.982 11.9 1.6 1.6-11.9z",
    className: "primary"
  })));
};

IconUpdateL.displayName = 'IconUpdateL';
IconUpdateL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUpdateL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconUpdateM = function IconUpdateM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M2.164 15.014l6 1a1 1 0 01.543 1.693l-1.749 1.75a9.004 9.004 0 0013.862-5.656l1.96.398a11.004 11.004 0 01-17.258 6.693l-1.815 1.815a.985.985 0 01-.594.288l-.106.006a.998.998 0 01-.993-.837l-1-6a1 1 0 011.15-1.15zm1.053 2.203l.45 2.702 2.252-2.252-2.702-.45zm18.77-15.381l1 6a1 1 0 01-.917 1.162L21.954 9a1.026 1.026 0 01-.118-.013l-6-1a1 1 0 01-.543-1.693l1.75-1.75A9.003 9.003 0 003.18 10.199l-1.96-.397a11.003 11.003 0 0117.258-6.693l1.815-1.815a1 1 0 011.693.543zM20.332 4.08l-2.252 2.252 2.702.45-.45-2.702z",
    className: "primary"
  }));
};

IconUpdateM.displayName = 'IconUpdateM';
IconUpdateM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUpdateM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconUpdateS = function IconUpdateS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12.93 8.835l1.973.331A6.975 6.975 0 018 15a7.014 7.014 0 01-4.625-1.75l-1.93 1.93-.539-6.211 6.211.539-2.322 2.322A5.004 5.004 0 008 13a4.98 4.98 0 004.93-4.165zM14.555.82l.539 6.211-6.211-.539 2.322-2.322A5.004 5.004 0 008 3a4.98 4.98 0 00-4.93 4.165l-1.973-.331A6.975 6.975 0 018 1c1.71 0 3.353.632 4.625 1.75l1.93-1.93z",
    className: "primary"
  }));
};

IconUpdateS.displayName = 'IconUpdateS';
IconUpdateS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUpdateS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconUploadL = function IconUploadL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M47 45H1v2h46z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M24.014 1l16.264 16.263-1.415 1.415L25 4.815v30.524h-2V4.84L9.164 18.678 7.75 17.263 24.013 1h.001z",
    className: "primary"
  })));
};

IconUploadL.displayName = 'IconUploadL';
IconUploadL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUploadL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconUploadM = function IconUploadM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M12 .586L19.414 8 18 9.414l-5-5V17h-2V4.414l-5 5L4.586 8 12 .586z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M23 21H1v2h22z",
    className: "secondary"
  })));
};

IconUploadM.displayName = 'IconUploadM';
IconUploadM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUploadM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconUploadS = function IconUploadS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M16 14v2H0v-2h16zM8 0l5.5 5.42-1.05 1.034-3.709-3.656V12H7.259V2.798L3.549 6.454 2.5 5.42 8 0z",
    className: "primary"
  }));
};

IconUploadS.displayName = 'IconUploadS';
IconUploadS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUploadS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var IconUploadXL = function IconUploadXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M63 60H1v2h62z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32.002 2.632l19.879 20.166-1.425 1.404L32.995 6.489V47.5h-2V6.455L13.161 24.209 11.75 22.79l20.252-20.16z",
    className: "primary"
  })));
};

IconUploadXL.displayName = 'IconUploadXL';
IconUploadXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUploadXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconUserbaseXL = function IconUserbaseXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M14 53c4.198 0 7.724 1.058 10.542 2.725A5 5 0 0127 60.035V62a1 1 0 01-1 1H2a1 1 0 01-1-1v-1.987c0-1.765.922-3.392 2.435-4.297C6.223 54.052 9.748 53 14 53zm36 0c4.198 0 7.724 1.058 10.542 2.725A5 5 0 0163 60.035V62a1 1 0 01-1 1H38a1 1 0 01-1-1v-1.987c0-1.765.922-3.392 2.435-4.297C42.223 54.052 45.748 53 50 53zm-36 2c-3.875 0-7.05.948-9.54 2.433A2.996 2.996 0 003 60.013V61h22v-.965a3 3 0 00-1.476-2.588C21 55.954 17.822 55 14 55zm36 0c-3.875 0-7.05.948-9.54 2.433a2.996 2.996 0 00-1.46 2.58V61h22v-.965a3 3 0 00-1.476-2.588C57 55.954 53.822 55 50 55zm0-20a7 7 0 110 14 7 7 0 010-14zm-36 0a7 7 0 110 14 7 7 0 010-14zm36 2a5 5 0 100 10 5 5 0 000-10zm-36 0a5 5 0 100 10 5 5 0 000-10z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M32 19c4.198 0 7.724 1.058 10.542 2.725A5 5 0 0145 26.035V28a1 1 0 01-1 1H20a1 1 0 01-1-1v-1.987c0-1.765.922-3.392 2.435-4.297C24.223 20.052 27.748 19 32 19zm0 2c-3.875 0-7.05.948-9.54 2.433a2.996 2.996 0 00-1.46 2.58V27h22v-.965a3 3 0 00-1.476-2.588C39 21.954 35.822 21 32 21zm0-20a7 7 0 110 14 7 7 0 010-14zm0 2a5 5 0 100 10 5 5 0 000-10z",
    className: "primary"
  })));
};

IconUserbaseXL.displayName = 'IconUserbaseXL';
IconUserbaseXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUserbaseXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconUsersL = function IconUsersL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M12 17c1.772 0 3.385.931 4.283 2.42l-1.712 1.034A2.998 2.998 0 0012 19H6a3 3 0 00-3 3v8.28l2.316.771a1 1 0 01.68.858L6.913 42H12v2H6a1 1 0 01-.996-.91l-.94-10.348-2.38-.793A1 1 0 011 31v-9a5 5 0 015-5h6zm30 0a5 5 0 015 5v9a1 1 0 01-.684.949l-2.38.793-.94 10.349A1 1 0 0142 44h-6v-2h5.087l.917-10.09a1 1 0 01.68-.859L45 30.28V22a3 3 0 00-3-3h-6c-1.064 0-2.03.558-2.57 1.454l-1.713-1.034A4.998 4.998 0 0136 17h6zM9 4a5 5 0 110 10A5 5 0 019 4zm30 0a5 5 0 110 10 5 5 0 010-10zM9 6a3 3 0 100 6 3 3 0 000-6zm30 0a3 3 0 100 6 3 3 0 000-6z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M30 20c2.745 0 5 2.088 5 4.704v9.259a1 1 0 01-.774.974l-3.295.763-.935 10.39A1 1 0 0129 47H19a1 1 0 01-.996-.91l-.935-10.39-3.295-.763a1 1 0 01-.774-.974v-9.26C13 22.089 15.255 20 18 20h12zm0 2H18c-1.673 0-3 1.229-3 2.704v8.464l3.226.747a1 1 0 01.77.884L19.914 45h8.172l.918-10.2a1 1 0 01.77-.885L33 33.168v-8.464C33 23.229 31.673 22 30 22zM24 1a7 7 0 110 14 7 7 0 110-14zm0 2a5 5 0 100 10 5 5 0 000-10z",
    className: "primary"
  })));
};

IconUsersL.displayName = 'IconUsersL';
IconUsersL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconUsersL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconVendorLockinL = function IconVendorLockinL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M43 12a1 1 0 011 1v22.5a1 1 0 01-2 0V14H22v9a1 1 0 01-1 1h-3v18.25c0 1.326.965 2.437 2.254 2.694l.112-.027a4.66 4.66 0 001.091-.408c.902-.483 1.4-1.185 1.4-2.259V40a1 1 0 011-1H47a1 1 0 011 1v2.25c0 2.63-2.18 4.75-4.857 4.75H20.824l-.042-.001h-.879c-.303 0-.534-.106-.692-.27C17.342 46.076 16 44.32 16 42.25V23a1 1 0 011-1h3v-9a1 1 0 011-1h22zm3 29H24.857v1.25c0 1.102-.326 2.018-.901 2.75h19.187C44.727 45 46 43.763 46 42.25V41zM13 12a3 3 0 011 5.829V19a1 1 0 01-2 0v-1.17A3.001 3.001 0 0113 12zm0 2a1 1 0 100 2 1 1 0 000-2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M35 32a1 1 0 010 2H25a1 1 0 010-2h10zm0-6a1 1 0 010 2H25a1 1 0 010-2h10zM13 0a6.053 6.053 0 015.514 3.594 1 1 0 01-1.828.812A4.053 4.053 0 0013 2c-2.248 0-4 1.752-4 4v2h12a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V9a1 1 0 011-1h2V6c0-3.352 2.648-6 6-6zm22 20a1 1 0 010 2H25a1 1 0 010-2h10zM20 10H6v12h14V10z",
    className: "primary"
  })));
};

IconVendorLockinL.displayName = 'IconVendorLockinL';
IconVendorLockinL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconVendorLockinL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconVendorLockinXL = function IconVendorLockinXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M19 23.12V57a4 4 0 003.95 4l-.05.005c.111-.011.338-.048.639-.124a6.207 6.207 0 001.48-.57C26.28 59.617 27 58.574 27 57v-3h32v3a6 6 0 01-6 6H23a6 6 0 01-6-6V23.12h2zM57 56H29v1c0 1.674-.58 3.003-1.58 4H53a4 4 0 004-4v-1zm-4-39v34h-2V19H23.006v-2H53zm-38-4a3 3 0 011 5.83V21h-2v-2.17A3.001 3.001 0 0115 13zm0 2a1 1 0 100 2 1 1 0 000-2zm.003-14a6.053 6.053 0 015.51 3.594l-1.827.812A4.055 4.055 0 0014.99 3 3.951 3.951 0 0011 7v3H9V7.01A5.951 5.951 0 0115.003 1z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M45 43v2H25v-2h20zm0-8v2H25v-2h20zm0-8v2H25v-2h20zM25 9v16H5V9h20zm-2 2H7v12h16V11z",
    className: "primary"
  })));
};

IconVendorLockinXL.displayName = 'IconVendorLockinXL';
IconVendorLockinXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconVendorLockinXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconVideoL = function IconVideoL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M18 14.21L33.908 24 18 33.79V14.21zm2 3.58v12.42L30.092 24 20 17.79z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M6 5h36a5 5 0 015 5v28a5 5 0 01-5 5H6a5 5 0 01-5-5V10a5 5 0 015-5zm0 2a3 3 0 00-3 3v28a3 3 0 003 3h36a3 3 0 003-3V10a3 3 0 00-3-3H6z",
    className: "primary"
  })));
};

IconVideoL.displayName = 'IconVideoL';
IconVideoL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconVideoL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconVideoM = function IconVideoM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M21 1a3 3 0 013 3v16a3 3 0 01-3 3H3a3 3 0 01-3-3V4a3 3 0 013-3h18zm0 2H3a1 1 0 00-1 1v16a1 1 0 001 1h18a1 1 0 001-1V4a1 1 0 00-1-1z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M9 6.131L17.803 12 9 17.869V6.13zm2 3.738v4.262L14.197 12 11 9.869z",
    className: "secondary"
  })));
};

IconVideoM.displayName = 'IconVideoM';
IconVideoM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconVideoM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconWalletL = function IconWalletL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M10 5v2H6a3 3 0 000 6v2A5 5 0 016 5h4z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M11 3v11H9V2a1 1 0 011-1h28a1 1 0 011 1v12h-2V3H11z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M1 10c0-1.333 2-1.333 2 0a3 3 0 003 3h36a1 1 0 011 1v11.999h-2V15H6a4.978 4.978 0 01-3-1v26a5 5 0 005 5h33V34h2v12a1 1 0 01-1 1H8a7 7 0 01-7-7V10z",
    className: "secondary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M45 33v-6h-8a3 3 0 000 6h8zm1 2h-9a5 5 0 010-10h9a1 1 0 011 1v8a1 1 0 01-1 1z",
    className: "secondary"
  })));
};

IconWalletL.displayName = 'IconWalletL';
IconWalletL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconWalletL.defaultProps = {
  width: 48,
  height: 48,
  theme: {}
};

var IconWebsiteXL = function IconWebsiteXL(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary,
      secondary = theme.secondary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: primary || '#28A730',
    d: "M11 32v14h14V32H11zm16-2v18H9V30h18z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M32 32v-2h23v2zM32 40v-2h23v2zM32 48v-2h14v2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: primary || '#28A730',
    d: "M9 14v-2h6v2zM19 14v-2h6v2zM42 14v-2h13v2z",
    className: "primary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M1 21v-2h62v2z",
    className: "secondary"
  }), React.createElement("path", {
    fill: secondary || '#00755B',
    d: "M3 7v50h58V7H3zm60-2v54H1V5h62z",
    className: "secondary"
  })));
};

IconWebsiteXL.displayName = 'IconWebsiteXL';
IconWebsiteXL.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconWebsiteXL.defaultProps = {
  width: 64,
  height: 64,
  theme: {}
};

var IconWorldM = function IconWorldM(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm-1.99 2.2l-.19.038a9.93 9.93 0 00-2.466.904c.353.393.674.838.976 1.344 1.052 1.762 1.543 3.727.461 5.126-.431.558-.987.943-1.913 1.417l-.975.484-.319.166a3.75 3.75 0 00-.437.272l-.12.095a.06.06 0 01-.014.008l-.001.017c.026.088.097.214.229.398l.153.203.093.117.222.27.591.69.128.157c.154.19.284.363.4.533 1.14 1.684.985 3.475.03 5.073a4.07 4.07 0 01-.544.714A9.943 9.943 0 0012 22c5.523 0 10-4.477 10-10a9.953 9.953 0 00-1.668-5.531c-.263.11-.539.217-.822.321l-.58.207c-.292.1-.586.197-.876.287l-.571.173-.548.154a25.02 25.02 0 01-.262.07l-.49.12a8.004 8.004 0 01-1.111.196c-.962.07-1.6-.336-2.13-1.151l-.594-1-.183-.296-.097-.14-.172-.218-.741-.862-.183-.22-.084-.104c-.52-.656-.824-1.206-.879-1.806zm5.504 6.703c2.444 0 4.47 1.744 4.5 3.986.05 3.655-4.536 8.202-7.392 7.037-1.336-.545-1.647-1.145-1.603-2.823l.017-.424.056-.91a15.02 15.02 0 00-.071-2.75c-.264-2.275 1.96-4.116 4.493-4.116zm-9.85-4.641l-.063.053A9.98 9.98 0 002 12a9.966 9.966 0 002.786 6.925c.146-.14.267-.289.355-.438.593-.991.678-1.972.03-2.926a4.986 4.986 0 00-.184-.254l-.168-.21-.362-.425-.18-.21-.32-.38C3.23 13.197 3 12.733 3 12c0-.987.567-1.522 1.781-2.16l1.144-.57c.694-.355 1.078-.615 1.284-.882.378-.489.054-1.787-.597-2.877a6.32 6.32 0 00-.948-1.249zm9.85 6.641c-1.455 0-2.614.96-2.507 1.885.147 1.262.145 2.23.053 3.56l-.051.812-.008.32c.003.355.065.45.231.531l.146.063c1.324.54 4.669-2.776 4.636-5.158-.014-1.083-1.094-2.013-2.5-2.013zM12 2c0 .097.14.366.455.763l.23.28.77.894.163.204.13.18.144.217.208.34.52.878.098.149c.064.09.093.103.163.1l.105-.009.17-.028.375-.077.311-.073.533-.134.577-.158a25.752 25.752 0 002.042-.673A9.968 9.968 0 0012 2z",
    className: "primary"
  }));
};

IconWorldM.displayName = 'IconWorldM';
IconWorldM.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconWorldM.defaultProps = {
  width: 24,
  height: 24,
  theme: {}
};

var IconWorldS = function IconWorldS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      theme = _ref.theme,
      label = _ref.label;
  var primary = theme.primary;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    "aria-hidden": !label,
    "aria-label": label,
    focusable: "false",
    className: className
  }, React.createElement("path", {
    fill: primary || '#28A730',
    fillRule: "evenodd",
    d: "M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm-.5 2c-1.1.1-2 .5-2.8 1 .7.8 1.4 2.3.7 3.1-.21.28-.58.499-.97.7l-.338.167C3.475 7.271 2.9 7.56 2.9 8c0 .6.8 1.3 1.3 2 .6.8.5 1.8-.1 2.6C5.2 13.5 6.5 14 8 14c3.3 0 6-2.7 6-6 0-1.3-.4-2.5-1-3.5-1 .3-2.8.3-3 .3-.7 0-.8-.5-1.3-1.3-.3-.4-1-1-1.2-1.5zm2.7 4.7c1.3 0 2.2.8 2.2 1.9.1 2-2.5 4.4-3.8 3.9-1.1-.5-.3-1.4-.6-3.9-.1-1.1 1-1.9 2.2-1.9z",
    className: "primary"
  }));
};

IconWorldS.displayName = 'IconWorldS';
IconWorldS.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.object,
  label: PropTypes.string
};
IconWorldS.defaultProps = {
  width: 16,
  height: 16,
  theme: {}
};

var themeGreen = {
  primary: '#28A730',
  secondary: '#00755B',
  tertiary: '#E5F8E6'
};
var themeRed = {
  primary: '#C62838',
  secondary: '#880714',
  tertiary: '#FFDDE0'
};
var themeGrey = {
  primary: '#A5ADB4',
  secondary: '#676A71',
  tertiary: '#D4D8DC'
};
var themeNavy = {
  primary: '#0C314F',
  secondary: '#091E2F',
  tertiary: '#E6EAED'
};
var themeYellow = {
  primary: '#EAC31C',
  secondary: '#B29206',
  tertiary: '#FFF6CE'
};
var themeBlue = {
  primary: '#0E64B1',
  secondary: '#234A83',
  tertiary: '#D4EBFF'
};

export { Icon90daysM, IconAddL, IconAddM, IconAddNodeL, IconAddS, IconAlertM, IconAlertS, IconAlertXL, IconArrowBackM, IconArrowBackS, IconArrowDownS, IconArrowForwardM, IconArrowForwardS, IconArrowUpS, IconBackupL, IconBoxL, IconCalendarL, IconCalendarM, IconCalendarXL, IconCallM, IconCallS, IconCancelL, IconCephL, IconCephM, IconCephXL, IconChatM, IconChatS, IconChatXL, IconChevronDownS, IconChevronLeftL, IconChevronLeftS, IconChevronRightS, IconChevronUpS, IconCloseM, IconCloseS, IconCloseupM, IconCloseupS, IconCoffinXL, IconCoinL, IconCompanyM, IconConfirmM, IconCreateS, IconCrosshairXL, IconCursorM, IconCustomCodeXL, IconDNAXL, IconDeliveryL, IconDeliveryM, IconDensityL, IconDensityM, IconDensityXL, IconDesignXL, IconDocumentL, IconDocumentM, IconDocumentS, IconDownloadL, IconDownloadM, IconDropdownM, IconDropdownS, IconEcoLightbulbXL, IconEditL, IconEditM, IconEditS, IconEditXL, IconElevatorM, IconEmailL, IconEmoticonHappyXL, IconEmploymentM, IconEngineeringXL, IconExpertM, IconEyeOpenM, IconFacebookM, IconFeedbackM, IconFilterM, IconFilterS, IconFlashLEDL, IconFlexibleL, IconGalleryM, IconGatewayS, IconGatewayXL, IconGiftXL, IconGlobeL, IconGridM, IconGridS, IconHDDL, IconHamburgerM, IconHarddriveM, IconHarddriveXL, IconHeartbeatXL, IconHeirarchyXL, IconHelpM, IconHierarchyL, IconHomeM, IconHourglassS, IconImageL, IconImageM, IconInfoM, IconInfoS, IconInteroperabilityL, IconKnowledgeM, IconLaunchM, IconLaunchS, IconLetterboxXL, IconLightBulbXL, IconLinkM, IconLinkXL, IconLinkedinM, IconListM, IconLoadingM, IconLockL, IconLockM, IconLockS, IconLockXL, IconLogoutM, IconLogoutS, IconMagicXL, IconMailM, IconMailS, IconMainboardS, IconMathL, IconMathM, IconMathXL, IconMoneyL, IconMoneyXL, IconMoneybagL, IconMoneybagXL, IconMoonM, IconMoonS, IconNFSL, IconNICXL, IconNetworkL, IconNetworkM, IconNetworkSettingsL, IconNewsM, IconNodeL, IconNodeM, IconNodeS, IconNodeXL, IconNotificationS, IconOptionsM, IconOrgChartM, IconPasswordM, IconPauseL, IconPayGoXL, IconPaymentL, IconPaymentM, IconPeopleM, IconPerformanceL, IconPerformanceM, IconPerformanceXL, IconPhoneL, IconPlaneL, IconPlaneM, IconPlaneS, IconPlaneXL, IconPlayL, IconPlayS, IconPlayXL, IconPowerL, IconPowerS, IconPrinterM, IconPrinterXL, IconQuestionS, IconRebootL, IconRecurringPayL, IconRefreshL, IconRepeatXL, IconResetM, IconResourcesM, IconRocketXL, IconS3L, IconSSDL, IconSSDM, IconSaveConfigXL, IconScaleUpL, IconScrollM, IconScrubS, IconSearchM, IconSearchS, IconSecureL, IconSerialM, IconSettingsAdvancedL, IconSettingsL, IconSettingsM, IconSettingsS, IconSettingsXL, IconShareAddL, IconSharePauseL, IconShareRefreshL, IconShareRemoveL, IconShareSettingsL, IconSharesM, IconShieldXL, IconSoCL, IconSoCM, IconSoCS, IconSortS, IconSpecsL, IconSpecsM, IconStorageL, IconStorageM, IconSubtractM, IconSubtractS, IconSummaryM, IconSunM, IconSunS, IconSupportCallL, IconSupportCallM, IconSupportL, IconSupportM, IconSupportXL, IconSwissArmyKnifeXL, IconSwitchesXL, IconTCOXL, IconTermsL, IconTestdriveL, IconTickL, IconTickS, IconTickSoloL, IconTickSoloM, IconTickSoloXL, IconTickXL, IconTimeM, IconTimeS, IconTrashM, IconTrashS, IconTrashXL, IconTravelM, IconTrialPayL, IconTrophyXL, IconTuneupM, IconTwitterM, IconUnlockL, IconUnlockM, IconUnlockS, IconUnlockXL, IconUpdateL, IconUpdateM, IconUpdateS, IconUploadL, IconUploadM, IconUploadS, IconUploadXL, IconUserbaseXL, IconUsersL, IconVendorLockinL, IconVendorLockinXL, IconVideoL, IconVideoM, IconWalletL, IconWebsiteXL, IconWorldM, IconWorldS, themeBlue, themeGreen, themeGrey, themeNavy, themeRed, themeYellow };
